export const resources = {
  fr: {
    translation: {
      apiKeys: {
        navLabel: "Clés d'Agent",
        agentPageTitle: "Clés d'Agent",
        agentPageDescription:
          "Une clé d'Agent appelle les Workflows de cet Agent par la route Agent. Elle ne donne accès à aucun autre Agent.",
        selectAgentFirst: "Choisissez un Agent pour gérer ses clés.",
        applicationIntro:
          "Une clé d'Application appelle les Workflows publiés dans cette Application. Donnez-lui seulement les droits nécessaires.",
        createTitle: "Nouvelle clé",
        createButton: "Créer une clé API",
        nameLabel: "Nom",
        namePlaceholder: "Ex. : intégration CRM",
        scopesLabel: "Droits",
        scopesRequired: "Choisissez au moins un droit.",
        scope: {
          surface_read: "Lire la surface publiée",
          surface_execute: "Exécuter les Workflows publiés",
          chat_session: "Ouvrir des conversations",
          viewer_session: "Ouvrir le Viewer",
        },
        expirationLabel: "Expiration",
        expiration30: "Dans 30 jours",
        expiration90: "Dans 90 jours",
        expiration365: "Dans un an",
        expirationNever: "Jamais",
        expirationCustom: "Date précise",
        expirationDateLabel: "Date d'expiration",
        revealedTitle: "Clé « {{name}} » créée",
        revealedWarning:
          "Copiez cette clé maintenant et rangez-la dans un coffre : elle ne sera plus jamais affichée.",
        plaintextLabel: "Clé API",
        copy: "Copier la clé",
        copied: "Clé copiée",
        dismissRevealed: "J'ai rangé la clé",
        listTitle: "Clés existantes",
        empty: "Aucune clé pour l'instant.",
        expiresLabel: "Expire :",
        expiredOn: "expirée le {{date}}",
        noExpiration: "jamais",
        lastUsedLabel: "Dernier usage :",
        neverUsed: "pas encore utilisée",
        revoke: "Révoquer",
        revokeTitle: "Révoquer la clé « {{name}} » ?",
        revokeDescription:
          "Les appels qui utilisent cette clé seront refusés immédiatement. Cette action est définitive.",
        revokeConfirm: "Révoquer la clé",
        revoked: "Clé révoquée",
        revokeFailed: "La révocation a échoué.",
        createFailed: "La création de la clé a échoué.",
        loadFailed: "Impossible de charger les clés.",
        reviewKeysHint:
          "Pour appeler ces Workflows en HTTP, il faut une clé d'Application.",
        manageKeys: "Gérer les clés",
      },
      workflowApi: {
        tabLabel: "API & déclencheurs",
        httpTab: "Appel HTTP",
        triggersTab: "Déclencheurs",
        keyTitle: "Clé requise",
        agentRouteLabel: "Route Agent",
        agentKeyRequirement: "Une clé d'Agent de cet Agent.",
        createAgentKey: "Créer une clé d'Agent",
        applicationRouteLabel: "Route Application",
        applicationKeyRequirement:
          "Une clé d'Application avec le droit « Exécuter les Workflows publiés », et ce Workflow publié dans l'Application.",
        publishedIn: "Publié dans {{name}}.",
        createApplicationKey: "Créer une clé d'Application",
        notPublished: "Ce Workflow n'est publié dans aucune Application.",
        publishInApplication: "Publier dans une Application",
        inputTitle: "Document d'entrée",
        inputFromSchema:
          "Le corps de la requête doit respecter ce schéma ; les exemples ci-dessous en sont dérivés.",
        inputGeneric:
          "Ce Workflow ne déclare pas de schéma d'entrée : les exemples envoient un document vide, à adapter.",
        agentRouteTitle: "Route Agent",
        applicationRouteTitle: "Route Application",
        applicationRouteSyncOnly:
          "La route Application est synchrone : elle attend la fin de l'exécution.",
        applicationSelect: "Application",
        applicationRouteUnavailable:
          "Disponible quand le Workflow est publié dans une Application.",
        schedulesTitle: "Planifications",
        webhookTitle: "Webhook entrant",
        webhook: {
          intro:
            "Un service externe lance ce Workflow publié en appelant une URL unique, signée par HMAC-SHA256 avec un secret affiché une seule fois. Aucune clé d'API n'est nécessaire.",
          needsPublication:
            "Publiez ce Workflow dans une Application pour créer un webhook entrant.",
          createTitle: "Créer un webhook",
          nameLabel: "Nom",
          namePlaceholder: "CRM, formulaire de contact…",
          mappingLabel: "Document d'entrée",
          mappingBody: "Le corps JSON entier",
          mappingPointers: "Champs choisis dans le corps (JSON Pointer)",
          pointersLabel: "Correspondance des champs",
          pointersHint:
            "Une ligne par champ d'entrée : champ = /chemin/dans/le/corps. Un chemin absent laisse le champ absent.",
          pointersInvalid: "Ligne invalide : « {{line}} ». Format attendu : champ = /chemin.",
          responseLabel: "Réponse",
          responseAsync: "Immédiate, avec l'identifiant d'exécution",
          responseSync: "Attendre le résultat (borné)",
          syncTimeoutLabel: "Attente maximale (secondes, 1 à 30)",
          responseAsyncSummary: "immédiate, identifiant d'exécution",
          responseSyncSummary: "attend le résultat, {{seconds}} s au plus",
          rateLimitLabel: "Limite d'appels par minute",
          rateLimitSummary: "{{value}} appels par minute",
          rateLimitHint:
            "De 1 à {{max}} (défaut {{default}}). L'Application reste limitée à 600 appels par minute, tous webhooks confondus.",
          constantsLabel: "Constantes",
          constantsHint:
            "Valeurs fixes ajoutées au document d'entrée à chaque appel. Une valeur JSON (nombre, true, false, texte entre guillemets) garde son type ; sinon c'est du texte.",
          constantKeyPlaceholder: "champ",
          constantValuePlaceholder: "valeur",
          constantKey: "Nom de la constante {{index}}",
          constantValue: "Valeur de la constante {{index}}",
          constantRemove: "Retirer la constante {{index}}",
          constantAdd: "Ajouter une constante",
          constantInvalid:
            "Constante invalide : « {{key}} ». Chaque constante a un nom unique, qui ne commence pas par __context.",
          edit: "Modifier",
          editTitle: "Modifier le webhook « {{name}} »",
          editIntro:
            "L'URL et le secret ne changent pas. Les nouveaux réglages s'appliquent au prochain appel.",
          save: "Enregistrer",
          saved: "Webhook modifié",
          saveFailed: "La modification du webhook a échoué.",
          createButton: "Créer le webhook",
          createFailed: "La création du webhook a échoué.",
          revealedTitle: "Webhook « {{name}} » créé",
          rotatedTitle: "Nouveau secret du webhook « {{name}} »",
          revealedWarning:
            "Copiez le secret maintenant : il ne sera plus jamais affiché. L'ancien secret éventuel reste accepté 24 heures après une rotation.",
          urlLabel: "URL du webhook",
          secretLabel: "Secret",
          curlIntro:
            "Exemple d'appel signé : exportez d'abord le secret dans la variable {{env}}.",
          listTitle: "Webhooks de ce Workflow",
          empty: "Aucun webhook pour ce Workflow.",
          loadFailed: "Impossible de charger les webhooks.",
          unnamed: "Sans nom",
          lastCall: "Dernier appel",
          neverCalled: "Jamais appelé",
          disable: "Désactiver",
          enable: "Réactiver",
          rotate: "Changer le secret",
          revoke: "Révoquer",
          journal: "Journal des appels",
          journalEmpty: "Aucun appel reçu.",
          journalFailed: "Impossible de charger le journal.",
          execution: "exécution {{id}}",
          aggregated: "{{count}} appels regroupés",
          revoked: "Webhook révoqué",
          actionFailed: "L'action a échoué.",
          rotateTitle: "Changer le secret ?",
          rotateDescription:
            "Un nouveau secret est affiché une seule fois. L'ancien reste accepté pendant 24 heures, le temps de mettre à jour le service émetteur.",
          revokeTitle: "Révoquer ce webhook ?",
          revokeDescription:
            "L'URL et les secrets cessent immédiatement de fonctionner. Le journal des appels est conservé. Cette action est définitive.",
          status: {
            active: "Actif",
            disabled: "Désactivé",
            revoked: "Révoqué",
          },
          outcome: {
            accepted: "Accepté",
            duplicate: "Relivraison",
            rejected: "Refusé",
          },
        },
      },
      language: {
        label: "Langue",
        fr: "Français",
        en: "Anglais",
        es: "Espagnol",
      },
      theme: {
        label: "Thème",
        system: "Système",
        light: "Clair",
        dark: "Sombre",
      },
      common: {
        loading: "Chargement…",
        miniappStepDone: "terminée",
        miniappStepCurrent: "en cours",
        miniappStepTodo: "à faire",
        miniappNoData: "Aucune donnée",
        miniappOther: "Autres",
        miniappToneSuccess: "Favorable",
        miniappToneWarning: "À surveiller",
        miniappToneError: "Défavorable",
        miniappDevWarnings: "Avertissements de rendu (mode développement)",
        close: "Fermer",
        cancel: "Annuler",
        create: "Créer",
        save: "Enregistrer",
        edit: "Éditer",
        delete: "Supprimer",
        remove: "Retirer",
        refresh: "Rafraîchir",
        noDescription: "Aucune description fournie.",
        unknown: "Inconnu",
        valid: "Valide",
        invalid: "Invalide",
        preview: "Aperçu",
        hide: "Masquer",
        open: "Ouvrir",
        download: "Télécharger",
        context: "Contexte",
        connecting: "Connexion…",
        active: "actif",
        error: "Erreur",
        copy: "Copier",
        run: "Exécution",
        studio: "Studio",
        build: "Configuration",
        builder: "Builder",
        admin: "Admin",
      },
      integrations: {
        description:
          "Ajoutez les connecteurs utiles à l’Agent courant, configurez leurs accès et exposez leurs tools au runtime AgentMaurice.",
        usageTitle: "Crédits intégrations",
        usageValue: "{{consumed}} / {{budget}} crédits ce mois-ci",
        addedTitle: "Connecteurs ajoutés",
        addedDescription:
          "Seuls les connecteurs ajoutés à l’Agent courant apparaissent ici.",
        addConnector: "Ajouter un connecteur",
        emptyTitle: "Aucun connecteur ajouté",
        emptyDescription:
          "Recherchez un connecteur dans le catalogue pour l’ajouter à l’Agent courant.",
        connectSuccess: "Connecteur connecté.",
        connectError: "Connexion impossible.",
        addSuccess: "Connecteur ajouté.",
        addError: "Ajout impossible.",
        removeSuccess: "Connecteur retiré.",
        removeError: "Retrait impossible.",
        disconnectSuccess: "Connecteur déconnecté.",
        disconnectError: "Déconnexion impossible.",
        settingsSuccess: "Configuration enregistrée.",
        settingsError: "Configuration impossible.",
        testSuccess: "Statut connecteur : {{status}}.",
        testError: "Test impossible.",
        catalogError: "Impossible de charger les connecteurs.",
        catalogHTTPError: "Console {{status}} sur {{path}} : {{message}}",
        authMode: "Mode",
        configurationRequiredHelp:
          "Renseignez la configuration du connecteur avant de créer une connexion utilisateur.",
        manualSupportHelp:
          "Ce connecteur nécessite une configuration accompagnée par le support.",
        editSettings: "Modifier",
        configure: "Configurer",
        reconnect: "Reconnecter",
        connect: "Connecter",
        test: "Tester",
        tools: "Tools",
        disconnect: "Déconnecter",
        remove: "Retirer",
        maintainedPack: "Pack maintenu",
        actionsAvailable: "Actions disponibles",
        noActionsEnabled: "Aucune action activée",
        directoryTitle: "Ajouter un connecteur",
        directoryDescription:
          "Le catalogue est global, mais l’ajout rend le connecteur disponible uniquement pour l’Agent courant.",
        searchPlaceholder: "Rechercher Gmail, Slack, CRM…",
        allCategories: "Toutes catégories",
        allAuthModes: "Tous modes",
        directoryError: "Impossible de charger le catalogue.",
        noDirectoryResults: "Aucun connecteur ne correspond à cette recherche.",
        toolPack: "Pack tools",
        add: "Ajouter",
        loadMoreConnectors: "Afficher plus",
        toolsTitle: "Tools du connecteur",
        toolsDescription: "Tools projetés sur l’Agent courant pour {{connector}}.",
        toolsError: "Impossible de charger les tools du connecteur.",
        noActionsHelp:
          "Aucun tool n’est projeté tant que le connecteur n’est pas configuré et connecté sur cet Agent.",
        managedAction: "Action disponible",
        customTool: "Tool custom",
        editSettingsTitle: "Modifier la configuration",
        configureTitle: "Configurer le connecteur",
        configureDescription: "Les valeurs secrètes ne sont jamais réaffichées.",
        connectionCredentialsHelp:
          "Les identifiants sont saisis au moment de connecter le compte utilisateur.",
        setupGuide: "Guide de configuration",
        callbackUrl: "URL de callback",
        disabled: "Désactivé",
        manualSupport: "Support requis",
        configurationRequired: "Configuration requise",
        connected: "Connecté",
        revoked: "Révoqué",
        notConnected: "Non connecté",
        consoleRequiredTitle: "Connectez AgentMaurice Console",
        consoleRequiredDescription:
          "Les intégrations s’authentifient sur la Console avec votre session Hanko. Sans ces deux critères, le catalogue et les crédits ne sont pas disponibles.",
        consoleRequiredHankoOk: "Session Hanko",
        consoleRequiredHankoMissing: "Session Hanko manquante",
        consoleRequiredConsoleMissing: "Session Console manquante",
        consoleRequiredHankoTitle: "1. Connectez-vous avec Hanko",
        consoleRequiredHankoBody:
          "Ouvrez AgentMaurice OS en auth Hanko (pas le mode local). Utilisez le même e-mail que sur la Console. La création de compte se fait sur la Console.",
        consoleRequiredConsoleTitle: "2. Ouvrez une session AgentMaurice Console",
        consoleRequiredConsoleBody:
          "Connectez-vous sur AgentMaurice Console avec ce compte, puis créez ou rejoignez une organisation. Le JWT Hanko de l’OS doit être accepté par cette Console.",
        consoleRequiredCreditsTitle: "3. Obtenez des crédits",
        consoleRequiredCreditsBody:
          "Les connecteurs hosted débittent le wallet de l’organisation. Dans la Console, ouvrez Facturation et achetez un pack de crédits AgentMaurice.",
        consoleRequiredOpenConsole: "Ouvrir AgentMaurice Console",
        consoleRequiredOpenBilling: "Acheter des crédits",
      },
      desktopUpdate: {
        availableTitle: "Nouvelle version disponible",
        availableDescription: "JusteMaurice {{version}} peut être installé.",
        genericVersion: "la plus récente",
        installAction: "Mettre à jour",
        installing: "Installation de la mise à jour…",
        installError: "Impossible d’installer la mise à jour.",
      },
      auth: {
        checking: "Vérification de l’authentification…",
        required:
          "Une authentification est requise avant de charger les organisations, les Agents et les espaces.",
        localModeEnabled:
          "Le mode développement local est activé. L’authentification est gérée par `chatserver`.",
        localAccount: "Compte local",
        localSignIn: "Connexion locale",
        signIn: "Se connecter",
        createAccount: "Créer un compte",
        loadingApp: "Chargement de l’Agent OS…",
        createAccountOnConsoleHint:
          "La création de compte se fait sur console.agentmaurice.app.",
        signInError: "Erreur de connexion",
        noAccountYet: "Pas encore de compte ?",
      },
      enrollment: {
        title: "Compléter votre profil AgentMaurice",
        subtitle:
          "Renseignez votre profil et créez votre première organisation avant d’entrer dans AgentMaurice OS.",
        subtitleProfileOnly:
          "Renseignez votre profil Console avant d’entrer dans AgentMaurice OS.",
        roleHint:
          "Votre premier rôle sera `orga-admin` pour cette organisation.",
        roleHintProfileOnly:
          "Ce profil sera enregistré dans la Console et synchronisé automatiquement ici.",
        email: "Email",
        username: "Nom d’utilisateur",
        usernamePlaceholder: "mikaelmorvan",
        firstName: "Prénom",
        firstNamePlaceholder: "Votre prénom",
        lastName: "Nom",
        lastNamePlaceholder: "Votre nom",
        language: "Langue favorite",
        personalOrganization: "C’est une organisation personnelle",
        personalOrganizationHint:
          "Laissez le nom vide si vous voulez utiliser votre identité comme nom d’organisation.",
        organizationName: "Nom de l’organisation",
        organizationNamePlaceholder: "AgentMaurice",
        organizationNamePersonalPlaceholder:
          "Optionnel pour une organisation personnelle",
        submit: "Enregistrer le profil",
        error: "Impossible d’enregistrer le profil.",
        validation: {
          username: "Le nom d’utilisateur est requis.",
          firstName: "Le prénom est requis.",
          lastName: "Le nom est requis.",
          language: "La langue favorite est requise.",
          organizationName: "Le nom de l’organisation est requis.",
        },
      },
      welcome: {
        badge: "Configuration express",
        title: "Préparez AgentMaurice OS pour un premier run utile.",
        subtitle:
          "Nous récupérons le contexte d’organisation, créons l’Agent par défaut si nécessaire, puis nous verrouillons l’accès LLM avant d’ouvrir le chat et Build.",
        organizationTitle: "Organisation",
        organizationReady: "Organisation disponible",
        organizationPending: "En attente du bootstrap local",
        deploymentTitle: "Agent",
        deploymentReady: "Agent par défaut prêt",
        deploymentPending: "Agent à créer ou rattacher",
        providerTitle: "LLM",
        providerChoicePending: "Choix LLM non défini",
        providerHosted: "LLM AgentMaurice",
        providerHostedPending: "LLM AgentMaurice à initialiser",
        providerReady: "Provider configuré",
        providerPending: "Aucun provider actif",
        nextStepTitle: "Étape suivante",
        nextStepModeChoice:
          "Choisissez d’abord comment vous voulez utiliser les LLM : modèles AgentMaurice ou clés API personnelles.",
        nextStepContext:
          "Nous finalisons encore le contexte local. Relancez le bootstrap pour récupérer l’organisation console et créer le workspace par défaut.",
        nextStepDeployment:
          "L’organisation est prête, mais il manque encore l’Agent utilisateur par défaut. Rafraîchissez le contexte pour le créer.",
        nextStepProvider:
          "Le contexte est prêt. Configurez maintenant vos clés API pour débloquer le chat et Build.",
        nextStepHostedPending:
          "Le contexte est prêt. Initialisez le profil LLM AgentMaurice pour créer le provider, le modèle et la sélection de l’Agent.",
        nextStepHosted:
          "Le contexte est prêt. Les modèles AgentMaurice sont disponibles sans clé supplémentaire sur cette instance.",
        nextStepReady:
          "Tout est prêt sur cette machine. Vous pouvez aller dans le chat ou passer en Build sans configuration supplémentaire.",
        stepConsoleTitle: "Contexte",
        stepConsoleDescription:
          "AgentMaurice OS recharge d’abord votre organisation puis prépare le workspace actif.",
        stepProviderTitle: "Provider",
        stepProviderDescription:
          "Choisissez le mode LLM adapté à votre usage puis, en mode clés utilisateur, testez la configuration avant enregistrement.",
        stepLaunchTitle: "Lancement",
        stepLaunchDescription:
          "Une fois le mode validé, le chat et Build deviennent directement exploitables depuis cette machine.",
        modeTitle: "Choisir l’accès LLM",
        modeDescription:
          "Vous devez choisir entre les modèles proposés par AgentMaurice et vos propres clés API avant d’utiliser l’instance.",
        modeLabel: "Mode LLM",
        modeHostedTitle: "LLM AgentMaurice",
        modeHostedDescription:
          "Utilisez les modèles fournis par AgentMaurice. Aucune clé personnelle n’est requise sur ce poste.",
        modeByokTitle: "Mes propres clés",
        modeByokDescription:
          "Utilisez vos propres providers. Tant que les clés ne sont pas configurées, le chat et Build restent bloqués.",
        modeChoiceRequiredTitle: "Choix requis",
        modeChoiceRequiredDescription:
          "Tant que vous n’avez pas choisi un mode LLM, l’instance reste en configuration et les parcours principaux restent verrouillés.",
        modeLockedTitle: "Configuration LLM déjà définie",
        modeLockedHostedDescription:
          "Cette organisation utilise les modèles AgentMaurice. Les autres utilisateurs de cette VM n’ont pas à refaire l’onboarding LLM.",
        modeLockedByokDescription:
          "Cette organisation utilise déjà un provider BYOK. Les autres utilisateurs de cette VM n’ont pas à ressaisir de clés.",
        hostedTitle: "Utiliser les LLM AgentMaurice",
        hostedDescription:
          "Cette instance peut utiliser directement les modèles AgentMaurice. Vous n’avez rien à saisir côté clés API.",
        hostedPanelTitle: "LLM AgentMaurice actif",
        hostedPanelDescription:
          "L’Agent utilise un profil LLM organisationnel AgentMaurice. Aucun secret utilisateur n’est nécessaire dans AgentMaurice OS.",
        hostedPanelPendingTitle: "Initialiser le profil AgentMaurice",
        hostedPanelPendingDescription:
          "AgentMaurice OS va créer ou réutiliser le provider AgentMaurice de l’organisation, ajouter un modèle par défaut, créer un profil et le sélectionner pour cet Agent.",
        hostedNoKeyRequired: "Aucune clé utilisateur requise",
        hostedPendingNoKey: "Aucune clé utilisateur requise",
        hostedActivateButton: "Initialiser AgentMaurice",
        hostedActivating: "Initialisation…",
        hostedActivateSuccess: "Profil LLM AgentMaurice initialisé.",
        hostedActivateError: "Impossible d’initialiser le profil LLM AgentMaurice.",
        byokPanelTitle: "Provider BYOK actif",
        byokPanelDescription:
          "L’organisation possède déjà une configuration LLM. Pour la modifier, utilisez Build > LLM avec les droits nécessaires.",
        formTitle: "Connecter votre LLM",
        formDescription:
          "Un seul setup suffit. Les secrets sont stockés côté backend local et le provider est rattaché à l’Agent par défaut.",
        readyBadge: "Prêt",
        setupBadge: "Setup requis",
        providerNameLabel: "Nom affiché",
        modelLabel: "Modèle",
        apiKeyLabel: "Clé API",
        apiKeyOptionalLabel: "Clé API (optionnelle)",
        apiKeyPlaceholder: "sk-...",
        urlRequiredLabel: "URL / endpoint",
        urlOptionalLabel: "URL / endpoint (optionnel)",
        urlPlaceholder: "https://...",
        advancedTitle: "Paramètres avancés",
        hideAdvanced: "Masquer",
        showAdvanced: "Afficher",
        systemPromptLabel: "System prompt",
        systemPromptPlaceholder:
          "Optionnel. Utilisez le prompt par défaut si vous laissez ce champ vide.",
        maxCompletionTokensLabel: "Max completion tokens",
        diagnosticOk: "Connexion validée",
        diagnosticError: "Le test a échoué",
        testing: "Test…",
        testButton: "Tester",
        saving: "Configuration…",
        primaryButton: "Tester et démarrer",
        refreshing: "Rafraîchissement…",
        refreshButton: "Rafraîchir le contexte",
        continueChat: "Continuer vers le chat",
        openBuild: "Ouvrir Studio",
        readyHint:
          "Le contexte est prêt. Vous pouvez entrer dans le chat ou ouvrir Build pour commencer à construire.",
        readyHintHosted:
          "Le contexte est prêt et les modèles AgentMaurice sont disponibles. Vous pouvez entrer directement dans le chat ou Build.",
        pendingHint:
          "Choisissez d’abord un mode LLM, puis vérifiez que l’organisation et l’Agent sont bien prêts avant de continuer.",
        pendingHintByok:
          "Tant que vos clés API ne sont pas testées et enregistrées, le chat et Build restent verrouillés.",
        pendingHintHosted:
          "Initialisez le profil AgentMaurice pour débloquer le chat et Build sans saisir de clé API.",
        testSuccess: "Connexion au provider validée.",
        testError: "Impossible de valider la connexion au provider.",
        saveSuccess: "Configuration enregistrée.",
        saveError: "Impossible d’enregistrer la configuration.",
        contextRefreshed: "Contexte local rechargé.",
        contextRefreshError: "Impossible de recharger le contexte local.",
        statusError: "Impossible de lire le statut du setup.",
        agentDiscoveryTitle: "Connecter un agent de code",
        agentDiscoveryDescription:
          "Choisissez un prompt sans installation ou une commande MauriceCLI pour le rail Git-native Agent Spec V2. Dans les deux cas, l’accès External Inception reste guidé, temporaire et auditable.",
        agentDiscoveryBadge: "External Inception",
        codeAgentPromptMode: "Connexion MCP sans installation (`amb_`)",
        codeAgentCLIMode: "Connexion MauriceCLI (`amc_`)",
        codeAgentPromptModeHint:
          "Copiez un prompt de connexion MCP. Son URL `amb_` ne doit jamais être transmise à `maurice agent connect`.",
        codeAgentCLIModeHint:
          "Copiez la commande `maurice agent connect`. Elle configure le client puis engage le rail Agent Spec V2 dans le projet Git local.",
        agentDiscoveryReadyHint:
          "Le prompt ne contient pas la clé finale. L’agent devra appeler l’URL bootstrap pour recevoir le contrat `agentmaurice.agent_connection/v2`.",
        agentDiscoveryUnavailableHint:
          "Vous n’avez pas les droits suffisants pour générer ce prompt.",
        agentDiscoveryHumanApprovalHint:
          "L’agent de code prépare le plan, mais ne peut pas l’approuver. L’approbation du hash exact reste une action humaine distincte dans AgentMaurice OS.",
        agentDiscoveryGenerate: "Générer le prompt",
        agentDiscoveryGenerating: "Génération…",
        agentDiscoveryCopy: "Copier le prompt",
        agentDiscoveryGenerated: "Prompt agent généré.",
        agentDiscoveryGenerateError: "Impossible de générer le prompt agent.",
        agentDiscoveryInvalidBootstrap: "Le serveur n’a pas retourné une connexion MCP `amb_` valide.",
        agentDiscoveryCopied: "Prompt agent copié.",
        agentDiscoveryCopyError: "Impossible de copier le prompt agent.",
        agentDiscoveryPrompt:
          "Tu vas connecter cet agent de code à une instance AgentMaurice.\n\nIMPORTANT — connexion MCP uniquement (`amb_`) : ne transmets jamais cette URL à `maurice agent connect`. Cette commande exige un bootstrap MauriceCLI `amc_` généré par AgentMaurice OS.\n\n1. Appelle cette URL bootstrap une seule fois :\n{{url}}\n\n2. Vérifie que le JSON retourné porte `$schema: agentmaurice.agent_connection/v2`, `schema_version: 2`, `bootstrap_kind: external_inception_mcp` et `intended_consumer: mcp_client_setup`. Utilise uniquement `organization`, `agent`, `agent_scopes`, `credential`, `mcp`, `commands`, `tools`, `policies`, `warnings`, `next_command` et `client_setup`.\n\n3. Configure le MCP avec `client_setup`. Commence par `inception_agent_scopes_list`, puis appelle `inception_agent_doctor` sans argument : sa réponse est compacte par défaut ; utilise `full:true` seulement pour un diagnostic expert explicite. Appelle ensuite `inception_mcp_capabilities`. Ne cible jamais un Agent par inférence de nom : utilise `agent_alias` ou `agent_id` depuis `agent_scopes`.\n\n4. Pour toute modification, suis exclusivement ce rail : `inception_agent_spec_init` si nécessaire → `inception_agent_spec_pull` → édition des fichiers Git-native → `inception_agent_spec_check` → `inception_agent_spec_plan`. Présente le plan immuable et son `plan_hash`, puis arrête-toi.\n\n5. L’approbation doit être enregistrée par un humain authentifié dans AgentMaurice OS ou dans une session humaine distincte. En tant qu’agent ou service, n’appelle pas `inception_agent_spec_approve` et ne tente jamais de t’auto-approuver. Après confirmation que l’approbation humaine est enregistrée, appelle `inception_agent_spec_apply` avec le plan approuvé, puis `inception_agent_spec_verify`.\n\n6. Ne demande, n’affiche et n’écris jamais de secret brut ; utilise uniquement des références de secrets.",
        cliBootstrapReadyHint:
          "La commande configure le client et le projet local ; les changements suivent ensuite init/pull/check/plan, approbation humaine, apply et verify.",
        cliBootstrapUnavailableHint:
          "Vous n’avez pas les droits suffisants pour générer cette commande.",
        cliBootstrapEnvLabel: "Environnement",
        cliBootstrapKindLabel: "Type",
        cliBootstrapClientLabel: "Client agent",
        cliBootstrapAliasLabel: "Alias technique de l’Agent (`agent_alias`)",
        cliBootstrapDirLabel: "Dossier",
        cliBootstrapJoinExistingLabel: "Me reconnecter à un projet existant",
        cliBootstrapJoinExistingDescription:
          "Ajoute `--join-existing` pour renouveler les accès locaux sans réécrire ni exporter les fichiers Agent Spec du projet.",
        bootstrapScopesTitle: "Agents liés",
        bootstrapScopesDescription:
          "Ajoutez seulement les Agents que cet agent ou cette CLI doit pouvoir cibler explicitement.",
        bootstrapScopesNone:
          "Aucun autre Agent disponible dans ce contexte.",
        bootstrapScopeAlias: "Alias",
        bootstrapScopeRole: "Rôle",
        bootstrapScopeRuntimeDependency: "Dépendance runtime",
        bootstrapScopeManaged: "Géré",
        cliBootstrapGenerate: "Générer la commande",
        cliBootstrapGenerating: "Génération…",
        cliBootstrapCopy: "Copier la commande",
        cliBootstrapGenerated: "Commande MauriceCLI générée.",
        cliBootstrapGenerateError: "Impossible de générer la commande MauriceCLI.",
        cliBootstrapInvalidCommand: "Le serveur n’a pas retourné une commande `maurice agent connect` V2 valide.",
        cliBootstrapCopied: "Commande MauriceCLI copiée.",
        cliBootstrapCopyError: "Impossible de copier la commande MauriceCLI.",
        cliBootstrapKind: {
          development: "Développement",
          preproduction: "Préproduction",
          production: "Production",
          sandbox: "Sandbox",
          integration_test: "Test d’intégration",
        },
        cliBootstrapClient: {
          "claude-code": "Claude Code",
          codex: "Codex",
          cursor: "Cursor",
          windsurf: "Windsurf",
          generic: "Generic MCP",
        },
      },
      operateSetup: {
        missingOrganizationTitle: "Organisation requise",
        missingOrganizationDescription:
          "Cette vue a besoin d’une organisation active avant de pouvoir charger le contenu d’exécution.",
        missingDeploymentTitle: "Agent requis",
        missingDeploymentDescription:
          "Sélectionnez ou créez d’abord un Agent actif pour ouvrir les écrans d’exécution.",
        missingSpaceTitle: "Espace requis",
        missingSpaceDescription:
          "L’Agent est prêt, mais aucun espace n’est encore actif dans cette session. Revenez à l’accueil pour terminer la mise en route.",
        noSpaceTitle: "Aucun espace prêt pour cet Agent",
        noSpaceDescription:
          "Cette instance n’a pas encore d’espace exploitable pour l’Agent courant. Finalisez la configuration depuis l’accueil avant d’ouvrir le chat.",
        loadingSpacesTitle: "Chargement des espaces…",
        loadingSpacesDescription:
          "Vérification des espaces disponibles pour l’Agent courant avant d’ouvrir le chat.",
        openWelcome: "Ouvrir l’accueil",
        createSpace: "Créer un espace",
        creatingSpace: "Création de l’espace…",
        createSpaceError: "Impossible de créer l’espace pour cet Agent.",
        escalateChiefOfStaff: "Continuer dans Studio avec le Chef d’orchestre",
        escalateChiefOfStaffHint:
          "Cet Agent n’a pas encore la capacité demandée. Le Chef d’orchestre la prépare dans Studio.",
        openCatalog: "Ouvrir le catalogue",
        openHistory: "Ouvrir l’historique",
        completeSetupToStart:
          "Terminez l’accueil pour débloquer le chat et les écrans d’exécution",
      },
      shell: {
        toggleContextPanel: "Basculer le panneau de contexte",
        toggleRightPanel: "Basculer le panneau de droite (Ctrl/Cmd+Shift+\\)",
        openNavigation: "Ouvrir la navigation",
        closeNavigation: "Fermer la navigation",
        resizeNavigationPanel: "Redimensionner le panneau de navigation",
        resizeContextPanel: "Redimensionner le panneau de contexte",
        executionDetailTitle: "Détail d’exécution",
        executionDetailDescription: "Contexte pour l’exécution sélectionnée.",
        emptyContextDescription:
          "Le shell garde cette zone prête pour l’inspection, les détails d’exécution et les aperçus contextuels.",
      },
      sidebar: {
        recipes: "Recettes",
        data: "Données",
        deployments: "Agents",
        chiefOfStaff: "Chef d'orchestre",
        applications: "Applications",
        agentStudio: "Studio",
        travail: "Travail",
        travailInbox: "À traiter",
        travailActivity: "Activité",
        noApplications: "Aucune Application",
        applicationReview: "Revue",
        organization: "Organisation",
        orgAccessMap: "Droits",
        orgGates: "Portes machine",
        orgMembers: "Membres & annuaire",
        orgVault: "Coffre & événements",
        orgUsage: "Usage & facturation",
        orgImportExport: "Import / export",
        agentModels: "Modèles",
        models: "Modèles",
        mcp: "MCP",
        skills: "Skills",
        agentConfig: "Réglages",
        tools: "Outils",
        channels: "Canaux",
        importExport: "Import / Export",
        mailCatcher: "Mail Catcher",
        spaces: "Espaces",
        chat: "Chat",
        catalog: "Catalogue",
        history: "Historique",
        spacesSessions: "Espaces et sessions",
        newSession: "Nouvelle session",
        sessionActions: "Actions de session",
        renameSession: "Renommer",
        renameSessionTitle: "Renommer la session",
        renameSessionDescription:
          "Modifiez le nom affiché dans la liste des sessions.",
        renameSessionNameRequired: "Le nom de session est obligatoire.",
        renameSessionSuccess: "Session renommée.",
        renameSessionError: "Impossible de renommer la session.",
        deleteSession: "Supprimer",
        deleteSessionTitle: "Supprimer la session",
        deleteSessionDescription:
          "La session {{name}} sera supprimée définitivement.",
        deleteSessionSuccess: "Session supprimée.",
        deleteSessionError: "Impossible de supprimer la session.",
        sessionName: "Nom de la session",
        unnamedSession: "Session",
        noSessionYet: "Aucune session pour le moment.",
        localProfile: "Profil local",
        userProfile: "Profil utilisateur",
        account: "Compte",
        access: "Accès",
        osVersion: "AgentMaurice OS",
        appearance: "Apparence",
        profileSecurity: "Sécurité",
        localAuthentication: "Authentification locale",
        hankoAuthentication: "Authentification sécurisée",
        hankoProfileDescription:
          "Gérez l’identité, les méthodes de connexion et le contexte AgentMaurice de cette session.",
        hankoProfileLoadError: "Impossible de charger la sécurité du compte.",
        localSignOutHint:
          "La déconnexion vous ramène au sélecteur de comptes locaux.",
        hankoSignOutHint:
          "La déconnexion termine la session locale sur cet appareil.",
        confirmSignOutTitle: "Confirmer la déconnexion",
        confirmSignOutDescription:
          "Vous allez fermer la session courante sur cet appareil.",
        confirmSwitchUserDescription:
          "Vous allez quitter ce profil local et revenir au sélecteur de comptes.",
        switchUser: "Changer d’utilisateur",
        signOut: "Se déconnecter",
        consoleBinding: "Rattachement console",
        consoleBindingDescription:
          "Rattachez cette installation à une instance console sans changer le backend local ni la base SQLite.",
        consoleBound: "Rattaché",
        consoleUnbound: "Non rattaché",
        consoleUrl: "Console",
        consoleInstance: "Instance",
        consoleOrganization: "Organisation",
        consoleUser: "Utilisateur console",
        consoleLastSync: "Dernière mise à jour {{value}}",
        consolePair: "Rattacher",
        consoleReconnect: "Rattacher à nouveau",
        consoleDetach: "Détacher",
        consoleDetachConfirm:
          "Détacher cette installation de la console et recharger l’application ?",
        consoleDetached:
          "Le rattachement console a été supprimé. Rechargement…",
        consolePairingIntro:
          "Entrez l’URL de la console puis lancez le device flow de rattachement.",
        consolePairingStart: "Démarrer le rattachement",
        consolePairingCancel: "Annuler",
        consolePairingUrlPlaceholder: "https://console.agentmaurice.app",
        consolePairingPending:
          "Ouvrez cette URL dans votre navigateur et saisissez le code suivant.",
        consoleVerificationUrl: "URL de validation",
        consoleUserCode: "Code",
        consoleCheckingStatus: "En attente de validation…",
        consolePairingExpires: "Expire dans {{count}} s",
        consolePairingExpired:
          "Le code de rattachement a expiré. Relancez le pairing.",
        consolePaired: "Installation rattachée à {{instance}}. Rechargement…",
        consolePairingFailed: "Le rattachement console a échoué.",
        consoleReloadHint:
          "Le contexte d’organisation sera rechargé automatiquement après rattachement ou détachement.",
      },
      contextSwitcher: {
        selectOrganization: "Sélectionner une organisation",
        selectDeployment: "Sélectionner un Agent",
        organization: "Organisation",
        orgId: "ID organisation",
        notSelected: "Non sélectionné",
        loadingContext: "Chargement du contexte…",
        createApplicationTitle: "Créer une Application",
        createApplicationDescription:
          "Une Application regroupe des Agents et publie une surface d’accès externe (workflows, MiniApps, chat optionnel).",
        createApplicationKeyLabel: "Clé Application",
        createApplicationKeyPlaceholder: "salon-client",
        createApplicationNameLabel: "Nom affiché",
        createApplicationNamePlaceholder: "Portail client",
        createApplicationConfirm: "Créer l’Application",
        createApplicationSubmitting: "Création…",
        createApplicationSuccess: "Application {{name}} créée.",
        createApplicationFailed: "Impossible de créer l’Application.",
        createApplicationKeyRequired: "La clé Application est requise.",
        createApplicationAgentsLabel: "Agents membres",
        createApplicationAgentsHint:
          "Sélectionnez les Agents à inclure dans cette Application.",
        createApplicationNoAgents:
          "Aucun Agent disponible dans cette organisation.",
        createApplicationMembersPartial:
          "Application créée, mais certains Agents n’ont pas pu être ajoutés.",
        createDeploymentTitle: "Créer un Agent",
        createDeploymentSubmitting: "Création…",
        createDeploymentNoOrganization:
          "Sélectionnez d’abord une organisation.",
      },
      compose: {
        emptyApplications: "Aucune Application. Créez-en une depuis l’arbre Studio.",
        selectOrganization: "Sélectionnez une organisation.",
        selectApplicationHint:
          "Choisissez une Application dans l’arbre Studio.",
        sectionSurface: "Surface",
        sectionRun: "Run",
        loadFailed: "Impossible de charger les Applications.",
        members: "Members (Agents)",
        noAgents: "Aucun Agent member pour l’instant.",
        selectAgent: "Choisir un Agent",
        addAgent: "Ajouter",
        removeAgent: "Retirer",
        agentAdded: "Agent ajouté à l’Application.",
        agentAddFailed: "Impossible d’ajouter l’Agent.",
        agentRemoved: "Agent retiré de l’Application.",
        agentRemoveFailed: "Impossible de retirer l’Agent.",
        chatEntrypoint: "Entrypoint chat (optionnel)",
        noChatEntrypoint: "Pas de chat",
        runLLM: "Modèle utilisé par cette Application",
        runLLMHint: "Référence portable slug:model (ex. hosted:gpt-4o-mini). Vide = profil org.run.",
        mcpGrants: "Grants MCP (tools Run)",
        mcpGrantsHint: "Une tool par ligne. Vide = pas de narrowing supplémentaire.",
        saveRunConfig: "Enregistrer Run / grants",
        runConfigSaved: "Configuration Run enregistrée.",
        runConfigSaveFailed: "Échec de l’enregistrement Run / grants.",
        surfaceWorkflows: "Workflows publics",
        surfaceWorkflowsHint:
          "Cochez les Workflows des Agents members à exposer. Absents = rien n’est publié.",
        surfaceWorkflowsUnavailable: "Plus disponible sur l’Agent",
        surfaceWorkflowsLoadFailed: "Impossible de charger les Workflows des members.",
        saveSurface: "Enregistrer le draft",
        publishSurface: "Publier (semver minor)",
        surfaceSaved: "Surface enregistrée.",
        surfaceSaveFailed: "Échec de l’enregistrement de la surface.",
        surfacePublished: "Surface publiée.",
        surfacePublishFailed: "Échec de la publication.",
        publishedVersion: "Version publiée : {{version}}",
      },
      chat: {
        headerTitle: "Discuter avec Maurice",
        presenceLabel: "Présents dans la session",
        presenceYou: "vous",
        invite: {
          button: "Inviter",
          title: "Inviter dans la discussion",
          hint: "Seules les personnes qui ont accès à l'Application sont proposées. La personne invitée accède à cette discussion seulement, pas aux autres discussions de l'espace.",
          loading: "Chargement des personnes…",
          empty: "Toutes les personnes qui ont accès à l'Application ont déjà accès à cette discussion.",
          listLabel: "Personnes à inviter",
          pending: "Invitation en cours",
          retry: "Réessayer",
          success: "{{name}} a accès à cette discussion : elle apparaît dans son Run.",
          alreadyMember: "{{name}} a déjà accès à cette discussion.",
          participantsTitle: "Personnes invitées",
          participantsEmpty: "Personne n'est encore invité dans cette discussion.",
          remove: "Retirer",
          removeLabel: "Retirer {{name}} de la discussion",
          removing: "Retrait en cours",
          removed: "{{name}} n'a plus accès à cette discussion.",
          errors: {
            run_invitee_not_application_person: "Cette personne n'a pas accès à l'Application.",
            run_session_not_found: "Discussion introuvable, ou vous n'y participez pas.",
            run_session_not_invitable: "Cette discussion ne peut pas être partagée depuis cette Application.",
            run_participant_removal_forbidden: "Seuls l'auteur de l'invitation et le propriétaire de l'espace peuvent retirer cette personne.",
            application_access_denied: "Vous n'avez pas accès à cette Application.",
            unknown: "Impossible de charger ou d'envoyer l'invitation. Réessayez.",
          },
        },
        recipeLabel: "Workflow : {{name}}",
        recipeBadge: "Contexte",
        chooseRecipe: "Choisir un Workflow",
        skillsButton: "Skills",
        debugMessages: "Debug",
        showTechnicalMessages: "Afficher les appels tools et résultats bruts",
        hideTechnicalMessages: "Masquer les appels tools et résultats bruts",
        skillsSessionLabel: "Skills de session",
        skillsPanelTitle: "Skills de session",
        skillsPanelDescription:
          "Sélectionnez des skills de l’Agent pour enrichir la session courante.",
        skillsLoading: "Chargement des skills…",
        skillsLoadingError: "Impossible de charger les skills de l’Agent.",
        noSelectedSkills: "Aucune skill sélectionnée pour cette session.",
        noDeploymentSkills: "Aucune skill installée sur cet Agent.",
        useSkill: "Utiliser",
        skillSelected: "Sélectionnée",
        clearSkills: "Vider les skills",
        skillsCleared: "Sélection de skills vidée.",
        skillNotFound: "Skill introuvable : {{skill}}",
        skillAdded: "{{skill}} ajoutée à la session.",
        skillRemoved: "{{skill}} retirée de la session.",
        noSkillPreview: "Aucun aperçu disponible pour cette skill.",
        execution: "Exécution",
        connectionErrorTitle: "Erreur de connexion",
        connectionErrorDescription:
          "La connexion au chat a échoué. Réessayez ; si le problème persiste, contactez votre administrateur.",
        serverErrorTitle: "Erreur du service",
        serverErrorDescription:
          "Le service a rencontré une erreur. Votre message n'a pas été perdu ; réessayez dans un instant.",
        serviceTimeoutTitle: "Le service met trop de temps à répondre",
        serviceTimeoutDescription:
          "Problème de service temporaire, indépendant du Workflow. Réessayez dans un instant.",
        errorRetryAction: "Réessayer",
        errorTechnicalDetailsToggle: "Détails techniques",
        sessionPausedTitle: "Session en veille",
        sessionPausedDescription: "La session a été mise en veille après une période d'inactivité.",
        resumeConversation: "Reprendre la conversation",
        sessionReplacedOtherApplication:
          "Cette discussion appartient à une autre Application : une nouvelle discussion a été ouverte ici. L’historique reste dans son Application.",
        sessionReplacedUnavailable:
          "La discussion demandée n’est pas disponible dans cette Application : une nouvelle discussion a été ouverte.",
        sessionReplacedDismiss: "Masquer ce message",
        accessRemovedTitle: "Votre accès à cette discussion a été retiré",
        accessRemovedDescription:
          "Vous ne pouvez plus lire ni écrire dans cette discussion. Pour y revenir, demandez à une personne qui gère l’Application de vous réinviter.",
        accessRemovedPlaceholder: "Accès retiré",
        applicationNotOpenPlaceholder: "Application non ouverte",
        messageFeed: "Fil des messages du chat",
        loadingHistory: "Chargement de l’historique…",
        loadingOlderMessages: "Chargement des messages plus anciens…",
        startConversation: "Démarrer une conversation",
        readyForMessage: "À vous de jouer",
        askAboutRecipe:
          "Posez n’importe quelle question à Maurice sur ce Workflow",
        askAboutWorkspace:
          "Posez n’importe quelle question à Maurice sur cet espace",
        latest: "Derniers messages",
        createSessionToStart:
          "Créez ou sélectionnez une session pour commencer.",
        askMaurice: "Demandez à Maurice…",
        noExecutionContext:
          "Aucun contexte d’exécution disponible pour le moment",
        noActiveSessionToClear: "Aucune session active à vider",
        sessionHistoryCleared: "Historique de session vidé",
        failedToClearSession: "Impossible de vider la session",
        clearSessionTitle: "Vider la session",
        clearSessionDescription:
          "Cela supprimera tout l’historique de la session de chat courante.",
        clearHistory: "Vider l’historique",
        helpMessage: [
          "Commandes disponibles :",
          "",
          "- `/status` ouvrir le contexte d’exécution",
          "- `/workflow` ouvrir le sélecteur de Workflows",
          "- `/tools` demander à Maurice les outils disponibles dans ce contexte",
          "- `/skills` ouvrir le panneau skills",
          "- `/use-skill <id>` sélectionner une skill pour la session",
          "- `/clear-skills` vider la sélection de skills",
          "- `/help` afficher cette aide",
          "- `/clear` supprimer l’historique de la session courante",
        ].join("\n"),
        recipeContextHint:
          "Les messages suivants restent cadrés par ce Workflow.",
        llmActivityThinking: "Maurice réfléchit…",
        llmActivityTool: "Maurice utilise un outil…",
        llmActivitySkill: "Maurice applique une skill…",
        llmActivityProject: "Maurice travaille sur le projet…",
      },
      chatInput: {
        openStatusContext: "Ouvrir le contexte de statut",
        openStatusContextDescription:
          "Demander le statut courant d’une exécution ou d’un Agent",
        launchRecipe: "Lancer un Workflow",
        launchRecipeDescription:
          "Ouvrir le sélecteur de Workflows ou cibler une commande de Workflow",
        showHelp: "Afficher l’aide",
        showHelpDescription: "Afficher les slash commands disponibles",
        showTools: "Afficher les outils",
        showToolsDescription:
          "Demander à Maurice les outils disponibles dans ce contexte",
        openSkills: "Ouvrir les skills",
        openSkillsDescription:
          "Afficher les skills de l’Agent et la sélection active de la session",
        useSkill: "Utiliser une skill",
        useSkillDescription:
          "Sélectionner une skill pour enrichir les prochains messages",
        clearSkills: "Vider les skills",
        clearSkillsDescription:
          "Retirer toutes les skills sélectionnées pour la session courante",
        clearSession: "Vider la session",
        clearSessionDescription:
          "Supprimer l’historique de la session courante",
        changeRecipe: "Changer",
        messageLabel: "Votre message",
        quickActions: "Actions rapides",
        shortcutHint:
          "Utilisez les slash commands ou le sélecteur de Workflows pour cadrer rapidement la session.",
        stop: "Arrêter",
      },
      files: {
        attach: "Joindre un fichier",
        attached: "{{filename}} ajouté au message",
        uploadFailed: "Échec de l’envoi du fichier",
        uploadProgress: "Envoi {{progress}}%",
        attachedFile: "Fichier joint",
      },
      recipePicker: {
        title: "Sélectionner un blueprint",
        description:
          "Lancez la conversation avec un contexte de Workflow spécifique, ou gardez le chat générique.",
        searchPlaceholder: "Rechercher des Workflows…",
        loading: "Chargement des Workflows…",
        noMatch: "Aucun Workflow ne correspond à cette recherche.",
        noDescription: "Aucune description fournie.",
      },
      recipeForm: {
        fallbackTitle: "Formulaire de Workflow",
        fallbackDescription:
          "Le Workflow en cours a besoin d’informations supplémentaires pour continuer.",
        selectOption: "Sélectionner…",
        submit: "Envoyer le formulaire",
        submitting: "Envoi…",
        fieldRequired: "{{field}} est obligatoire.",
        restoreError: "Impossible de rouvrir le formulaire de ce Workflow.",
      },
      chatMessage: {
        resourcePreview: "Aperçu de ressource",
        previewTruncated: "Aperçu tronqué.",
        result: "Résultat",
        logs: "Logs",
        userMessage: "Message utilisateur",
        peerMessage: "Message de {{name}}",
        assistantMessage: "Message assistant",
        technicalMessage: "Message technique",
      },
      executionPanel: {
        title: "Statut d’exécution",
        completedCount: "{{done}}/{{total}} terminées",
        running: "En cours…",
        progress: "Progression",
        overallProgress: "Progression globale",
        stepProgress: "Progression de {{step}}",
        empty: "Aucune étape active pour le moment",
        summary:
          "Les étapes d’exécution apparaîtront ici dès qu’un Workflow ou une tâche de session démarre.",
      },
      executionResult: {
        title: "Résultat",
        refresh: "Rafraîchir le résultat",
        copy: "Copier le résultat",
        loading: "Chargement du résultat…",
        empty: "Aucun résultat disponible.",
        expired:
          "Le Workflow s’est terminé, mais le résultat détaillé a expiré et n’est plus disponible.",
      },
      executionLogs: {
        title: "Logs",
        refresh: "Rafraîchir les logs",
        copy: "Copier les logs",
        loading: "Chargement des logs…",
        empty: "Aucun log disponible pour cette exécution.",
        expired:
          "Le Workflow s’est terminé, mais les logs détaillés ont expiré et ne sont plus disponibles.",
      },
      historyDetail: {
        rerun: "Relancer dans le chat",
        timeline: "Chronologie",
        created: "Créé",
        started: "Démarré",
        completed: "Terminé",
        duration: "Durée",
        blueprint: "Blueprint",
        loadingBlueprint: "Chargement de l’aperçu du Workflow…",
        noBlueprintPreview:
          "Aucun aperçu de blueprint n’est disponible pour cette exécution.",
        noDescription: "Aucune description fournie.",
        noRecipe: "Aucun Workflow n’est associé à cette exécution.",
        error: "Erreur",
        notAvailable: "Indisponible",
        pending: "En attente",
        running: "En cours",
        completedStatus: "Terminé",
        failed: "Échec",
        cancelled: "Annulée",
        waitingForForm: "Réponse attendue",
        unknownStatus: "Inconnu",
        respondToForm: "Répondre au formulaire",
        resultPartial: "Résultat partiel : le détail complet n’est plus disponible (archivé ou expiré).",
        usageTitle: "Bilan d’usage",
        usageSourceTrace: "Estimé",
        usageSourceMetering: "Metering",
        usageDuration: "Durée",
        usageTokens: "Tokens",
        usageEstimatedCost: "Coût estimé",
        usageActions: "Actions",
        usageFailures: "échecs",
        usageLLMCalls: "Appels LLM",
        usageMonetaryUnavailable: "Coût monétaire final indisponible",
        usageNoData: "Aucun bilan d’usage disponible.",
        usageModelBreakdown: "Modèles",
      },
      catalog: {
        title: "Catalogue d’actions",
        description:
          "Choisissez un Workflow pour démarrer une conversation avec Maurice",
        searchPlaceholder: "Rechercher des Workflows...",
        all: "Toutes",
        metricsAvailable: "Workflows",
        metricsAvailableHint: "Disponibles sur cet Agent",
        metricsVisible: "Visibles",
        metricsVisibleHint: "Correspondent aux filtres courants",
        surfaceHint:
          "Parcourez les Workflows depuis une surface faite pour rester lisible avant même le lancement.",
        resultsTitle: "Tous les Workflows",
        resultsDescription:
          "{{count}} Workflow(s) visible(s) dans cet Agent.",
        resultsFilteredBy: "Filtré par {{category}}",
        resultsAllVisible: "Vue complète",
        launchableTitle: "Prêtes à lancer",
        launchableDescription:
          "Ces Workflows sont déjà utilisables et peuvent ouvrir une nouvelle session immédiatement.",
        launchableCount: "{{count}} prête(s)",
        buildRequiredTitle: "À finaliser dans Studio",
        buildRequiredDescription:
          "Ces Workflows existent déjà, mais demandent encore une passe Agent Spec avant d’être lancés.",
        buildRequiredCount: "{{count}} à finaliser",
        loading: "Chargement des Workflows…",
        error: "Erreur",
        noRecipes: "Aucun Workflow disponible",
        noRecipesHint:
          "Créez et appliquez un Workflow avec Agent Spec pour démarrer",
        noSearchMatch: "Aucun Workflow ne correspond à votre recherche",
        clearFilters: "Effacer les filtres",
      },
      travail: {
        inboxTitle: "À traiter",
        inboxDescription:
          "Plans et fils qui attendent une décision humaine. Ce n’est pas une messagerie.",
        inboxEmpty: "Rien à traiter pour cet Agent.",
        activityTitle: "Activité",
        activityDescription:
          "Jobs Agent durables, exécutions Workflow et closeouts Studio réunis au même endroit.",
        activityEmpty: "Aucune activité récente pour cet Agent.",
        openThread: "Ouvrir le fil",
        openExecution: "Ouvrir l’exécution",
        summary: "Résumé",
        trajectory: "Trajectoire",
        evidence: "Preuves",
        blockedThread: "Fil bloqué",
        preparedPlan: "Plan à examiner",
        context: "Contexte",
        closeout: "Closeout Studio",
      },
      history: {
        title: "Historique des exécutions",
        description: "Consultez les exécutions passées et leurs résultats",
        searchPlaceholder: "Rechercher par Workflow ou ID d’exécution...",
        all: "Toutes",
        metricsTotal: "Total",
        metricsTotalHint: "Exécutions chargées",
        metricsSuccess: "Réussies",
        metricsSuccessHint: "Terminées sans blocage",
        metricsAttention: "À corriger",
        metricsAttentionHint: "Demandent une intervention",
        metricsRerunnable: "Relançables",
        metricsRerunnableHint: "Peuvent repartir dans le chat",
        surfaceHint:
          "Relisez les derniers runs et ouvrez leurs détails sans dépendre d’un panneau déjà rempli.",
        loading: "Chargement de l’historique…",
        error: "Erreur",
        noExecutions: "Aucune exécution trouvée",
        noExecutionsHint: "Démarrez une conversation pour voir l’historique",
        loadMore: "Charger plus",
        pending: "En attente",
        running: "En cours",
        completed: "Terminée",
        failed: "Échec",
        cancelled: "Annulée",
        waitingForForm: "Réponse attendue",
        unknownStatus: "Inconnu",
        openDetails: "Ouvrir les détails",
        respondToForm: "Répondre",
        rerun: "Relancer dans le chat",
        executionLabel: "Exécution",
        startedLabel: "Démarrée",
        durationLabel: "Durée",
        usageLabel: "Usage",
        signalLabel: "Signal",
        readinessReview: "À relire",
        readinessFix: "À corriger",
        readinessRerunnable: "Relançable",
        readinessRunning: "Suivi actif",
        readinessQueued: "En file",
        readinessWaitingForm: "Réponse attendue",
        readinessUnknown: "État inconnu",
        nextStepLabel: "Prochaine action",
        nextStepRerun:
          "Ouvrir les détails puis relancer rapidement si vous voulez comparer ou repartir.",
        nextStepFix:
          "Inspecter l’erreur, corriger le Workflow puis relancer depuis le chat.",
        nextStepReview: "Exécution annulée : relisez le contexte avant de relancer.",
        nextStepWatch:
          "Suivre la progression en détail ou attendre la fin du run.",
        nextStepQueue:
          "Attendre le démarrage complet avant de relancer ou d’intervenir.",
        nextStepRespond:
          "Répondre au formulaire pour que l’exécution reprenne.",
        nextStepUnknown:
          "État non reconnu par l’interface : consultez le détail avant d’agir.",
        groupAttentionTitle: "À corriger",
        groupAttentionDescription:
          "Ces runs ont échoué ou se sont bloqués et demandent une action avant relance.",
        groupActiveTitle: "En cours",
        groupActiveDescription:
          "Ces runs progressent encore dans le runtime et méritent surtout du suivi.",
        groupWaitingTitle: "Réponse attendue",
        groupWaitingDescription:
          "Ces runs attendent une réponse humaine à un formulaire avant de reprendre.",
        groupQueuedTitle: "En attente",
        groupQueuedDescription:
          "Ces runs existent déjà, mais n’ont pas encore démarré complètement.",
        groupUnknownTitle: "État inconnu",
        groupUnknownDescription:
          "Ces runs ont un état que l’interface ne reconnaît pas encore.",
        groupSuccessTitle: "Réussies",
        groupSuccessDescription:
          "Ces runs sont terminés, relisibles et souvent prêts à être relancés.",
        pendingSummary: "Cette exécution attend encore son démarrage complet.",
        runningSummary: "Cette exécution progresse encore dans le runtime.",
        completedSummary: "Le run est terminé et prêt à être relu.",
        failedSummary: "Le run a échoué et demande une relecture ciblée.",
        cancelledSummary: "Ce run a été annulé avant sa fin.",
        waitingForFormSummary: "Cette exécution attend une réponse à un formulaire.",
        unknownSummary: "État d’exécution non reconnu par l’interface.",
      },
      recipeCard: {
        active: "Active",
        draft: "Brouillon",
        noDescription: "Aucune description fournie",
        launchNow: "Lancer maintenant",
        openInBuild: "Ouvrir dans Studio",
        inspectBlueprint: "Inspecter le blueprint",
        launchHint: "Ouvre directement une nouvelle session d’exécution.",
        buildHint: "Passez par Agent Spec pour terminer ou appliquer ce Workflow.",
        workflow: "Workflow",
        miniapp: "MiniApp",
        moreTags: "+{{count}}",
      },
      runContext: {
        title: "Contexte de session",
        description:
          "Mémoire de session, artefacts récents et Workflow lié à cette conversation.",
        loadingContext: "Chargement du contexte de session…",
        activeRecipe: "Workflow actif",
        activeRecipeDescription:
          "Aperçu en lecture seule du Workflow actuellement lié à cette session.",
        loadingRecipe: "Chargement de l’aperçu du Workflow…",
        notLinked:
          "Cette conversation n’est pas encore liée à un Workflow spécifique.",
        openTasks: "Tâches ouvertes",
        timeline: "Chronologie",
        artifacts: "Artefacts",
        sourceGraph: "Sources",
        noOpenTasks: "Aucune tâche ouverte n’est visible pour cette session.",
        noTimeline:
          "Aucun événement récent n’est disponible pour cette session.",
        noArtifacts:
          "Aucun artefact récent n’est disponible pour cette session.",
        noSources: "Aucune source liée n’est disponible pour cette session.",
        previewTitle: "Aperçu d’artefact",
        previewDescription:
          "Prévisualisation rapide d’un artefact produit pendant cette session.",
        openFile: "Ouvrir le fichier",
        noPreview: "Aucun aperçu intégré disponible.",
      },
      filePreview: {
        image: "Image",
        document: "Document",
        file: "Fichier",
        noPreviewUrl: "Aucune URL d’aperçu disponible pour ce fichier.",
        loadingPreview: "Chargement de l’aperçu…",
        noInlinePreview: "Aucun aperçu intégré disponible pour ce fichier.",
      },
      commandPalette: {
        title: "Palette de commandes",
        description:
          "Rechercher des commandes de l’application ou demander à Calisto d’agir sur l’Agent courant.",
        placeholder: "Rechercher des commandes ou interroger Calisto…",
        noCommands: "Aucune commande trouvée.",
        newThread: "Nouveau fil",
        newThreadDescription: "Ouvrir le dialog de création d’un fil Studio",
        continueInStudio: "Continuer dans Studio",
        continueInStudioDescription: "Reprendre depuis la revue Application",
        travailInbox: "À traiter",
        travailInboxDescription: "Ouvrir la file Travail",
      },
      build: {
        llmOrgCatalogDescription:
          "Providers et credentials partagés par tous les Agents de l’organisation.",
        llmOrgProvidersTitle: "Providers",
        llmOrgProvidersEmpty: "Aucun provider configuré.",
        llmOrgRolesLiveUnderAgent:
          "Les modèles utilisés par le chat, Studio et les embeddings se choisissent sous chaque Agent › Réglages › Modèles.",
        llmAgentSelectAgent: "Sélectionnez un Agent pour choisir ses modèles.",
        llmAgentModelsHeading: "Modèles de l’Agent",
        llmAgentModelsDescription:
          "Modèles utilisés par le chat, par AgentMaurice Studio et par les embeddings pour cet Agent, choisis dans le catalogue de l’organisation.",
        llmOpenOrgCatalog: "Catalogue",
        questionNode: "Question",
        questionMore: "+ {{count}} autres — voir la configuration",
        questionCriteria: "Critères",
        questionConfidence: "Confiance minimale",
        networkAllowListBadge: "Sécurité réseau",
        networkAllowListTitle: "Accès réseau sortants",
        networkAllowListDescription: "Autorisez explicitement les endpoints que le code Deno de cet Agent peut appeler. Les modifications s’appliquent aux prochaines exécutions.",
        networkAllowListAddTitle: "Autoriser une URL",
        networkAllowListAddDescription: "L’hôte, le protocole et le port effectif sont extraits automatiquement. Le chemin et le token ne sont jamais stockés dans cette liste.",
        networkAllowListURLLabel: "URL à autoriser",
        networkAllowListURLPlaceholder: "https://devmachine.example.com/callback",
        networkAllowListEntryDescriptionLabel: "Description",
        networkAllowListDescriptionPlaceholder: "Callback DevMachine",
        networkAllowListAllow: "Autoriser",
        networkAllowListEntriesTitle: "Endpoints autorisés",
        networkAllowListEntriesDescription: "Ces permissions sont propres à l’Agent sélectionné et sont injectées dans le sandbox Deno.",
        networkAllowListEmpty: "Aucun endpoint externe n’est autorisé.",
        networkAllowListSubdomains: "Sous-domaines HTTP",
        networkAllowListDelete: "Supprimer l’autorisation",
        networkAllowListSaveSuccess: "Endpoint réseau autorisé",
        networkAllowListSaveError: "Impossible d’autoriser cet endpoint",
        networkAllowListDeleteSuccess: "Autorisation réseau supprimée",
        networkAllowListDeleteError: "Impossible de supprimer l’autorisation",
        llmEnableProvider: "Activer",
        llmDisableProvider: "Désactiver",
        llmProviderEnabled: "Provider activé",
        llmProviderDisabled: "Provider désactivé",
        accessPrimaryCta: "Ouvrir une vue Configuration disponible",
        accessBackToRun: "Revenir à Run",
        accessRecipesTitle: "Accès Studio limité",
        accessRecipesDescription:
          "Cette zone Studio demande des droits d’édition sur les recettes. Votre rôle actuel ne permet pas d’ouvrir les écrans d’authoring.",
        accessDeployTitle: "Agent réservé",
        accessDeployDescription:
          "La page Deploy demande une capacité Agent explicite. Ouvrez une autre vue Configuration ou revenez à Run.",
        accessExternalControlTitle: "Clés de l’Agent réservées",
        accessExternalControlDescription:
          "Cette zone Configuration demande une capacité Agent explicite.",
        source: "Source",
        conditionalExpression: "Expression conditionnelle",
        maxTokens: "Max tokens",
        inputLabel: "Entrée",
        outputLabel: "Sortie",
        deleteNode: "Supprimer le nœud",
        noConditionSet: "Aucune condition définie",
        trueLabel: "Vrai",
        falseLabel: "Faux",
        noPromptConfigured: "Aucun prompt configuré",
        noToolsConfigured: "Aucun outil configuré",
        moreTools: "+ {{count}} de plus",
        toolsCount: "{{count}} outils",
        recordsCount: "{{count}} enregistrements",
        dataPlaneTitle: "Plan de données",
        dataCoverageLabel: "Couverture",
        dataAvailableLabel: "Disponibles",
        dataNeedsSetupLabel: "À brancher",
        dataStatusReady: "Prêt",
        dataStatusLoadError: "Erreur de chargement",
        dataStatusUnknown: "Inconnu",
        dataInventoryStorageLoadError:
          "Échec du chargement de la configuration de stockage.",
        dataInventoryStorageUnknown: "Backend de stockage pas encore déterminé.",
        dataInventoryStorageManaged:
          "Stockage géré par la plateforme (AgentMaurice CDN).",
        deployTabSkills: "Skills",
        deployTabInternal: "Interne",
        deployTabVariables: "Variables",
        deployRuntimeLoading: "Chargement de la configuration runtime…",
        deployRuntimeSkillsPanelDescription:
          "Pilotez les skills réellement installées sur l’Agent et le catalogue de skills disponibles.",
        deployRuntimeSkillsCatalogTitle: "Catalogue skills",
        deployRuntimeSkillsCatalogDescription:
          "Installez des skills depuis le catalogue réel exposé par chatserver.",
        deployRuntimeSkillsSearchPlaceholder:
          "Rechercher une skill par nom, dépôt ou tag",
        deployRuntimeSkillsNoCatalog: "Aucune skill disponible",
        deployRuntimeSkillsNoCatalogDescription:
          "Ajoutez des skills au catalogue pour pouvoir les installer sur cet Agent.",
        deployRuntimeSkillsInstall: "Installer",
        deployRuntimeSkillsUninstall: "Désinstaller",
        deployRuntimeSkillsInstalled: "Installées runtime",
        deployRuntimeSkillsFilesCount: "{{count}} fichier(s)",
        deployRuntimeSkillsToolsCount: "{{count}} outil(s) MCP",
        deployRuntimeSkillsInstallations: "Installations",
        deployRuntimeSkillsInstallationsTitle: "Installations catalogue",
        deployRuntimeSkillsInstallationsDescription:
          "Ces lignes viennent de SkillInstallation et indiquent les packages installés pour cet Agent.",
        deployRuntimeSkillsNoInstallations: "Aucune installation catalogue.",
        deployRuntimeSkillsNoInstallationsDescription:
          "Les installations apparaîtront ici après ajout depuis le catalogue réel.",
        deployRuntimeSkillsCatalogCount: "Catalogue",
        deployRuntimeSkillsInstalledTitle: "État réel du runtime",
        deployRuntimeSkillsInstalledDescription:
          "Cette liste vient de chatserver et reflète les skills effectivement disponibles sur l’Agent.",
        deployRuntimeSkillsNoInstalled: "Aucune skill installée dans le runtime.",
        deployRuntimeSkillsNoInstalledDescription:
          "Installez une skill depuis le catalogue réel ou importez un SKILL.md dans cet Agent.",
        deployRuntimeSkillsVerified: "Vérifiée",
        deployRuntimeSkillsInactive: "Inactive",
        deployRuntimeSkillsNotInstalled: "Non installée",
        deployRuntimeSkillsInstallSuccess:
          "Skill {{skillName}} installée sur l’Agent.",
        deployRuntimeSkillsInstallError:
          "Impossible d’installer la skill {{skillName}}.",
        deployRuntimeSkillsUninstallSuccess:
          "Skill {{skillName}} désinstallée de l’Agent.",
        deployRuntimeSkillsUninstallError:
          "Impossible de désinstaller la skill {{skillName}}.",
        deployRuntimeSkillsUninstallConfirm:
          "Désinstaller la skill {{skillName}} de cet Agent ?",
        deployRuntimeSkillsGitHubImportTitle: "Installer depuis GitHub",
        deployRuntimeSkillsGitHubImportDescription:
          "Collez l’URL d’un repository ou d’un dossier GitHub contenant un SKILL.md. Les fichiers Markdown du dossier sont importés dans cet Agent.",
        deployRuntimeSkillsGitHubUrlPlaceholder:
          "https://github.com/owner/repo/tree/main/skills/ma-skill",
        deployRuntimeSkillsGitHubBranchPlaceholder: "Branche (optionnel)",
        deployRuntimeSkillsGitHubPathPlaceholder: "Dossier (optionnel)",
        deployRuntimeSkillsGitHubIdPlaceholder: "ID skill (optionnel)",
        deployRuntimeSkillsGitHubOverwrite: "Remplacer si la skill existe déjà",
        deployRuntimeSkillsGitHubImport: "Importer",
        deployRuntimeSkillsGitHubImporting: "Import…",
        deployRuntimeSkillsGitHubUrlRequired:
          "Renseignez une URL GitHub contenant un SKILL.md.",
        deployRuntimeSkillsGitHubImportSuccess:
          "Skill {{skillName}} importée depuis GitHub.",
        deployRuntimeSkillsGitHubImportError:
          "Impossible d’importer cette skill depuis GitHub.",
        deployRuntimeSkillsFootnoteTitle: "Quand utiliser des skills",
        deployRuntimeSkillsFootnoteDescription:
          "Utilisez des skills pour exposer des workflows spécialisés au build sans surcharger les recettes standards de l’Agent.",
        agentControlTitle: "Contrôle agent-native",
        agentControlDescription: "Supervisez les accès des agents de code, les approbations humaines Agent Spec et les clés temporaires associées.",
        agentAccessKindAgent: "Agent de code",
        agentAccessKindCli: "MauriceCLI",
        agentAccessTitle: "Accès des agents de code",
        agentAccessDescription:
          "Liens bootstrap émis pour les agents de code et MauriceCLI. Révoquer un lien révoque aussi sa clé temporaire.",
        agentAccessNoActiveLinks: "Aucun lien bootstrap actif.",
        agentAccessRevokedLinks: "Liens révoqués",
        agentControlSeeAlso: "Vues associées",
        agentControlOpenAgentSpec: "Plan et approbation → Agent Spec",
        agentControlOpenObserve: "Apply et vérification → Agent Spec",
        agentDiscoveryBootstrapRevoked: "Accès agent révoqué",
        agentDiscoveryBootstrapRevokeError: "Impossible de révoquer cet accès",
        cliBootstrapRevoked: "Accès MauriceCLI révoqué",
        cliBootstrapRevokeError: "Impossible de révoquer cet accès MauriceCLI",
        deployRuntimeApiKeyExpiresAt: "Expire le",
        deployRuntimeInternalDescription:
          "Prépare les services internes de l’Agent : stockage des artefacts, recherche documentaire, mémoire métier, multimodal, messagerie et contrôle expert.",
        deployRuntimeUnsavedChanges: "Modifications non enregistrées",
        deployRuntimeSavedState: "Enregistré",
        deployRuntimeResetDraft: "Annuler les changements",
        deployRuntimeSaving: "Enregistrement…",
        deployRuntimeStorage: "Storage",
        deployRuntimeCompanyMemory: "Company memory",
        deployRuntimeEnabled: "Activé",
        deployRuntimeDisabled: "Désactivé",
        deployRuntimeStorageCardDescription:
          "Choisit où le runtime conserve les fichiers produits, imports, exports et artefacts longs. Laissez désactivé si l’Agent ne manipule pas de fichiers persistants.",
        deployRuntimeStorageDisabled: "Désactivé",
        deployRuntimeStorageLocalS3: "Stockage S3 local",
        deployRuntimeStorageS3Compatible: "S3 compatible",
        deployRuntimeStorageAgentMauriceCdn: "AgentMaurice CDN",
        deployRuntimeStorageUnavailable: "indisponible",
        deployRuntimeStorageUnavailableMessage:
          "Ce provider n’est pas disponible sur ce runtime. Sélectionnez un stockage local/S3 compatible pour enregistrer.",
        deployRuntimeConfigureS3: "Configurer S3",
        deployRuntimeDocstoreCardDescription:
          "Ajoute une couche documentaire interne pour déposer, indexer et retrouver des fichiers dans les workflows qui travaillent sur des contrats, manuels ou bases de connaissance.",
        deployRuntimeCompanyMemoryCardDescription:
          "Expose une mémoire métier structurée aux recettes et outils pour conserver faits, décisions et contexte d’organisation entre les sessions.",
        deployRuntimeBrain: "Brain",
        deployRuntimeBrainCardDescription:
          "Active le MCP Brain local pour interroger une base DuckDB dédiée quand un Agent doit raisonner sur des données locales sans passer par un service externe.",
        deployRuntimeMemory: "Memory",
        deployRuntimeMemoryCardDescription:
          "Active le MCP Memory local pour stocker des notes, états et souvenirs opérationnels propres à ce poste ou à cet Agent.",
        deployRuntimeCompanyMemoryReadyDocker:
          "Company Memory est actif via le sidecar Docker de cet Agent.",
        deployRuntimeMultimodalCardDescription:
          "Permet aux recettes et au chat d’utiliser des profils spécialisés pour analyser des images, lire des PDF, extraire de l’OCR, transcrire de l’audio ou produire des médias.",
        deployRuntimeMessagingCardDescription:
          "Ouvre l’Agent aux canaux de conversation externes comme Slack, Telegram, WhatsApp, Discord, Google Chat ou Signal, avec des comptes liés à des clés API.",
        accessPageTitle: "Accès de l’Application",
        accessPageDescription:
          "Qui peut ouvrir cette Application, ses clés machine et les endpoints que son runtime a le droit d’appeler.",
        accessTabPeople: "Personnes",
        accessTabKeys: "Clés",
        accessTabNetwork: "Réseau",
        accessPeopleHint:
          "Seules ces personnes voient l’Application en Run. Ce n’est pas un rôle métier.",
        accessPeopleEmpty: "Personne n’a encore accès à cette Application.",
        accessPeoplePick: "Ajouter une personne",
        accessPeopleAdd: "Ajouter",
        accessAudienceTitle: "Qui entre dans l’Application",
        accessAudienceListed: "Personnes listées",
        accessAudienceListedHint:
          "Seules les personnes de la liste ci-dessous entrent dans l’Application.",
        accessAudienceOrganization: "Tous les membres de l’organisation",
        accessAudienceOrganizationHint:
          "Chaque membre de l’organisation entre, y compris ceux qui la rejoindront, en plus des personnes listées.",
        accessAudienceOrganizationNote:
          "Tous les membres de l’organisation entrent dans cette Application : retirer quelqu’un de la liste ne lui retire pas l’accès tant qu’il est membre de l’organisation.",
        accessAudienceConfirmOrganizationTitle: "Ouvrir l’Application à tous les membres ?",
        accessAudienceConfirmOrganizationDescription:
          "Chaque membre de l’organisation, y compris ceux qui la rejoindront, pourra entrer dans « {{name}} ». La liste des personnes est conservée, mais retirer quelqu’un de la liste ne lui retirera plus l’accès tant qu’il est membre.",
        accessAudienceConfirmListedTitle: "Réserver l’Application aux personnes listées ?",
        accessAudienceConfirmListedDescription:
          "Seules les personnes de la liste pourront entrer dans « {{name}} ». Les membres de l’organisation qui ne sont pas listés perdent l’accès ; personne n’est retiré de la liste.",
        accessAudienceConfirm: "Confirmer",
        accessAudienceCancel: "Annuler",
        accessAudienceSaved: "Audience de l’Application mise à jour.",
        accessPeopleHintOrganization:
          "Personnes nommées explicitement. Elles gardent l’accès si l’Application revient aux personnes listées.",
        applicationAccessDeniedTitle: "Cette Application ne vous est pas ouverte",
        applicationAccessDeniedDescription:
          "Vous n’êtes pas membre de cette Application. Choisissez-en une autre dans l’arbre, ou demandez l’accès à un administrateur.",
        accessNetworkNeedsEntrypoint:
          "Choisissez un Agent d’entrée chat dans la Revue pour configurer le réseau.",
        selectApplicationFirst: "Choisissez une Application dans l’arbre.",
        toolsPageDescription:
          "Serveurs MCP et Skills que cet Agent peut appeler. Connecteurs et secrets ont leur propre feuille.",
        channelsPageTitle: "Canaux",
        channelsPageDescription:
          "Comptes de messagerie externes de cette Application, portés par l’Agent d’entrée chat.",
        channelsNeedEntrypoint:
          "Choisissez un Agent d’entrée chat dans la Revue pour brancher les canaux.",
        channelsAdvancedTitle: "Passerelles et runtime avancé",
        scheduleSelectWorkflow: "Workflow",
        snapshotTitle: "Import / Export de l’Agent",
        snapshotDescription:
          "Transférez la configuration d’un Agent entre instances via un snapshot chiffré.",
        snapshotExportTitle: "Exporter un snapshot",
        snapshotExportDescription:
          "Générez une archive JSON chiffrée contenant la configuration de l’Agent.",
        snapshotImportTitle: "Importer un snapshot",
        snapshotImportDescription:
          "Importez un snapshot JSON en création ou en écrasement contrôlé.",
        snapshotPassphrase: "Phrase secrète",
        snapshotPassphrasePlaceholder: "Saisir une phrase secrète forte",
        snapshotIncludeRegistryDefinitions:
          "Inclure les définitions de registry pour l’auto-création à l’import",
        snapshotExportAction: "Exporter le snapshot",
        snapshotExportSuccess: "Snapshot de l’Agent exporté.",
        snapshotExportError: "Impossible d’exporter le snapshot.",
        snapshotImportFromFile: "Depuis un fichier",
        snapshotImportFromJson: "Depuis JSON",
        snapshotSelectedFile: "Fichier sélectionné",
        snapshotJson: "Snapshot JSON",
        snapshotJsonPlaceholder: "Collez ici l’enveloppe JSON exportée.",
        snapshotImportMode: "Mode d’import",
        snapshotImportCreate: "Créer un nouvel Agent",
        snapshotImportOverwrite: "Écraser un Agent existant",
        snapshotTargetDeployment: "Agent cible",
        snapshotDryRun: "Dry-run sans appliquer",
        snapshotLaunchAfterImport: "Lancer après import",
        snapshotRedeployAfterImport: "Redéployer après import",
        snapshotAllowRegistryAutoCreate:
          "Autoriser l’auto-création des entrées registry",
        snapshotDryRunAction: "Tester l’import",
        snapshotImportAction: "Importer le snapshot",
        snapshotImportResult: "Résultat d’import",
        snapshotImportDryRunSuccess: "Dry-run terminé.",
        snapshotImportSuccess: "Snapshot importé.",
        snapshotImportError: "Impossible d’importer le snapshot.",
        mailCatcherTitle: "Routes email",
        mailCatcherDescription:
          "Associez des adresses inbound à des recettes pour déclencher automatiquement des workflows par email.",
        mailCatcherDisabledBadge: "Non disponible",
        mailCatcherDisabledTitle: "Email inbound désactivé",
        mailCatcherDisabledDescription:
          "Mail Catcher dépend d’EmailConnect et restera désactivé tant que le service payant, les quotas, la sécurité webhook et le dispatch vers les VMs ne sont pas prêts en production.",
        spacesTitle: "Espaces collaboratifs",
        spacesDescription:
          "Gérez les espaces rattachés à l’Agent, leurs sessions et leur usage collaboratif.",
        spacesCreate: "Créer un espace",
        spacesCount: "Espaces",
        spacesMembersCount: "Membres",
        spacesSessionsCount: "Sessions",
        spacesNoSpaces: "Aucun espace",
        spacesNoSpacesDescription:
          "Créez un espace pour organiser les sessions et collaborations de l’Agent.",
        spacesMembersLabel: "membre(s)",
        spacesSessionsLabel: "session(s)",
        spacesCreatedAt: "Créé",
        spacesCreateTitle: "Créer un espace",
        spacesCreateDescription:
          "L’espace sera rattaché à l’Agent courant.",
        spacesName: "Nom",
        spacesDescriptionLabel: "Description",
        spacesDeleteTitle: "Supprimer l’espace",
        spacesDeleteDescription:
          "L’espace {{name}} et ses sessions associées seront supprimés.",
        spacesCreateSuccess: "Espace créé.",
        spacesCreateError: "Impossible de créer l’espace.",
        spacesDeleteSuccess: "Espace supprimé.",
        spacesDeleteError: "Impossible de supprimer l’espace.",
        deployRuntimeMessagingTitle: "Comptes messaging",
        deployRuntimeMessagingDescription:
          "Connectez des canaux externes à l’Agent et associez-les à une clé d’API dédiée.",
        deployRuntimeMessagingAddAccount: "Ajouter un compte",
        deployRuntimeMessagingAccountsCount: "Comptes",
        deployRuntimeMessagingApiKeysAvailable: "Clés API disponibles",
        deployRuntimeMessagingWebhookChannels: "Canaux webhook",
        deployRuntimeMessagingNoAccounts: "Aucun compte messaging",
        deployRuntimeMessagingNoAccountsDescription:
          "Ajoutez au moins un canal si cet Agent doit recevoir ou émettre des messages métier.",
        deployRuntimeMessagingCopyWebhook: "Copier le webhook",
        deployRuntimeMessagingWebhookCopied: "Webhook copié.",
        deployRuntimeMessagingWebhookCopyError:
          "Impossible de copier le webhook.",
        deployRuntimeMessagingEditAccount: "Modifier le compte",
        deployRuntimeMessagingCreateAccount: "Créer un compte",
        deployRuntimeMessagingDialogDescription:
          "Configurez le canal, le compte et les secrets nécessaires pour ce transport.",
        deployRuntimeMessagingChannel: "Canal",
        deployRuntimeMessagingSelectChannel: "Choisir un canal",
        deployRuntimeMessagingStatus: "Statut",
        deployRuntimeMessagingStatusActive: "Actif",
        deployRuntimeMessagingStatusDisabled: "Désactivé",
        deployRuntimeMessagingStatusInvalid: "Invalide",
        deployRuntimeMessagingAccountId: "Identifiant de compte",
        deployRuntimeMessagingDisplayName: "Nom affiché",
        deployRuntimeMessagingDisplayNamePlaceholder: "Bot principal",
        deployRuntimeMessagingExternalId: "Identifiant externe",
        deployRuntimeMessagingExternalIdPlaceholder: "Optionnel",
        deployRuntimeMessagingApiKeyLabel: "Clé API",
        deployRuntimeMessagingApiKeyPlaceholder: "Sélectionner une clé API",
        deployRuntimeMessagingApiKeyPlaceholderEdit:
          "Laisser vide pour conserver la clé actuelle",
        deployRuntimeMessagingApiKeyHelperEdit:
          "Ne sélectionnez une nouvelle clé API que si vous souhaitez remplacer celle déjà liée.",
        deployRuntimeMessagingNoExpiration: "Sans expiration",
        deployRuntimeMessagingConfigSection: "Configuration du canal",
        deployRuntimeMessagingSecretInfo:
          "Les secrets existants ne sont jamais préremplis.",
        deployRuntimeMessagingSecretPlaceholder:
          "Laisser vide pour conserver la valeur actuelle",
        deployRuntimeMessagingSecretHelperEdit:
          "Laissez vide pour conserver le secret déjà stocké.",
        deployRuntimeMessagingDeleteAccount: "Supprimer le compte",
        deployRuntimeMessagingDeleteAccountDescription:
          "Le compte {{name}} sera supprimé du gateway messaging.",
        deployRuntimeMessagingChannelRequired: "Le canal est requis.",
        deployRuntimeMessagingAccountIdRequired:
          "L’identifiant du compte est requis.",
        deployRuntimeMessagingFieldRequired: "Le champ {{field}} est requis.",
        deployRuntimeMessagingApiKeyRequired:
          "Une clé API est requise pour créer un compte messaging.",
        deployRuntimeMessagingCreateSuccess: "Compte messaging créé.",
        deployRuntimeMessagingCreateError:
          "Impossible de créer le compte messaging.",
        deployRuntimeMessagingUpdateSuccess: "Compte messaging mis à jour.",
        deployRuntimeMessagingUpdateError:
          "Impossible de mettre à jour le compte messaging.",
        deployRuntimeMessagingDeleteSuccess: "Compte messaging supprimé.",
        deployRuntimeMessagingDeleteError:
          "Impossible de supprimer le compte messaging.",
        deployRuntimeMessagingConnectionWebhook: "Webhook",
        deployRuntimeMessagingConnectionPolling: "Polling",
        deployRuntimeMessagingConnectionWebsocket: "WebSocket",
        deployRuntimeMessagingConfigKeys: "Clés de configuration",
        deployRuntimeMessagingCapabilities: "Fonctionnalités interactives",
        deployRuntimeMessagingRichUI: "Interface enrichie",
        deployRuntimeMessagingRichUIDescription:
          "Utilise les cartes, boutons et listes natifs disponibles sur ce canal.",
        deployRuntimeMessagingWorkflowInteractions: "Interactions Workflow",
        deployRuntimeMessagingWorkflowInteractionsDescription:
          "Autorise les formulaires et approbations Workflow depuis ce compte.",
        deployRuntimeMessagingRichUIEnabled: "UI enrichie active",
        deployRuntimeMessagingRichUIDisabled: "UI enrichie inactive",
        deployRuntimeMessagingWorkflowsEnabled: "Workflows actifs",
        deployRuntimeMessagingWorkflowsDisabled: "Workflows inactifs",
        deployRuntimeMessagingManageIdentities: "Liaisons",
        deployRuntimeMessagingGenerateLinkCode: "Générer un code",
        deployRuntimeMessagingLinkCode: "Code de liaison",
        deployRuntimeMessagingCopyLinkCode: "Copier le code de liaison",
        deployRuntimeMessagingLinkCodeCopied: "Code de liaison copié.",
        deployRuntimeMessagingLinkCodeCopyError: "Impossible de copier le code.",
        deployRuntimeMessagingLinkCodeError: "Impossible de générer le code de liaison.",
        deployRuntimeMessagingLinkCodeExpiresIn: "Expire dans {{seconds}} s",
        deployRuntimeMessagingLinkCodeExpired: "Expiré",
        deployRuntimeMessagingLinkedIdentities: "Identités liées",
        deployRuntimeMessagingNoIdentities: "Aucune identité liée à ce compte.",
        deployRuntimeMessagingIdentitiesError: "Impossible de charger les identités liées.",
        deployRuntimeMessagingLinkedAt: "Liée le {{date}}",
        deployRuntimeMessagingRevoke: "Révoquer",
        deployRuntimeMessagingRevokeIdentity: "Révoquer cette identité",
        deployRuntimeMessagingIdentityRevoked: "Liaison révoquée.",
        deployRuntimeMessagingIdentityRevokeError: "Impossible de révoquer cette liaison.",
        deployRuntimeMessagingChannelTelegram: "Telegram",
        deployRuntimeMessagingChannelSlack: "Slack",
        deployRuntimeMessagingChannelWhatsapp: "WhatsApp",
        deployRuntimeMessagingChannelDiscord: "Discord",
        deployRuntimeMessagingChannelGooglechat: "Google Chat",
        deployRuntimeMessagingChannelSignal: "Signal",
        deployRuntimeMessagingChannelUnknown: "Canal inconnu",
        deployRuntimeMessagingFieldBotToken: "Bot token",
        deployRuntimeMessagingFieldPollInterval: "Intervalle de poll (s)",
        deployRuntimeMessagingFieldAllowedUpdates: "Allowed updates",
        deployRuntimeMessagingFieldSigningSecret: "Signing secret",
        deployRuntimeMessagingFieldBotUserId: "Bot user ID",
        deployRuntimeMessagingFieldAccessToken: "Access token",
        deployRuntimeMessagingFieldPhoneNumberId: "Phone number ID",
        deployRuntimeMessagingFieldAppSecret: "App secret",
        deployRuntimeMessagingFieldVerifyToken: "Verify token",
        deployRuntimeMessagingFieldApiBaseUrl: "API base URL",
        deployRuntimeMessagingFieldApiVersion: "API version",
        deployRuntimeMessagingFieldIntents: "Intents",
        deployRuntimeMessagingFieldVerificationToken: "Verification token",
        deployRuntimeMessagingFieldBaseUrl: "Base URL",
        deployRuntimeMessagingFieldNumber: "Numéro",
        deployRuntimeMessagingFieldWebhookSecret: "Secret de signature webhook",
        deployRuntimeMqttCardDescription:
          "Expose un pont MQTT pour recevoir ou publier des événements temps réel, utile pour IoT, supervision, automations terrain et systèmes qui parlent déjà MQTT.",
        deployRuntimeExternalInceptionCardDescription:
          "Branche l’Agent sur une instance Inception externe afin de piloter des opérations expertes, d’inspecter le runtime et de déléguer des actions d’administration contrôlées.",
        deployRuntimeShellCardDescription:
          "Expose les capacités shell pour les flows locaux et les outils experts.",
        deployRuntimeInternalSaved: "Configuration interne enregistrée.",
        deployRuntimeInternalSaveError:
          "Impossible d’enregistrer la configuration interne.",
        deployRuntimeS3DialogDescription:
          "Renseignez la connexion S3 utilisée comme stockage par cet Agent.",
        deployRuntimeS3Endpoint: "Endpoint",
        deployRuntimeS3Region: "Région",
        deployRuntimeS3Bucket: "Bucket",
        deployRuntimeS3AccessKey: "Access key",
        deployRuntimeS3SecretKey: "Secret key",
        deployRuntimeS3Cdn: "URL CDN publique",
        deployRuntimeS3UseSsl: "Utiliser SSL",
        deployRuntimeS3Required: "L’endpoint et l’access key S3 sont requis.",
        deployRuntimeS3Created: "Configuration S3 créée.",
        deployRuntimeS3CreateError: "Impossible de créer la configuration S3.",
        deployRuntimeS3Updated: "Configuration S3 mise à jour.",
        deployRuntimeS3UpdateError:
          "Impossible de mettre à jour la configuration S3.",
        deployRuntimeS3Deleted: "Configuration S3 supprimée.",
        deployRuntimeS3DeleteError:
          "Impossible de supprimer la configuration S3.",
        deployRuntimeMultimodalSaved: "Configuration multimodale enregistrée.",
        deployRuntimeMultimodalSaveError:
          "Impossible d’enregistrer la configuration multimodale.",
        deployRuntimeMultimodalDeleted: "Configuration multimodale supprimée.",
        deployRuntimeMultimodalDeleteError:
          "Impossible de supprimer la configuration multimodale.",
        deployRuntimeMultimodalDefaultsSaved:
          "Multimodal AgentMaurice activé.",
        deployRuntimeMultimodalDefaultsError:
          "Impossible d’activer le multimodal AgentMaurice.",
        deployRuntimeConfigureMultimodal: "Configurer le multimodal",
        deployRuntimeMultimodalDialogDescription:
          "Activez le mode AgentMaurice géré ou configurez une clé personnelle.",
        deployRuntimeMultimodalManagedMode: "AgentMaurice géré",
        deployRuntimeMultimodalByokMode: "Clé personnelle",
        deployRuntimeMultimodalManagedTitle: "Multimodal AgentMaurice",
        deployRuntimeMultimodalManagedDescription:
          "Active les capacités vision, document, audio et vidéo sans clé personnelle. La consommation est facturée en crédits AgentMaurice.",
        deployRuntimeMultimodalManagedCapabilities:
          "Vision, documents, transcription audio et vidéo",
        deployRuntimeMultimodalManagedActivate: "Activer le multimodal",
        deployRuntimeMultimodalManagedActivating: "Activation…",
        deployRuntimeMultimodalHostedBadge: "AgentMaurice géré",
        deployRuntimeMultimodalByokBadge: "Clé personnelle",
        deployRuntimeMultimodalBaseUrlInvalid:
          "L’URL de base doit être une URL http(s) valide.",
        deployRuntimeMultimodalExistingConfigs: "Configurations existantes",
        deployRuntimeMultimodalAddConfig: "Ajouter une configuration",
        deployRuntimeMultimodalEditConfig: "Modifier la configuration",
        deployRuntimeMultimodalFormDescription:
          "Définissez une capacité, un provider et un modèle pour ce profil.",
        deployRuntimeMultimodalCapability: "Capacité",
        deployRuntimeMultimodalProfile: "Profil",
        deployRuntimeMultimodalProvider: "Provider",
        deployRuntimeMultimodalModel: "Modèle",
        deployRuntimeMultimodalSelectModel: "Sélectionner un modèle",
        deployRuntimeMultimodalNoCompatibleModels:
          "Aucun modèle compatible trouvé pour ce provider.",
        deployRuntimeMultimodalBaseUrl: "URL de base",
        deployRuntimeMultimodalOrgProvider: "Provider LLM organisation",
        deployRuntimeMultimodalSelectOrgProvider: "Sélectionner un provider",
        deployRuntimeMultimodalNoOrgProviders:
          "Aucun provider organisation compatible avec credential. Déclarez-en un dans Build → LLM.",
        deployRuntimeMultimodalOrgProviderRequired:
          "Un provider LLM organisation est requis pour le multimodal BYOK.",
        deployRuntimeMultimodalModelRequired:
          "Le modèle multimodal est requis.",
        deployRuntimeMultimodalNoConfigs:
          "Aucune configuration multimodale enregistrée.",
        deployRuntimeMultimodalDeleteConfig:
          "Supprimer la configuration multimodale",
        deployRuntimeMultimodalDeleteDescription:
          "La configuration {{capability}} / {{profile}} sera supprimée.",
        deployRuntimeVariablesPanelDescription:
          "Gérez les variables et secrets injectés automatiquement pendant l’exécution des recettes.",
        deployRuntimeVariablesCount: "Variables",
        deployRuntimeVariableSecretCount: "Secrets",
        deployRuntimeVariableScopedCount: "Scopées",
        deployRuntimeVariableSharedCount: "Globales",
        deployRuntimeVariablesList: "Variables de l’Agent",
        deployRuntimeVariablesListDescription:
          "Ajoutez ici les clés API, identifiants et constantes nécessaires à cet Agent.",
        deployRuntimeAddVariable: "Ajouter une variable",
        deployRuntimeNoVariables: "Aucune variable configurée.",
        deployRuntimeNoVariablesDescription:
          "Les variables permettent de stocker des secrets et constantes injectés automatiquement dans les recettes.",
        deployRuntimeCreateVariable: "Créer une variable",
        deployRuntimeEditVariable: "Modifier la variable",
        deployRuntimeDeleteVariable: "Supprimer la variable",
        deployRuntimeDeleteVariableDescription:
          "La variable {{name}} sera retirée de l’Agent. Cette action est immédiate.",
        deployRuntimeVariableDialogDescription:
          "Définissez le nom, la valeur et le scope de cette variable pour l’Agent.",
        deployRuntimeVariableName: "Nom",
        deployRuntimeVariableValue: "Valeur",
        deployRuntimeVariableValueOptional:
          "Laisser vide pour conserver la valeur existante",
        deployRuntimeVariableSecret: "Masquer la valeur comme secret",
        deployRuntimeVariableDescriptionLabel: "Description",
        deployRuntimeVariableRecipeScope: "Scope recettes",
        deployRuntimeVariableRecipeScopeDescription:
          "Laissez vide pour partager la variable avec toutes les recettes, ou sélectionnez seulement celles qui en ont besoin.",
        deployRuntimeVariableAvailableRecipes: "Recettes disponibles",
        deployRuntimeVariableRecipeScopeAll: "Toutes les recettes",
        deployRuntimeVariableRecipeScopeEmpty:
          "Aucune recette déployée pour le moment. La variable restera partagée à l’échelle de l’Agent.",
        deployRuntimeVariableNameRequired: "Le nom de la variable est requis.",
        deployRuntimeVariableValueRequired:
          "La valeur de la variable est requise.",
        deployRuntimeVariableCreated: "Variable créée.",
        deployRuntimeVariableCreateError: "Impossible de créer la variable.",
        deployRuntimeVariableUpdated: "Variable mise à jour.",
        deployRuntimeVariableUpdateError:
          "Impossible de mettre à jour la variable.",
        deployRuntimeVariableDeleted: "Variable supprimée.",
        deployRuntimeVariableDeleteError:
          "Impossible de supprimer la variable.",
        deployRuntimeVariableAllRecipes: "Toutes les recettes",
        deployRuntimeVariableAllRecipesDescription:
          "Disponible pour toutes les recettes de cet Agent.",
        deployRuntimeVariableScopedRecipes: "Scope limité",
        deployRuntimeVariableShow: "Afficher",
        deployRuntimeVariableHide: "Masquer",
        deployRuntimeVariableSecretBadge: "Secret",
        deployRuntimeVariableDescription:
          "Expliquez brièvement à quoi sert cette variable.",
        deployRuntimeVariablesUsageTitle: "Bonnes pratiques",
        deployRuntimeVariablesUsage1:
          "Réservez les secrets aux valeurs sensibles comme les clés API et mots de passe.",
        deployRuntimeVariablesUsage2:
          "Utilisez le scope recettes pour limiter les variables à certains workflows.",
        deployRuntimeVariablesUsage3:
          "Préférez des noms explicites et stables pour faciliter la maintenance.",
        deployRuntimeVariablesInjectedDescription:
          "Ces variables seront injectées automatiquement dans les exécutions de l’Agent.",
        openTasks: "Tâches ouvertes",
        timeline: "Chronologie",
        artifacts: "Artefacts",
        sourceGraph: "Graphe de sources",
        degraded: "Dégradé",
        loadingContext: "Chargement du contexte…",
        loadingRecipePreview: "Chargement de l’aperçu de recette…",
      },
    },
  },
  en: {
    translation: {
      apiKeys: {
        navLabel: "Agent keys",
        agentPageTitle: "Agent keys",
        agentPageDescription:
          "An Agent key calls this Agent's Workflows through the Agent route. It gives no access to any other Agent.",
        selectAgentFirst: "Choose an Agent to manage its keys.",
        applicationIntro:
          "An Application key calls the Workflows published in this Application. Grant only the permissions it needs.",
        createTitle: "New key",
        createButton: "Create an API key",
        nameLabel: "Name",
        namePlaceholder: "E.g. CRM integration",
        scopesLabel: "Permissions",
        scopesRequired: "Choose at least one permission.",
        scope: {
          surface_read: "Read the published surface",
          surface_execute: "Run published Workflows",
          chat_session: "Open conversations",
          viewer_session: "Open the Viewer",
        },
        expirationLabel: "Expiration",
        expiration30: "In 30 days",
        expiration90: "In 90 days",
        expiration365: "In one year",
        expirationNever: "Never",
        expirationCustom: "Specific date",
        expirationDateLabel: "Expiration date",
        revealedTitle: "Key “{{name}}” created",
        revealedWarning:
          "Copy this key now and store it in a vault: it will never be shown again.",
        plaintextLabel: "API key",
        copy: "Copy the key",
        copied: "Key copied",
        dismissRevealed: "I stored the key",
        listTitle: "Existing keys",
        empty: "No keys yet.",
        expiresLabel: "Expires:",
        expiredOn: "expired on {{date}}",
        noExpiration: "never",
        lastUsedLabel: "Last used:",
        neverUsed: "not used yet",
        revoke: "Revoke",
        revokeTitle: "Revoke the key “{{name}}”?",
        revokeDescription:
          "Calls that use this key will be refused immediately. This cannot be undone.",
        revokeConfirm: "Revoke the key",
        revoked: "Key revoked",
        revokeFailed: "Revocation failed.",
        createFailed: "Key creation failed.",
        loadFailed: "Unable to load the keys.",
        reviewKeysHint:
          "Calling these Workflows over HTTP requires an Application key.",
        manageKeys: "Manage keys",
      },
      workflowApi: {
        tabLabel: "API & triggers",
        httpTab: "HTTP call",
        triggersTab: "Triggers",
        keyTitle: "Required key",
        agentRouteLabel: "Agent route",
        agentKeyRequirement: "An Agent key of this Agent.",
        createAgentKey: "Create an Agent key",
        applicationRouteLabel: "Application route",
        applicationKeyRequirement:
          "An Application key with the “Run published Workflows” permission, and this Workflow published in the Application.",
        publishedIn: "Published in {{name}}.",
        createApplicationKey: "Create an Application key",
        notPublished: "This Workflow is not published in any Application.",
        publishInApplication: "Publish in an Application",
        inputTitle: "Input document",
        inputFromSchema:
          "The request body must match this schema; the examples below are derived from it.",
        inputGeneric:
          "This Workflow declares no input schema: the examples send an empty document, adapt it.",
        agentRouteTitle: "Agent route",
        applicationRouteTitle: "Application route",
        applicationRouteSyncOnly:
          "The Application route is synchronous: it waits for the execution to finish.",
        applicationSelect: "Application",
        applicationRouteUnavailable:
          "Available once the Workflow is published in an Application.",
        schedulesTitle: "Schedules",
        webhookTitle: "Incoming webhook",
        webhook: {
          intro:
            "An external service starts this published Workflow by calling a unique URL, signed with HMAC-SHA256 using a secret shown only once. No API key is needed.",
          needsPublication:
            "Publish this Workflow in an Application to create an incoming webhook.",
          createTitle: "Create a webhook",
          nameLabel: "Name",
          namePlaceholder: "CRM, contact form…",
          mappingLabel: "Input document",
          mappingBody: "The whole JSON body",
          mappingPointers: "Fields picked from the body (JSON Pointer)",
          pointersLabel: "Field mapping",
          pointersHint:
            "One line per input field: field = /path/in/the/body. A missing path leaves the field absent.",
          pointersInvalid: "Invalid line: “{{line}}”. Expected format: field = /path.",
          responseLabel: "Response",
          responseAsync: "Immediate, with the execution id",
          responseSync: "Wait for the result (bounded)",
          syncTimeoutLabel: "Maximum wait (seconds, 1 to 30)",
          responseAsyncSummary: "immediate, execution identifier",
          responseSyncSummary: "waits for the result, {{seconds}} s at most",
          rateLimitLabel: "Calls per minute limit",
          rateLimitSummary: "{{value}} calls per minute",
          rateLimitHint:
            "From 1 to {{max}} (default {{default}}). The Application stays limited to 600 calls per minute across all its webhooks.",
          constantsLabel: "Constants",
          constantsHint:
            "Fixed values added to the input document on every call. A JSON value (number, true, false, quoted text) keeps its type; anything else is text.",
          constantKeyPlaceholder: "field",
          constantValuePlaceholder: "value",
          constantKey: "Constant {{index}} name",
          constantValue: "Constant {{index}} value",
          constantRemove: "Remove constant {{index}}",
          constantAdd: "Add a constant",
          constantInvalid:
            "Invalid constant: “{{key}}”. Each constant has a unique name that does not start with __context.",
          edit: "Edit",
          editTitle: "Edit the “{{name}}” webhook",
          editIntro:
            "The URL and the secret do not change. The new settings apply to the next call.",
          save: "Save",
          saved: "Webhook updated",
          saveFailed: "The webhook update failed.",
          createButton: "Create the webhook",
          createFailed: "Webhook creation failed.",
          revealedTitle: "Webhook “{{name}}” created",
          rotatedTitle: "New secret for webhook “{{name}}”",
          revealedWarning:
            "Copy the secret now: it will never be shown again. After a rotation the previous secret stays valid for 24 hours.",
          urlLabel: "Webhook URL",
          secretLabel: "Secret",
          curlIntro:
            "Signed call example: first export the secret in the {{env}} variable.",
          listTitle: "Webhooks of this Workflow",
          empty: "No webhook for this Workflow.",
          loadFailed: "Unable to load the webhooks.",
          unnamed: "Unnamed",
          lastCall: "Last call",
          neverCalled: "Never called",
          disable: "Disable",
          enable: "Enable",
          rotate: "Rotate the secret",
          revoke: "Revoke",
          journal: "Call log",
          journalEmpty: "No call received.",
          journalFailed: "Unable to load the call log.",
          execution: "execution {{id}}",
          aggregated: "{{count}} calls grouped",
          revoked: "Webhook revoked",
          actionFailed: "The action failed.",
          rotateTitle: "Rotate the secret?",
          rotateDescription:
            "A new secret is shown once. The previous one stays valid for 24 hours, the time to update the sending service.",
          revokeTitle: "Revoke this webhook?",
          revokeDescription:
            "The URL and the secrets stop working immediately. The call log is kept. This cannot be undone.",
          status: {
            active: "Active",
            disabled: "Disabled",
            revoked: "Revoked",
          },
          outcome: {
            accepted: "Accepted",
            duplicate: "Re-delivery",
            rejected: "Refused",
          },
        },
      },
      language: {
        label: "Language",
        fr: "French",
        en: "English",
        es: "Spanish",
      },
      theme: {
        label: "Theme",
        system: "System",
        light: "Light",
        dark: "Dark",
      },
      common: {
        loading: "Loading…",
        miniappStepDone: "done",
        miniappStepCurrent: "in progress",
        miniappStepTodo: "to do",
        miniappNoData: "No data",
        miniappOther: "Other",
        miniappToneSuccess: "On track",
        miniappToneWarning: "Watch",
        miniappToneError: "Off track",
        miniappDevWarnings: "Rendering warnings (development mode)",
        close: "Close",
        cancel: "Cancel",
        create: "Create",
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        remove: "Remove",
        refresh: "Refresh",
        noDescription: "No description provided.",
        unknown: "Unknown",
        valid: "Valid",
        invalid: "Invalid",
        preview: "Preview",
        hide: "Hide",
        open: "Open",
        download: "Download",
        context: "Context",
        connecting: "Connecting…",
        active: "active",
        error: "Error",
        copy: "Copy",
        run: "Run",
        studio: "Studio",
        build: "Configuration",
        builder: "Builder",
        admin: "Admin",
      },
      integrations: {
        description:
          "Add useful connectors to the current agent, configure access and expose their tools to the AgentMaurice runtime.",
        usageTitle: "Integration credits",
        usageValue: "{{consumed}} / {{budget}} credits this month",
        addedTitle: "Added connectors",
        addedDescription:
          "Only connectors added to the current agent appear here.",
        addConnector: "Add connector",
        emptyTitle: "No connector added",
        emptyDescription:
          "Search the catalog to add a connector to the current agent.",
        connectSuccess: "Connector connected.",
        connectError: "Unable to connect.",
        addSuccess: "Connector added.",
        addError: "Unable to add connector.",
        removeSuccess: "Connector removed.",
        removeError: "Unable to remove connector.",
        disconnectSuccess: "Connector disconnected.",
        disconnectError: "Unable to disconnect.",
        settingsSuccess: "Configuration saved.",
        settingsError: "Unable to configure connector.",
        testSuccess: "Connector status: {{status}}.",
        testError: "Unable to test connector.",
        catalogError: "Unable to load connectors.",
        catalogHTTPError: "Console {{status}} on {{path}}: {{message}}",
        authMode: "Mode",
        configurationRequiredHelp:
          "Configure the connector before creating a user connection.",
        manualSupportHelp:
          "This connector requires support-assisted configuration.",
        editSettings: "Edit",
        configure: "Configure",
        reconnect: "Reconnect",
        connect: "Connect",
        test: "Test",
        tools: "Tools",
        disconnect: "Disconnect",
        remove: "Remove",
        maintainedPack: "Maintained pack",
        actionsAvailable: "Available actions",
        noActionsEnabled: "No action enabled",
        directoryTitle: "Add connector",
        directoryDescription:
          "The catalog is global, but adding a connector only enables it for the current agent.",
        searchPlaceholder: "Search Gmail, Slack, CRM…",
        allCategories: "All categories",
        allAuthModes: "All modes",
        directoryError: "Unable to load the catalog.",
        noDirectoryResults: "No connector matches this search.",
        toolPack: "Tool pack",
        add: "Add",
        loadMoreConnectors: "Show more",
        toolsTitle: "Connector tools",
        toolsDescription: "Tools projected on the current agent for {{connector}}.",
        toolsError: "Unable to load connector tools.",
        noActionsHelp:
          "No tool is projected until the connector is configured and connected on this agent.",
        managedAction: "Available action",
        customTool: "Custom tool",
        editSettingsTitle: "Edit configuration",
        configureTitle: "Configure connector",
        configureDescription: "Secret values are never shown again.",
        connectionCredentialsHelp:
          "Credentials are entered when connecting the user account.",
        setupGuide: "Setup guide",
        callbackUrl: "Callback URL",
        disabled: "Disabled",
        manualSupport: "Support required",
        configurationRequired: "Configuration required",
        connected: "Connected",
        revoked: "Revoked",
        notConnected: "Not connected",
        consoleRequiredTitle: "Connect AgentMaurice Console",
        consoleRequiredDescription:
          "Integrations authenticate against the Console with your Hanko session. Without both, the catalog and credits are unavailable.",
        consoleRequiredHankoOk: "Hanko session",
        consoleRequiredHankoMissing: "Hanko session missing",
        consoleRequiredConsoleMissing: "Console session missing",
        consoleRequiredHankoTitle: "1. Sign in with Hanko",
        consoleRequiredHankoBody:
          "Open AgentMaurice OS with Hanko auth (not local mode). Use the same email as on the Console. Accounts are created on the Console.",
        consoleRequiredConsoleTitle: "2. Open an AgentMaurice Console session",
        consoleRequiredConsoleBody:
          "Sign in to AgentMaurice Console with that account, then create or join an organization. The OS Hanko JWT must be accepted by this Console.",
        consoleRequiredCreditsTitle: "3. Get credits",
        consoleRequiredCreditsBody:
          "Hosted connectors debit the organization wallet. In the Console, open Billing and buy an AgentMaurice credit pack.",
        consoleRequiredOpenConsole: "Open AgentMaurice Console",
        consoleRequiredOpenBilling: "Buy credits",
      },
      desktopUpdate: {
        availableTitle: "New version available",
        availableDescription: "JusteMaurice {{version}} can be installed.",
        genericVersion: "latest",
        installAction: "Update",
        installing: "Installing update…",
        installError: "Unable to install the update.",
      },
      auth: {
        checking: "Checking authentication…",
        required:
          "Authentication is required before loading organizations, agents and workspaces.",
        localModeEnabled:
          "Local development mode is enabled. Authentication is handled by `chatserver`.",
        localAccount: "Local account",
        localSignIn: "Local sign in",
        signIn: "Sign in",
        createAccount: "Create account",
        loadingApp: "Loading Agent OS…",
        createAccountOnConsoleHint:
          "Account creation happens on console.agentmaurice.app.",
        signInError: "Sign-in error",
        noAccountYet: "No account yet?",
      },
      enrollment: {
        title: "Complete your AgentMaurice profile",
        subtitle:
          "Complete your profile and create your first organization before entering AgentMaurice OS.",
        subtitleProfileOnly:
          "Complete your Console profile before entering AgentMaurice OS.",
        roleHint: "Your first role in this organization will be `orga-admin`.",
        roleHintProfileOnly:
          "This profile is saved in the Console and synchronized here automatically.",
        email: "Email",
        username: "Username",
        usernamePlaceholder: "mikaelmorvan",
        firstName: "First name",
        firstNamePlaceholder: "Your first name",
        lastName: "Last name",
        lastNamePlaceholder: "Your last name",
        language: "Preferred language",
        personalOrganization: "This is a personal organization",
        personalOrganizationHint:
          "Leave the name empty if you want to use your identity as the organization name.",
        organizationName: "Organization name",
        organizationNamePlaceholder: "AgentMaurice",
        organizationNamePersonalPlaceholder:
          "Optional for a personal organization",
        submit: "Save profile",
        error: "Could not save profile.",
        validation: {
          username: "Username is required.",
          firstName: "First name is required.",
          lastName: "Last name is required.",
          language: "Preferred language is required.",
          organizationName: "Organization name is required.",
        },
      },
      welcome: {
        badge: "Express setup",
        title: "Prepare AgentMaurice OS for a first useful run.",
        subtitle:
          "We restore the organization context, create the default agent when needed, then lock the LLM access path before opening chat and Build.",
        organizationTitle: "Organization",
        organizationReady: "Organization available",
        organizationPending: "Waiting for local bootstrap",
        deploymentTitle: "Agent",
        deploymentReady: "Default agent ready",
        deploymentPending: "Agent still needs bootstrap",
        providerTitle: "LLM",
        providerChoicePending: "LLM choice missing",
        providerHosted: "AgentMaurice hosted models",
        providerHostedPending: "AgentMaurice models to initialize",
        providerReady: "Provider configured",
        providerPending: "No active provider yet",
        nextStepTitle: "Next step",
        nextStepModeChoice:
          "Choose first how you want to use LLMs: AgentMaurice models or your own API keys.",
        nextStepContext:
          "The local context is still being finalized. Rerun bootstrap to pull the console organization and create the default workspace.",
        nextStepDeployment:
          "The organization is ready, but the default user agent is still missing. Refresh the context to create it.",
        nextStepProvider:
          "The context is ready. Configure your API keys now to unlock chat and Build.",
        nextStepHostedPending:
          "The context is ready. Initialize the AgentMaurice LLM profile to create the provider, model, and agent selection.",
        nextStepHosted:
          "The context is ready. AgentMaurice models are available on this instance without any additional key setup.",
        nextStepReady:
          "Everything is ready on this machine. You can enter chat or switch to Build without any extra setup.",
        stepConsoleTitle: "Context",
        stepConsoleDescription:
          "AgentMaurice OS first restores your organization context and prepares the active workspace.",
        stepProviderTitle: "Provider",
        stepProviderDescription:
          "Choose the LLM mode that fits your usage, then, in user-key mode, test the configuration before saving it.",
        stepLaunchTitle: "Launch",
        stepLaunchDescription:
          "Once the mode is ready, chat and Build become usable on this machine.",
        modeTitle: "Choose your LLM access",
        modeDescription:
          "You must choose between AgentMaurice models and your own API keys before using the instance.",
        modeLabel: "LLM mode",
        modeHostedTitle: "AgentMaurice models",
        modeHostedDescription:
          "Use the models provided by AgentMaurice. No personal key is required on this machine.",
        modeByokTitle: "My own keys",
        modeByokDescription:
          "Use your own providers. Until the keys are configured, chat and Build stay locked.",
        modeChoiceRequiredTitle: "Choice required",
        modeChoiceRequiredDescription:
          "Until you choose an LLM mode, the instance stays in setup and the main flows remain locked.",
        modeLockedTitle: "LLM configuration already defined",
        modeLockedHostedDescription:
          "This organization uses AgentMaurice models. Other users on this VM do not need to repeat LLM onboarding.",
        modeLockedByokDescription:
          "This organization already uses a BYOK provider. Other users on this VM do not need to enter keys again.",
        hostedTitle: "Use AgentMaurice models",
        hostedDescription:
          "This instance can use AgentMaurice models directly. You do not need to enter any API key.",
        hostedPanelTitle: "AgentMaurice LLM is active",
        hostedPanelDescription:
          "The agent uses an organization-scoped AgentMaurice LLM profile. No user secret is required inside AgentMaurice OS.",
        hostedPanelPendingTitle: "Initialize the AgentMaurice profile",
        hostedPanelPendingDescription:
          "AgentMaurice OS will create or reuse the organization AgentMaurice provider, add a default model, create a profile, and select it for this agent.",
        hostedNoKeyRequired: "No user key required",
        hostedPendingNoKey: "No user key required",
        hostedActivateButton: "Initialize AgentMaurice",
        hostedActivating: "Initializing…",
        hostedActivateSuccess: "AgentMaurice LLM profile initialized.",
        hostedActivateError: "Could not initialize the AgentMaurice LLM profile.",
        byokPanelTitle: "BYOK provider active",
        byokPanelDescription:
          "The organization already has an LLM configuration. To change it, use Build > LLM with the required permissions.",
        formTitle: "Connect your LLM",
        formDescription:
          "One setup is enough. Secrets stay in the local backend and the provider is attached to the default agent.",
        readyBadge: "Ready",
        setupBadge: "Setup required",
        providerNameLabel: "Display name",
        modelLabel: "Model",
        apiKeyLabel: "API key",
        apiKeyOptionalLabel: "API key (optional)",
        apiKeyPlaceholder: "sk-...",
        urlRequiredLabel: "URL / endpoint",
        urlOptionalLabel: "URL / endpoint (optional)",
        urlPlaceholder: "https://...",
        advancedTitle: "Advanced settings",
        hideAdvanced: "Hide",
        showAdvanced: "Show",
        systemPromptLabel: "System prompt",
        systemPromptPlaceholder:
          "Optional. Leave empty to keep the default prompt.",
        maxCompletionTokensLabel: "Max completion tokens",
        diagnosticOk: "Connection validated",
        diagnosticError: "The test failed",
        testing: "Testing…",
        testButton: "Test",
        saving: "Saving…",
        primaryButton: "Test and start",
        refreshing: "Refreshing…",
        refreshButton: "Refresh context",
        continueChat: "Continue to chat",
        openBuild: "Open Studio",
        readyHint:
          "The workspace is ready. You can enter chat now or open Build to start shaping the agent.",
        readyHintHosted:
          "The workspace is ready and AgentMaurice models are available. You can go straight to chat or Build.",
        pendingHint:
          "Choose an LLM mode first, then make sure the organization and agent are ready before continuing.",
        pendingHintByok:
          "Until your API keys are tested and saved, chat and Build remain locked.",
        pendingHintHosted:
          "Initialize the AgentMaurice profile to unlock chat and Build without entering an API key.",
        testSuccess: "Provider connection validated.",
        testError: "Could not validate the provider connection.",
        saveSuccess: "Configuration saved.",
        saveError: "Could not save the configuration.",
        contextRefreshed: "Local context refreshed.",
        contextRefreshError: "Could not refresh the local context.",
        statusError: "Could not load setup status.",
        agentDiscoveryTitle: "Connect a code agent",
        agentDiscoveryDescription:
          "Choose a no-install prompt or a MauriceCLI command for the Git-native Agent Spec V2 rail. Both paths keep External Inception guided, temporary, and auditable.",
        agentDiscoveryBadge: "External Inception",
        codeAgentPromptMode: "MCP connection without installation (`amb_`)",
        codeAgentCLIMode: "MauriceCLI connection (`amc_`)",
        codeAgentPromptModeHint:
          "Copy an MCP setup prompt. Its `amb_` URL must never be passed to `maurice agent connect`.",
        codeAgentCLIModeHint:
          "Copy the `maurice agent connect` command. It configures the client and starts the Agent Spec V2 rail in the local Git project.",
        agentDiscoveryReadyHint:
          "The prompt does not contain the final key. The agent must call the bootstrap URL to receive the `agentmaurice.agent_connection/v2` contract.",
        agentDiscoveryUnavailableHint:
          "You do not have sufficient permissions to generate this prompt.",
        agentDiscoveryHumanApprovalHint:
          "The code agent prepares the plan but cannot approve it. Approval of the exact hash remains a separate human action in AgentMaurice OS.",
        agentDiscoveryGenerate: "Generate prompt",
        agentDiscoveryGenerating: "Generating…",
        agentDiscoveryCopy: "Copy prompt",
        agentDiscoveryGenerated: "Agent prompt generated.",
        agentDiscoveryGenerateError: "Could not generate the agent prompt.",
        agentDiscoveryInvalidBootstrap: "The server did not return a valid `amb_` MCP connection.",
        agentDiscoveryCopied: "Agent prompt copied.",
        agentDiscoveryCopyError: "Could not copy the agent prompt.",
        agentDiscoveryPrompt:
          "You are going to connect this code agent to an AgentMaurice instance.\n\nIMPORTANT — MCP setup only (`amb_`): never pass this URL to `maurice agent connect`. That command requires an `amc_` MauriceCLI bootstrap generated by AgentMaurice OS.\n\n1. Call this bootstrap URL exactly once:\n{{url}}\n\n2. Verify that the returned JSON has `$schema: agentmaurice.agent_connection/v2`, `schema_version: 2`, `bootstrap_kind: external_inception_mcp`, and `intended_consumer: mcp_client_setup`. Use only `organization`, `agent`, `agent_scopes`, `credential`, `mcp`, `commands`, `tools`, `policies`, `warnings`, `next_command`, and `client_setup`.\n\n3. Configure MCP with `client_setup`. Start with `inception_agent_scopes_list`, then call `inception_agent_doctor` with no arguments: its response is compact by default; use `full:true` only for an explicitly requested expert diagnostic. Then call `inception_mcp_capabilities`. Never infer an Agent target from its human name: use `agent_alias` or `agent_id` from `agent_scopes`.\n\n4. For every change, use only this rail: `inception_agent_spec_init` when needed → `inception_agent_spec_pull` → edit the Git-native files → `inception_agent_spec_check` → `inception_agent_spec_plan`. Present the immutable plan and its `plan_hash`, then stop.\n\n5. Approval must be recorded by an authenticated human in AgentMaurice OS or in a separate human session. As an agent or service, do not call `inception_agent_spec_approve` and never attempt to self-approve. After confirmation that human approval has been recorded, call `inception_agent_spec_apply` with the approved plan, then `inception_agent_spec_verify`.\n\n6. Never request, display, or write raw secrets; use secret references only.",
        cliBootstrapReadyHint:
          "The command configures the client and local project; changes then follow init/pull/check/plan, human approval, apply, and verify.",
        cliBootstrapUnavailableHint:
          "You do not have sufficient permissions to generate this command.",
        cliBootstrapEnvLabel: "Environment",
        cliBootstrapKindLabel: "Kind",
        cliBootstrapClientLabel: "Agent client",
        cliBootstrapAliasLabel: "Agent alias",
        cliBootstrapDirLabel: "Directory",
        cliBootstrapJoinExistingLabel: "Reconnect to an existing project",
        cliBootstrapJoinExistingDescription:
          "Adds `--join-existing` to renew local access without rewriting or exporting the project's Agent Spec files.",
        bootstrapScopesTitle: "Linked agents",
        bootstrapScopesDescription:
          "Add only the agents this agent or CLI should be allowed to target explicitly.",
        bootstrapScopesNone:
          "No other agent is available in this context.",
        bootstrapScopeAlias: "Alias",
        bootstrapScopeRole: "Role",
        bootstrapScopeRuntimeDependency: "Runtime dependency",
        bootstrapScopeManaged: "Managed",
        cliBootstrapGenerate: "Generate command",
        cliBootstrapGenerating: "Generating…",
        cliBootstrapCopy: "Copy command",
        cliBootstrapGenerated: "MauriceCLI command generated.",
        cliBootstrapGenerateError: "Could not generate the MauriceCLI command.",
        cliBootstrapInvalidCommand: "The server did not return a valid V2 `maurice agent connect` command.",
        cliBootstrapCopied: "MauriceCLI command copied.",
        cliBootstrapCopyError: "Could not copy the MauriceCLI command.",
        cliBootstrapKind: {
          development: "Development",
          preproduction: "Preproduction",
          production: "Production",
          sandbox: "Sandbox",
          integration_test: "Integration test",
        },
        cliBootstrapClient: {
          "claude-code": "Claude Code",
          codex: "Codex",
          cursor: "Cursor",
          windsurf: "Windsurf",
          generic: "Generic MCP",
        },
      },
      operateSetup: {
        missingOrganizationTitle: "Organization required",
        missingOrganizationDescription:
          "This view needs an active organization before it can load runtime content.",
        missingDeploymentTitle: "Agent required",
        missingDeploymentDescription:
          "Select or create an active agent before opening runtime screens.",
        missingSpaceTitle: "Workspace required",
        missingSpaceDescription:
          "The agent is ready, but no workspace is active in this session yet. Go back to the welcome screen to finish the setup.",
        noSpaceTitle: "No workspace is ready for this agent",
        noSpaceDescription:
          "This instance does not yet have a usable workspace for the current agent. Finish the welcome flow before opening chat.",
        loadingSpacesTitle: "Loading workspaces…",
        loadingSpacesDescription:
          "Checking available workspaces for the current agent before opening chat.",
        openWelcome: "Open welcome",
        createSpace: "Create a workspace",
        creatingSpace: "Creating workspace…",
        createSpaceError: "Could not create a workspace for this agent.",
        escalateChiefOfStaff: "Continue in Studio with the Chief of Staff",
        escalateChiefOfStaffHint:
          "This Agent does not have the requested capability yet. The Chief of Staff will prepare it in Studio.",
        openCatalog: "Open catalog",
        openHistory: "Open history",
        completeSetupToStart:
          "Finish the welcome flow to unlock chat and runtime screens",
      },
      shell: {
        toggleContextPanel: "Toggle context panel",
        toggleRightPanel: "Toggle right panel (Ctrl/Cmd+Shift+\\)",
        openNavigation: "Open navigation",
        closeNavigation: "Close navigation",
        resizeNavigationPanel: "Resize navigation panel",
        resizeContextPanel: "Resize context panel",
        executionDetailTitle: "Execution detail",
        executionDetailDescription: "Context for the selected run.",
        emptyContextDescription:
          "The shell keeps this area ready for inspection, execution details and contextual previews.",
      },
      sidebar: {
        recipes: "Recipes",
        data: "Data",
        deployments: "Agents",
        chiefOfStaff: "Chief of Staff",
        applications: "Applications",
        agentStudio: "Studio",
        travail: "Work",
        travailInbox: "Inbox",
        travailActivity: "Activity",
        noApplications: "No applications",
        applicationReview: "Review",
        organization: "Organization",
        orgAccessMap: "Access rights",
        orgGates: "Machine gates",
        orgMembers: "Members & directory",
        orgVault: "Vault & events",
        orgUsage: "Usage & billing",
        orgImportExport: "Import / export",
        agentModels: "Models",
        models: "Models",
        mcp: "MCP",
        skills: "Skills",
        agentConfig: "Settings",
        tools: "Tools",
        channels: "Channels",
        importExport: "Import / Export",
        mailCatcher: "Mail Catcher",
        spaces: "Spaces",
        chat: "Chat",
        catalog: "Catalog",
        history: "History",
        spacesSessions: "Spaces & sessions",
        newSession: "New session",
        sessionActions: "Session actions",
        renameSession: "Rename",
        renameSessionTitle: "Rename session",
        renameSessionDescription:
          "Change the name shown in the session list.",
        renameSessionNameRequired: "Session name is required.",
        renameSessionSuccess: "Session renamed.",
        renameSessionError: "Unable to rename the session.",
        deleteSession: "Delete",
        deleteSessionTitle: "Delete session",
        deleteSessionDescription:
          "Session {{name}} will be permanently deleted.",
        deleteSessionSuccess: "Session deleted.",
        deleteSessionError: "Unable to delete the session.",
        sessionName: "Session name",
        unnamedSession: "Session",
        noSessionYet: "No session yet.",
        localProfile: "Local profile",
        userProfile: "User profile",
        account: "Account",
        access: "Access",
        osVersion: "AgentMaurice OS",
        appearance: "Appearance",
        profileSecurity: "Security",
        localAuthentication: "Local authentication",
        hankoAuthentication: "Secure authentication",
        hankoProfileDescription:
          "Manage the identity, sign-in methods, and AgentMaurice context for this session.",
        hankoProfileLoadError: "Unable to load account security.",
        localSignOutHint:
          "Signing out returns you to the local account picker.",
        hankoSignOutHint:
          "Signing out ends the local session on this device.",
        confirmSignOutTitle: "Confirm sign out",
        confirmSignOutDescription:
          "You are about to end the current session on this device.",
        confirmSwitchUserDescription:
          "You are about to leave this local profile and return to the account picker.",
        switchUser: "Switch user",
        signOut: "Sign out",
        consoleBinding: "Console binding",
        consoleBindingDescription:
          "Bind this installation to a console instance without changing the local backend or SQLite database.",
        consoleBound: "Bound",
        consoleUnbound: "Unbound",
        consoleUrl: "Console",
        consoleInstance: "Instance",
        consoleOrganization: "Organization",
        consoleUser: "Console user",
        consoleLastSync: "Last update {{value}}",
        consolePair: "Bind",
        consoleReconnect: "Bind again",
        consoleDetach: "Detach",
        consoleDetachConfirm:
          "Detach this installation from the console and reload the application?",
        consoleDetached: "Console binding removed. Reloading…",
        consolePairingIntro:
          "Enter the console URL, then start the device flow binding.",
        consolePairingStart: "Start binding",
        consolePairingCancel: "Cancel",
        consolePairingUrlPlaceholder: "https://console.agentmaurice.app",
        consolePairingPending:
          "Open this URL in your browser and enter the following code.",
        consoleVerificationUrl: "Verification URL",
        consoleUserCode: "Code",
        consoleCheckingStatus: "Waiting for approval…",
        consolePairingExpires: "Expires in {{count}} s",
        consolePairingExpired: "The binding code expired. Start pairing again.",
        consolePaired: "Installation bound to {{instance}}. Reloading…",
        consolePairingFailed: "Console binding failed.",
        consoleReloadHint:
          "The organization context will reload automatically after bind or detach.",
      },
      contextSwitcher: {
        selectOrganization: "Select organization",
        selectDeployment: "Select agent",
        organization: "Organization",
        orgId: "Org ID",
        notSelected: "Not selected",
        loadingContext: "Loading context…",
        createApplicationTitle: "Create application",
        createApplicationDescription:
          "An Application groups Agents and publishes an external access surface.",
        createApplicationKeyLabel: "Application key",
        createApplicationKeyPlaceholder: "salon-client",
        createApplicationNameLabel: "Display name",
        createApplicationNamePlaceholder: "Customer portal",
        createApplicationConfirm: "Create application",
        createApplicationSubmitting: "Creating…",
        createApplicationSuccess: "Application {{name}} created.",
        createApplicationFailed: "Unable to create the Application.",
        createApplicationKeyRequired: "Application key is required.",
        createApplicationAgentsLabel: "Member Agents",
        createApplicationAgentsHint:
          "Select the Agents to include in this Application.",
        createApplicationNoAgents: "No Agents available in this organization.",
        createApplicationMembersPartial:
          "Application created, but some Agents could not be added.",
        createDeploymentTitle: "Create agent",
        createDeploymentSubmitting: "Creating…",
        createDeploymentNoOrganization: "Select an organization first.",
      },
      compose: {
        emptyApplications: "No Application yet. Create one from the Studio tree.",
        selectOrganization: "Select an organization.",
        selectApplicationHint: "Choose an Application in the Studio tree.",
        sectionSurface: "Surface",
        sectionRun: "Run",
        loadFailed: "Unable to load Applications.",
        members: "Members (Agents)",
        noAgents: "No Agent members yet.",
        selectAgent: "Select an Agent",
        addAgent: "Add",
        removeAgent: "Remove",
        agentAdded: "Agent added to the Application.",
        agentAddFailed: "Unable to add the Agent.",
        agentRemoved: "Agent removed from the Application.",
        agentRemoveFailed: "Unable to remove the Agent.",
        chatEntrypoint: "Chat entrypoint (optional)",
        noChatEntrypoint: "No chat",
        runLLM: "Model used by this Application",
        runLLMHint: "Portable slug:model ref (e.g. hosted:gpt-4o-mini). Empty = org.run profile.",
        mcpGrants: "MCP grants (Run tools)",
        mcpGrantsHint: "One tool per line. Empty = no extra narrowing.",
        saveRunConfig: "Save Run / grants",
        runConfigSaved: "Run configuration saved.",
        runConfigSaveFailed: "Failed to save Run / grants.",
        surfaceWorkflows: "Public workflows",
        surfaceWorkflowsHint:
          "Select Workflows from member Agents to expose. None selected = nothing published.",
        surfaceWorkflowsUnavailable: "No longer available on the Agent",
        surfaceWorkflowsLoadFailed: "Unable to load member Workflows.",
        saveSurface: "Save draft",
        publishSurface: "Publish (semver minor)",
        surfaceSaved: "Surface saved.",
        surfaceSaveFailed: "Failed to save surface.",
        surfacePublished: "Surface published.",
        surfacePublishFailed: "Failed to publish surface.",
        publishedVersion: "Published version: {{version}}",
      },
      chat: {
        headerTitle: "Chat with Maurice",
        presenceLabel: "People in this session",
        presenceYou: "you",
        invite: {
          button: "Invite",
          title: "Invite to the discussion",
          hint: "Only people who have access to the Application are listed. The invitee gets this discussion only, not the other discussions of the space.",
          loading: "Loading people…",
          empty: "Everyone who has access to the Application already has this discussion.",
          listLabel: "People to invite",
          pending: "Inviting",
          retry: "Retry",
          success: "{{name}} now has this discussion: it shows in their Run.",
          alreadyMember: "{{name}} already has this discussion.",
          participantsTitle: "People invited",
          participantsEmpty: "Nobody is invited into this discussion yet.",
          remove: "Remove",
          removeLabel: "Remove {{name}} from the discussion",
          removing: "Removing",
          removed: "{{name}} no longer has this discussion.",
          errors: {
            run_invitee_not_application_person: "This person has no access to the Application.",
            run_session_not_found: "Discussion not found, or you do not take part in it.",
            run_session_not_invitable: "This discussion cannot be shared from this Application.",
            run_participant_removal_forbidden: "Only the author of the invitation and the owner of the space can remove this person.",
            application_access_denied: "You have no access to this Application.",
            unknown: "The invitation could not be loaded or sent. Try again.",
          },
        },
        recipeLabel: "Workflow: {{name}}",
        recipeBadge: "Context",
        chooseRecipe: "Choose a Workflow",
        skillsButton: "Skills",
        debugMessages: "Debug",
        showTechnicalMessages: "Show tool calls and raw results",
        hideTechnicalMessages: "Hide tool calls and raw results",
        skillsSessionLabel: "Session skills",
        skillsPanelTitle: "Session skills",
        skillsPanelDescription:
          "Select agent skills to enrich the current session.",
        skillsLoading: "Loading skills…",
        skillsLoadingError: "Failed to load agent skills.",
        noSelectedSkills: "No skill selected for this session.",
        noDeploymentSkills: "No skill is installed on this agent.",
        useSkill: "Use",
        skillSelected: "Selected",
        clearSkills: "Clear skills",
        skillsCleared: "Session skills cleared.",
        skillNotFound: "Skill not found: {{skill}}",
        skillAdded: "{{skill}} added to the session.",
        skillRemoved: "{{skill}} removed from the session.",
        noSkillPreview: "No preview available for this skill.",
        execution: "Execution",
        connectionErrorTitle: "Connection error",
        connectionErrorDescription:
          "The chat connection failed. Try again; if the problem persists, contact your administrator.",
        serverErrorTitle: "Service error",
        serverErrorDescription:
          "The service ran into an error. Your message was not lost; try again shortly.",
        serviceTimeoutTitle: "The service is taking too long to respond",
        serviceTimeoutDescription:
          "Temporary service problem, unrelated to the Workflow. Try again shortly.",
        errorRetryAction: "Retry",
        errorTechnicalDetailsToggle: "Technical details",
        sessionPausedTitle: "Session paused",
        sessionPausedDescription: "The session was paused after a period of inactivity.",
        resumeConversation: "Resume conversation",
        sessionReplacedOtherApplication:
          "This discussion belongs to another Application, so a new discussion was opened here. Its history stays in its Application.",
        sessionReplacedUnavailable:
          "The requested discussion is not available in this Application, so a new discussion was opened.",
        sessionReplacedDismiss: "Hide this message",
        accessRemovedTitle: "Your access to this discussion was removed",
        accessRemovedDescription:
          "You can no longer read or write in this discussion. To come back, ask a person who manages the Application to invite you again.",
        accessRemovedPlaceholder: "Access removed",
        applicationNotOpenPlaceholder: "Application not open to you",
        messageFeed: "Chat message feed",
        loadingHistory: "Loading history…",
        loadingOlderMessages: "Loading older messages…",
        startConversation: "Start a conversation",
        readyForMessage: "Ready when you are",
        askAboutRecipe: "Ask Maurice anything about this Workflow",
        askAboutWorkspace: "Ask Maurice anything about this workspace",
        latest: "Latest",
        createSessionToStart: "Create or select a session to start.",
        askMaurice: "Ask Maurice…",
        noExecutionContext: "No execution context available yet",
        noActiveSessionToClear: "No active session to clear",
        sessionHistoryCleared: "Session history cleared",
        failedToClearSession: "Failed to clear session",
        clearSessionTitle: "Clear session",
        clearSessionDescription:
          "This will remove the full history of the current chat session.",
        clearHistory: "Clear history",
        helpMessage: [
          "Available commands:",
          "",
          "- `/status` open the execution context",
          "- `/workflow` open the Workflow picker",
          "- `/tools` ask Maurice for the tools available in this context",
          "- `/skills` open the skills panel",
          "- `/use-skill <id>` select a skill for the session",
          "- `/clear-skills` clear the selected skills",
          "- `/help` show this help",
          "- `/clear` delete the current session history",
        ].join("\n"),
        recipeContextHint:
          "Following messages stay framed by this Workflow.",
        llmActivityThinking: "Maurice is thinking...",
        llmActivityTool: "Maurice is using a tool...",
        llmActivitySkill: "Maurice is applying a skill...",
        llmActivityProject: "Maurice is working on the project...",
      },
      chatInput: {
        openStatusContext: "Open status context",
        openStatusContextDescription:
          "Ask for the current execution or agent status",
        launchRecipe: "Launch a Workflow",
        launchRecipeDescription:
          "Open the Workflow picker or target a Workflow command",
        showHelp: "Show help",
        showHelpDescription: "Display available slash commands",
        showTools: "Show tools",
        showToolsDescription:
          "Ask Maurice for the tools available in this context",
        openSkills: "Open skills",
        openSkillsDescription:
          "Display agent skills and the current session selection",
        useSkill: "Use a skill",
        useSkillDescription: "Select a skill to enrich the next messages",
        clearSkills: "Clear skills",
        clearSkillsDescription:
          "Remove all selected skills from the current session",
        clearSession: "Clear session",
        clearSessionDescription: "Delete the current session history",
        changeRecipe: "Change",
        messageLabel: "Your message",
        quickActions: "Quick actions",
        shortcutHint:
          "Use slash commands or the Workflow picker to frame the session quickly.",
        stop: "Stop",
      },
      files: {
        attach: "Attach a file",
        attached: "{{filename}} added to the message",
        uploadFailed: "File upload failed",
        uploadProgress: "Upload {{progress}}%",
        attachedFile: "Attached file",
      },
      recipePicker: {
        title: "Select a blueprint",
        description:
          "Launch the conversation with a specific Workflow context, or keep the chat generic.",
        searchPlaceholder: "Search Workflows...",
        loading: "Loading Workflows…",
        noMatch: "No Workflow matches this search.",
        noDescription: "No description provided.",
      },
      recipeForm: {
        fallbackTitle: "Workflow form",
        fallbackDescription:
          "The running Workflow needs additional input before it can continue.",
        selectOption: "Select…",
        submit: "Submit form",
        submitting: "Submitting…",
        fieldRequired: "{{field}} is required.",
        restoreError: "Unable to reopen this Workflow form.",
      },
      chatMessage: {
        resourcePreview: "Resource preview",
        previewTruncated: "Preview truncated.",
        result: "Result",
        logs: "Logs",
        userMessage: "User message",
        peerMessage: "Message from {{name}}",
        assistantMessage: "Assistant message",
        technicalMessage: "Technical message",
      },
      executionPanel: {
        title: "Execution status",
        completedCount: "{{done}}/{{total}} completed",
        running: "Running...",
        progress: "Progress",
        overallProgress: "Overall progress",
        stepProgress: "{{step}} progress",
      },
      executionResult: {
        title: "Result",
        refresh: "Refresh result",
        copy: "Copy result",
        loading: "Loading result…",
        empty: "No result available.",
        expired:
          "The Workflow finished, but the detailed result has expired and is no longer available.",
      },
      executionLogs: {
        title: "Logs",
        refresh: "Refresh logs",
        copy: "Copy logs",
        loading: "Loading logs…",
        empty: "No log available for this execution.",
        expired:
          "The Workflow finished, but the detailed logs have expired and are no longer available.",
      },
      historyDetail: {
        rerun: "Re-run in chat",
        timeline: "Timeline",
        created: "Created",
        started: "Started",
        completed: "Completed",
        duration: "Duration",
        blueprint: "Blueprint",
        loadingBlueprint: "Loading Workflow preview…",
        noBlueprintPreview:
          "No blueprint preview is available for this execution.",
        noDescription: "No description provided.",
        noRecipe: "No Workflow is associated with this execution.",
        error: "Error",
        notAvailable: "Not available",
        pending: "Pending",
        running: "Running",
        completedStatus: "Completed",
        failed: "Failed",
        cancelled: "Cancelled",
        waitingForForm: "Response needed",
        unknownStatus: "Unknown",
        respondToForm: "Respond to form",
        resultPartial: "Partial result: the full detail is no longer available (archived or expired).",
        usageTitle: "Usage summary",
        usageSourceTrace: "Estimated",
        usageSourceMetering: "Metering",
        usageDuration: "Duration",
        usageTokens: "Tokens",
        usageEstimatedCost: "Estimated cost",
        usageActions: "Actions",
        usageFailures: "failures",
        usageLLMCalls: "LLM calls",
        usageMonetaryUnavailable: "Final monetary cost unavailable",
        usageNoData: "No usage summary available.",
        usageModelBreakdown: "Models",
      },
      catalog: {
        title: "Actions catalog",
        description: "Choose a Workflow to start a conversation with Maurice",
        searchPlaceholder: "Search Workflows...",
        all: "All",
        resultsTitle: "All Workflows",
        resultsDescription: "{{count}} Workflow(s) visible in this agent.",
        resultsFilteredBy: "Filtered by {{category}}",
        resultsAllVisible: "Full view",
        launchableTitle: "Ready to launch",
        launchableDescription:
          "These Workflows are ready and can open a new session immediately.",
        launchableCount: "{{count}} ready",
        buildRequiredTitle: "Needs Studio review",
        buildRequiredDescription:
          "These Workflows already exist, but still need an Agent Spec pass before they should be launched.",
        buildRequiredCount: "{{count}} to finish",
        loading: "Loading Workflows...",
        error: "Error",
        noRecipes: "No Workflows available",
        noRecipesHint:
          "Create and apply a Workflow with Agent Spec to get started",
        noSearchMatch: "No Workflows match your search",
        clearFilters: "Clear filters",
      },
      travail: {
        inboxTitle: "Inbox",
        inboxDescription:
          "Plans and threads waiting for a human decision. This is not another inbox.",
        inboxEmpty: "Nothing to handle for this Agent.",
        activityTitle: "Activity",
        activityDescription:
          "Durable Agent jobs, Workflow executions, and Studio closeouts in one place.",
        activityEmpty: "No recent activity for this Agent.",
        openThread: "Open thread",
        openExecution: "Open execution",
        summary: "Summary",
        trajectory: "Trajectory",
        evidence: "Evidence",
        blockedThread: "Blocked thread",
        preparedPlan: "Plan to review",
        context: "Context",
        closeout: "Studio closeout",
      },
      history: {
        title: "Execution history",
        description: "View past Workflow executions and results",
        searchPlaceholder: "Search by Workflow or execution ID...",
        all: "All",
        metricsTotal: "Total",
        metricsTotalHint: "Loaded executions",
        metricsSuccess: "Successful",
        metricsSuccessHint: "Finished without blockers",
        metricsAttention: "Needs fixes",
        metricsAttentionHint: "Require intervention",
        metricsRerunnable: "Rerunnable",
        metricsRerunnableHint: "Can restart in chat",
        surfaceHint:
          "Review recent runs and open their details without depending on a pre-filled context panel.",
        loading: "Loading history...",
        error: "Error",
        noExecutions: "No executions found",
        noExecutionsHint: "Start a conversation to see execution history",
        loadMore: "Load more",
        pending: "Pending",
        running: "Running",
        completed: "Completed",
        failed: "Failed",
        cancelled: "Cancelled",
        waitingForForm: "Response needed",
        unknownStatus: "Unknown",
        openDetails: "Open details",
        respondToForm: "Respond",
        rerun: "Run again in chat",
        executionLabel: "Execution",
        startedLabel: "Started",
        durationLabel: "Duration",
        usageLabel: "Usage",
        signalLabel: "Signal",
        readinessReview: "Ready for review",
        readinessFix: "Needs fixes",
        readinessRerunnable: "Rerunnable",
        readinessRunning: "Active tracking",
        readinessQueued: "Queued",
        readinessWaitingForm: "Response needed",
        readinessUnknown: "Unknown state",
        nextStepLabel: "Next step",
        nextStepRerun:
          "Open the details, then relaunch quickly if you want to compare or start over.",
        nextStepFix:
          "Inspect the error, fix the Workflow, then relaunch it from chat.",
        nextStepReview: "This run was cancelled: review the context before relaunching.",
        nextStepWatch:
          "Follow the progress in detail or wait until the run finishes.",
        nextStepQueue:
          "Wait for the full start before relaunching or intervening.",
        nextStepRespond: "Respond to the form so the execution can resume.",
        nextStepUnknown:
          "This state is not recognized by the interface: check the details before acting.",
        groupAttentionTitle: "Needs fixes",
        groupAttentionDescription:
          "These runs failed or stalled and need action before you relaunch them.",
        groupActiveTitle: "In progress",
        groupActiveDescription:
          "These runs are still progressing in the runtime and mainly need monitoring.",
        groupWaitingTitle: "Response needed",
        groupWaitingDescription:
          "These runs are waiting for a human response to a form before they can resume.",
        groupQueuedTitle: "Queued",
        groupQueuedDescription:
          "These runs already exist but have not fully started yet.",
        groupUnknownTitle: "Unknown state",
        groupUnknownDescription:
          "These runs have a state the interface does not recognize yet.",
        groupSuccessTitle: "Successful",
        groupSuccessDescription:
          "These runs are complete, reviewable, and often ready to rerun.",
        pendingSummary: "This execution is still waiting for a full start.",
        runningSummary: "This execution is still progressing in the runtime.",
        completedSummary: "This run is complete and ready for review.",
        failedSummary: "This run failed and needs a targeted review.",
        cancelledSummary: "This run was cancelled before it finished.",
        waitingForFormSummary: "This execution is waiting for a form response.",
        unknownSummary: "Execution state not recognized by the interface.",
      },
      recipeCard: {
        active: "Active",
        draft: "Draft",
        noDescription: "No description provided",
        launchNow: "Launch now",
        openInBuild: "Open in Studio",
        inspectBlueprint: "Inspect blueprint",
        launchHint: "Opens a new execution session directly.",
        buildHint: "Use Agent Spec to finish or apply this Workflow.",
        workflow: "Workflow",
        miniapp: "MiniApp",
        moreTags: "+{{count}}",
      },
      filePreview: {
        image: "Image",
        document: "Document",
        file: "File",
        noPreviewUrl: "No preview URL available for this file.",
        loadingPreview: "Loading preview…",
        noInlinePreview: "No inline preview available for this file.",
      },
      commandPalette: {
        title: "Command palette",
        description:
          "Search application commands or ask Calisto to act on the current agent.",
        placeholder: "Search commands or ask Calisto...",
        noCommands: "No commands found.",
        newThread: "New thread",
        newThreadDescription: "Open the Studio thread creation dialog",
        continueInStudio: "Continue in Studio",
        continueInStudioDescription: "Resume from Application review",
        travailInbox: "Inbox",
        travailInboxDescription: "Open the Work inbox",
      },
      build: {
        llmOrgCatalogDescription:
          "Providers and credentials shared by every Agent of the organization.",
        llmOrgProvidersTitle: "Providers",
        llmOrgProvidersEmpty: "No provider configured.",
        llmOrgRolesLiveUnderAgent:
          "The models used by chat, Studio and embeddings are chosen under each Agent › Settings › Models.",
        llmAgentSelectAgent: "Select an Agent to choose its models.",
        llmAgentModelsHeading: "Agent models",
        llmAgentModelsDescription:
          "Models used by chat, by AgentMaurice Studio and by embeddings for this Agent, picked from the organization catalogue.",
        llmOpenOrgCatalog: "Catalogue",
        questionNode: "Question",
        questionMore: "+ {{count}} more — inspect configuration",
        questionCriteria: "Criteria",
        questionConfidence: "Minimum confidence",
        networkAllowListBadge: "Network security",
        networkAllowListTitle: "Outbound network access",
        networkAllowListDescription: "Explicitly allow the endpoints this Agent's Deno code may call. Changes apply to subsequent executions.",
        networkAllowListAddTitle: "Allow a URL",
        networkAllowListAddDescription: "The host, scheme and effective port are extracted automatically. The path and token are never stored in this list.",
        networkAllowListURLLabel: "URL to allow",
        networkAllowListURLPlaceholder: "https://devmachine.example.com/callback",
        networkAllowListEntryDescriptionLabel: "Description",
        networkAllowListDescriptionPlaceholder: "DevMachine callback",
        networkAllowListAllow: "Allow",
        networkAllowListEntriesTitle: "Allowed endpoints",
        networkAllowListEntriesDescription: "These permissions are scoped to the selected Agent and injected into its Deno sandbox.",
        networkAllowListEmpty: "No external endpoint is allowed.",
        networkAllowListSubdomains: "HTTP subdomains",
        networkAllowListDelete: "Delete permission",
        networkAllowListSaveSuccess: "Network endpoint allowed",
        networkAllowListSaveError: "Could not allow this endpoint",
        networkAllowListDeleteSuccess: "Network permission deleted",
        networkAllowListDeleteError: "Could not delete the permission",
        llmEnableProvider: "Enable",
        llmDisableProvider: "Disable",
        llmProviderEnabled: "Provider enabled",
        llmProviderDisabled: "Provider disabled",
        accessPrimaryCta: "Open an available Configuration view",
        accessBackToRun: "Back to Run",
        accessRecipesTitle: "Limited Studio access",
        accessRecipesDescription:
          "This Studio area requires recipe authoring permissions. Your current role cannot open the authoring screens.",
        accessDeployTitle: "Deploy access required",
        accessDeployDescription:
          "The Deploy page requires explicit agent rights. Open another available Configuration view or go back to Run.",
        accessExternalControlTitle: "Agent keys are restricted",
        accessExternalControlDescription:
          "This Configuration area requires explicit agent rights.",
        source: "Source",
        conditionalExpression: "Conditional expression",
        maxTokens: "Max tokens",
        inputLabel: "Input",
        outputLabel: "Output",
        deleteNode: "Delete node",
        noConditionSet: "No condition set",
        trueLabel: "True",
        falseLabel: "False",
        noPromptConfigured: "No prompt configured",
        noToolsConfigured: "No tools configured",
        moreTools: "+ {{count}} more",
        toolsCount: "{{count}} tools",
        recordsCount: "{{count}} records",
        dataPlaneTitle: "Data plane",
        dataCoverageLabel: "Coverage",
        dataAvailableLabel: "Available",
        dataNeedsSetupLabel: "Needs setup",
        dataStatusReady: "Ready",
        dataStatusLoadError: "Load error",
        dataStatusUnknown: "Unknown",
        dataInventoryStorageLoadError: "Failed to load the storage configuration.",
        dataInventoryStorageUnknown: "Storage backend not yet determined.",
        dataInventoryStorageManaged: "Storage managed by the platform (AgentMaurice CDN).",
        deployTabSkills: "Skills",
        deployTabInternal: "Internal",
        deployTabVariables: "Variables",
        deployRuntimeLoading: "Loading runtime configuration…",
        deployRuntimeSkillsPanelDescription:
          "Manage the skills actually installed on this agent and the available skills catalog.",
        deployRuntimeSkillsCatalogTitle: "Skills catalog",
        deployRuntimeSkillsCatalogDescription:
          "Install skills from the real catalog exposed by chatserver.",
        deployRuntimeSkillsSearchPlaceholder:
          "Search skills by name, repository, or tag",
        deployRuntimeSkillsNoCatalog: "No skills available",
        deployRuntimeSkillsNoCatalogDescription:
          "Add skills to the catalog before installing them on this agent.",
        deployRuntimeSkillsInstall: "Install",
        deployRuntimeSkillsUninstall: "Uninstall",
        deployRuntimeSkillsInstalled: "Runtime installed",
        deployRuntimeSkillsFilesCount: "{{count}} file(s)",
        deployRuntimeSkillsToolsCount: "{{count}} MCP tool(s)",
        deployRuntimeSkillsInstallations: "Installations",
        deployRuntimeSkillsInstallationsTitle: "Catalog installations",
        deployRuntimeSkillsInstallationsDescription:
          "These rows come from SkillInstallation and show packages installed for this agent.",
        deployRuntimeSkillsNoInstallations: "No catalog installation.",
        deployRuntimeSkillsNoInstallationsDescription:
          "Installations will appear here after adding a skill from the real catalog.",
        deployRuntimeSkillsCatalogCount: "Catalog",
        deployRuntimeSkillsInstalledTitle: "Real runtime state",
        deployRuntimeSkillsInstalledDescription:
          "This list comes from chatserver and reflects the skills effectively available on the agent.",
        deployRuntimeSkillsNoInstalled: "No skill installed in the runtime.",
        deployRuntimeSkillsNoInstalledDescription:
          "Install a skill from the real catalog or import a SKILL.md into this agent.",
        deployRuntimeSkillsVerified: "Verified",
        deployRuntimeSkillsInactive: "Inactive",
        deployRuntimeSkillsNotInstalled: "Not installed",
        deployRuntimeSkillsInstallSuccess:
          "Skill {{skillName}} installed on the agent.",
        deployRuntimeSkillsInstallError:
          "Failed to install skill {{skillName}}.",
        deployRuntimeSkillsUninstallSuccess:
          "Skill {{skillName}} uninstalled from the agent.",
        deployRuntimeSkillsUninstallError:
          "Failed to uninstall skill {{skillName}}.",
        deployRuntimeSkillsUninstallConfirm:
          "Uninstall skill {{skillName}} from this agent?",
        deployRuntimeSkillsGitHubImportTitle: "Install from GitHub",
        deployRuntimeSkillsGitHubImportDescription:
          "Paste a GitHub repository or folder URL containing SKILL.md. Markdown files from that folder are imported into this agent.",
        deployRuntimeSkillsGitHubUrlPlaceholder:
          "https://github.com/owner/repo/tree/main/skills/my-skill",
        deployRuntimeSkillsGitHubBranchPlaceholder: "Branch (optional)",
        deployRuntimeSkillsGitHubPathPlaceholder: "Folder (optional)",
        deployRuntimeSkillsGitHubIdPlaceholder: "Skill ID (optional)",
        deployRuntimeSkillsGitHubOverwrite: "Replace if the skill already exists",
        deployRuntimeSkillsGitHubImport: "Import",
        deployRuntimeSkillsGitHubImporting: "Importing…",
        deployRuntimeSkillsGitHubUrlRequired:
          "Enter a GitHub URL containing SKILL.md.",
        deployRuntimeSkillsGitHubImportSuccess:
          "Skill {{skillName}} imported from GitHub.",
        deployRuntimeSkillsGitHubImportError:
          "Failed to import this skill from GitHub.",
        deployRuntimeSkillsFootnoteTitle: "When to use skills",
        deployRuntimeSkillsFootnoteDescription:
          "Use skills to expose specialized build workflows without overloading the agent standard recipes.",
        agentControlTitle: "Agent-native control",
        agentControlDescription: "Supervise code-agent access, human Agent Spec approvals, and the associated temporary keys.",
        agentAccessKindAgent: "Code agent",
        agentAccessKindCli: "MauriceCLI",
        agentAccessTitle: "Code-agent access",
        agentAccessDescription:
          "Bootstrap links issued to code agents and MauriceCLI. Revoking a link also revokes its temporary key.",
        agentAccessNoActiveLinks: "No active bootstrap link.",
        agentAccessRevokedLinks: "Revoked links",
        agentControlSeeAlso: "Related views",
        agentControlOpenAgentSpec: "Plan and approval → Agent Spec",
        agentControlOpenObserve: "Apply and verification → Agent Spec",
        agentDiscoveryBootstrapRevoked: "Agent access revoked",
        agentDiscoveryBootstrapRevokeError: "Could not revoke this access",
        cliBootstrapRevoked: "MauriceCLI access revoked",
        cliBootstrapRevokeError: "Could not revoke this MauriceCLI access",
        deployRuntimeApiKeyExpiresAt: "Expires",
        deployRuntimeInternalDescription:
          "Prepares agent internal services: artifact storage, document search, business memory, multimodal processing, messaging, and expert control.",
        deployRuntimeUnsavedChanges: "Unsaved changes",
        deployRuntimeSavedState: "Saved",
        deployRuntimeResetDraft: "Discard changes",
        deployRuntimeSaving: "Saving…",
        deployRuntimeStorage: "Storage",
        deployRuntimeCompanyMemory: "Company memory",
        deployRuntimeEnabled: "Enabled",
        deployRuntimeDisabled: "Disabled",
        deployRuntimeStorageCardDescription:
          "Selects where the runtime keeps generated files, imports, exports, and long-lived artifacts. Keep it disabled when the agent does not need persistent files.",
        deployRuntimeStorageDisabled: "Disabled",
        deployRuntimeStorageLocalS3: "Local S3 storage",
        deployRuntimeStorageS3Compatible: "S3 compatible",
        deployRuntimeStorageAgentMauriceCdn: "AgentMaurice CDN",
        deployRuntimeStorageUnavailable: "unavailable",
        deployRuntimeStorageUnavailableMessage:
          "This provider is not available on this runtime. Select local/S3-compatible storage to save.",
        deployRuntimeConfigureS3: "Configure S3",
        deployRuntimeDocstoreCardDescription:
          "Adds an internal document layer to upload, index, and retrieve files for workflows that work with contracts, manuals, or knowledge bases.",
        deployRuntimeCompanyMemoryCardDescription:
          "Exposes structured business memory to recipes and tools so facts, decisions, and organization context survive across sessions.",
        deployRuntimeBrain: "Brain",
        deployRuntimeBrainCardDescription:
          "Enables the local Brain MCP to query a dedicated DuckDB store when a agent needs to reason over local data without an external service.",
        deployRuntimeMemory: "Memory",
        deployRuntimeMemoryCardDescription:
          "Enables the local Memory MCP to keep notes, state, and operational memories scoped to this machine or agent.",
        deployRuntimeCompanyMemoryReadyDocker:
          "Company Memory is active through this agent Docker sidecar.",
        deployRuntimeMultimodalCardDescription:
          "Lets recipes and chat use specialized profiles for image analysis, PDF reading, OCR extraction, audio transcription, or media generation.",
        deployRuntimeMessagingCardDescription:
          "Opens the agent to external conversation channels such as Slack, Telegram, WhatsApp, Discord, Google Chat, or Signal, with accounts bound to API keys.",
        accessPageTitle: "Application access",
        accessPageDescription:
          "Who can open this Application, its machine keys, and which endpoints its runtime may call.",
        accessTabPeople: "People",
        accessTabKeys: "Keys",
        accessTabNetwork: "Network",
        accessPeopleHint:
          "Only these people see the Application in Run. This is not a business role.",
        accessPeopleEmpty: "Nobody has access to this Application yet.",
        accessPeoplePick: "Add a person",
        accessPeopleAdd: "Add",
        accessAudienceTitle: "Who enters the Application",
        accessAudienceListed: "Listed people",
        accessAudienceListedHint:
          "Only the people in the list below enter the Application.",
        accessAudienceOrganization: "All members of the organization",
        accessAudienceOrganizationHint:
          "Every member of the organization enters, including those who join later, on top of the listed people.",
        accessAudienceOrganizationNote:
          "All members of the organization enter this Application: removing someone from the list does not remove their access while they are a member of the organization.",
        accessAudienceConfirmOrganizationTitle: "Open the Application to all members?",
        accessAudienceConfirmOrganizationDescription:
          "Every member of the organization, including those who join later, will be able to enter “{{name}}”. The list of people is kept, but removing someone from it will no longer remove their access while they are a member.",
        accessAudienceConfirmListedTitle: "Restrict the Application to the listed people?",
        accessAudienceConfirmListedDescription:
          "Only the people in the list will be able to enter “{{name}}”. Members of the organization who are not listed lose access; nobody is removed from the list.",
        accessAudienceConfirm: "Confirm",
        accessAudienceCancel: "Cancel",
        accessAudienceSaved: "Application audience updated.",
        accessPeopleHintOrganization:
          "People named explicitly. They keep their access if the Application goes back to listed people.",
        applicationAccessDeniedTitle: "This Application is not open to you",
        applicationAccessDeniedDescription:
          "You are not a member of this Application. Pick another one in the tree, or ask an administrator for access.",
        accessNetworkNeedsEntrypoint:
          "Pick a chat entrypoint Agent in Review to configure the network.",
        selectApplicationFirst: "Choose an Application in the tree.",
        toolsPageDescription:
          "MCP servers and Skills this Agent can call. Connectors and secrets have their own leaf.",
        channelsPageTitle: "Channels",
        channelsPageDescription:
          "External messaging accounts for this Application, hosted by the chat entrypoint Agent.",
        channelsNeedEntrypoint:
          "Pick a chat entrypoint Agent in Review to connect channels.",
        channelsAdvancedTitle: "Gateways and advanced runtime",
        scheduleSelectWorkflow: "Workflow",
        snapshotTitle: "Agent Import / Export",
        snapshotDescription:
          "Transfer agent settings across instances using an encrypted snapshot.",
        snapshotExportTitle: "Export snapshot",
        snapshotExportDescription:
          "Generate an encrypted JSON archive containing the agent configuration.",
        snapshotImportTitle: "Import snapshot",
        snapshotImportDescription:
          "Import a JSON snapshot by creating or overwriting a agent.",
        snapshotPassphrase: "Passphrase",
        snapshotPassphrasePlaceholder: "Enter a strong passphrase",
        snapshotIncludeRegistryDefinitions:
          "Include registry definitions for auto-create during import",
        snapshotExportAction: "Export snapshot",
        snapshotExportSuccess: "Agent snapshot exported.",
        snapshotExportError: "Failed to export agent snapshot.",
        snapshotImportFromFile: "From file",
        snapshotImportFromJson: "From JSON",
        snapshotSelectedFile: "Selected file",
        snapshotJson: "Snapshot JSON",
        snapshotJsonPlaceholder: "Paste the exported JSON envelope here.",
        snapshotImportMode: "Import mode",
        snapshotImportCreate: "Create a new agent",
        snapshotImportOverwrite: "Overwrite an existing agent",
        snapshotTargetDeployment: "Target agent",
        snapshotDryRun: "Dry-run without applying",
        snapshotLaunchAfterImport: "Launch after import",
        snapshotRedeployAfterImport: "Redeploy after import",
        snapshotAllowRegistryAutoCreate: "Allow registry auto-create",
        snapshotDryRunAction: "Test import",
        snapshotImportAction: "Import snapshot",
        snapshotImportResult: "Import result",
        snapshotImportDryRunSuccess: "Dry-run completed.",
        snapshotImportSuccess: "Snapshot imported.",
        snapshotImportError: "Failed to import snapshot.",
        mailCatcherTitle: "Email routes",
        mailCatcherDescription:
          "Bind inbound email addresses to recipes so emails can trigger workflows automatically.",
        mailCatcherDisabledBadge: "Unavailable",
        mailCatcherDisabledTitle: "Inbound email disabled",
        mailCatcherDisabledDescription:
          "Mail Catcher depends on EmailConnect and stays disabled until the paid service, quotas, webhook security, and VM dispatch are production-ready.",
        spacesTitle: "Collaborative spaces",
        spacesDescription:
          "Manage spaces attached to the agent, their sessions, and collaboration usage.",
        spacesCreate: "Create space",
        spacesCount: "Spaces",
        spacesMembersCount: "Members",
        spacesSessionsCount: "Sessions",
        spacesNoSpaces: "No spaces",
        spacesNoSpacesDescription:
          "Create a space to organize agent sessions and collaboration.",
        spacesMembersLabel: "member(s)",
        spacesSessionsLabel: "session(s)",
        spacesCreatedAt: "Created",
        spacesCreateTitle: "Create space",
        spacesCreateDescription:
          "The space will be attached to the current agent.",
        spacesName: "Name",
        spacesDescriptionLabel: "Description",
        spacesDeleteTitle: "Delete space",
        spacesDeleteDescription:
          "Space {{name}} and its associated sessions will be deleted.",
        spacesCreateSuccess: "Space created.",
        spacesCreateError: "Failed to create space.",
        spacesDeleteSuccess: "Space deleted.",
        spacesDeleteError: "Failed to delete space.",
        deployRuntimeMessagingTitle: "Messaging accounts",
        deployRuntimeMessagingDescription:
          "Connect external channels to the agent and bind them to a dedicated API key.",
        deployRuntimeMessagingAddAccount: "Add account",
        deployRuntimeMessagingAccountsCount: "Accounts",
        deployRuntimeMessagingApiKeysAvailable: "Available API keys",
        deployRuntimeMessagingWebhookChannels: "Webhook channels",
        deployRuntimeMessagingNoAccounts: "No messaging accounts",
        deployRuntimeMessagingNoAccountsDescription:
          "Add at least one channel if this agent must receive or emit business messages.",
        deployRuntimeMessagingCopyWebhook: "Copy webhook",
        deployRuntimeMessagingWebhookCopied: "Webhook copied.",
        deployRuntimeMessagingWebhookCopyError: "Failed to copy webhook.",
        deployRuntimeMessagingEditAccount: "Edit account",
        deployRuntimeMessagingCreateAccount: "Create account",
        deployRuntimeMessagingDialogDescription:
          "Configure the channel, account, and required secrets for this transport.",
        deployRuntimeMessagingChannel: "Channel",
        deployRuntimeMessagingSelectChannel: "Choose a channel",
        deployRuntimeMessagingStatus: "Status",
        deployRuntimeMessagingStatusActive: "Active",
        deployRuntimeMessagingStatusDisabled: "Disabled",
        deployRuntimeMessagingStatusInvalid: "Invalid",
        deployRuntimeMessagingAccountId: "Account ID",
        deployRuntimeMessagingDisplayName: "Display name",
        deployRuntimeMessagingDisplayNamePlaceholder: "Primary bot",
        deployRuntimeMessagingExternalId: "External ID",
        deployRuntimeMessagingExternalIdPlaceholder: "Optional",
        deployRuntimeMessagingApiKeyLabel: "API key",
        deployRuntimeMessagingApiKeyPlaceholder: "Select an API key",
        deployRuntimeMessagingApiKeyPlaceholderEdit:
          "Leave empty to keep the current key",
        deployRuntimeMessagingApiKeyHelperEdit:
          "Only select a new API key if you want to replace the one already bound.",
        deployRuntimeMessagingNoExpiration: "No expiration",
        deployRuntimeMessagingConfigSection: "Channel configuration",
        deployRuntimeMessagingSecretInfo:
          "Existing secrets are never prefilled.",
        deployRuntimeMessagingSecretPlaceholder:
          "Leave empty to keep the current value",
        deployRuntimeMessagingSecretHelperEdit:
          "Leave empty to keep the secret already stored.",
        deployRuntimeMessagingDeleteAccount: "Delete account",
        deployRuntimeMessagingDeleteAccountDescription:
          "Account {{name}} will be removed from the messaging gateway.",
        deployRuntimeMessagingChannelRequired: "Channel is required.",
        deployRuntimeMessagingAccountIdRequired: "Account ID is required.",
        deployRuntimeMessagingFieldRequired: "Field {{field}} is required.",
        deployRuntimeMessagingApiKeyRequired:
          "An API key is required to create a messaging account.",
        deployRuntimeMessagingCreateSuccess: "Messaging account created.",
        deployRuntimeMessagingCreateError:
          "Failed to create messaging account.",
        deployRuntimeMessagingUpdateSuccess: "Messaging account updated.",
        deployRuntimeMessagingUpdateError:
          "Failed to update messaging account.",
        deployRuntimeMessagingDeleteSuccess: "Messaging account deleted.",
        deployRuntimeMessagingDeleteError:
          "Failed to delete messaging account.",
        deployRuntimeMessagingConnectionWebhook: "Webhook",
        deployRuntimeMessagingConnectionPolling: "Polling",
        deployRuntimeMessagingConnectionWebsocket: "WebSocket",
        deployRuntimeMessagingConfigKeys: "Config keys",
        deployRuntimeMessagingCapabilities: "Interactive features",
        deployRuntimeMessagingRichUI: "Rich interface",
        deployRuntimeMessagingRichUIDescription:
          "Uses native cards, buttons and lists available on this channel.",
        deployRuntimeMessagingWorkflowInteractions: "Workflow interactions",
        deployRuntimeMessagingWorkflowInteractionsDescription:
          "Allows Workflow forms and approvals from this account.",
        deployRuntimeMessagingRichUIEnabled: "Rich UI enabled",
        deployRuntimeMessagingRichUIDisabled: "Rich UI disabled",
        deployRuntimeMessagingWorkflowsEnabled: "Workflows enabled",
        deployRuntimeMessagingWorkflowsDisabled: "Workflows disabled",
        deployRuntimeMessagingManageIdentities: "Identity links",
        deployRuntimeMessagingGenerateLinkCode: "Generate code",
        deployRuntimeMessagingLinkCode: "Link code",
        deployRuntimeMessagingCopyLinkCode: "Copy link code",
        deployRuntimeMessagingLinkCodeCopied: "Link code copied.",
        deployRuntimeMessagingLinkCodeCopyError: "Unable to copy the code.",
        deployRuntimeMessagingLinkCodeError: "Unable to generate a link code.",
        deployRuntimeMessagingLinkCodeExpiresIn: "Expires in {{seconds}}s",
        deployRuntimeMessagingLinkCodeExpired: "Expired",
        deployRuntimeMessagingLinkedIdentities: "Linked identities",
        deployRuntimeMessagingNoIdentities: "No identity is linked to this account.",
        deployRuntimeMessagingIdentitiesError: "Unable to load linked identities.",
        deployRuntimeMessagingLinkedAt: "Linked on {{date}}",
        deployRuntimeMessagingRevoke: "Revoke",
        deployRuntimeMessagingRevokeIdentity: "Revoke this identity",
        deployRuntimeMessagingIdentityRevoked: "Identity link revoked.",
        deployRuntimeMessagingIdentityRevokeError: "Unable to revoke this identity link.",
        deployRuntimeMessagingChannelTelegram: "Telegram",
        deployRuntimeMessagingChannelSlack: "Slack",
        deployRuntimeMessagingChannelWhatsapp: "WhatsApp",
        deployRuntimeMessagingChannelDiscord: "Discord",
        deployRuntimeMessagingChannelGooglechat: "Google Chat",
        deployRuntimeMessagingChannelSignal: "Signal",
        deployRuntimeMessagingChannelUnknown: "Unknown channel",
        deployRuntimeMessagingFieldBotToken: "Bot token",
        deployRuntimeMessagingFieldPollInterval: "Poll interval (s)",
        deployRuntimeMessagingFieldAllowedUpdates: "Allowed updates",
        deployRuntimeMessagingFieldSigningSecret: "Signing secret",
        deployRuntimeMessagingFieldBotUserId: "Bot user ID",
        deployRuntimeMessagingFieldAccessToken: "Access token",
        deployRuntimeMessagingFieldPhoneNumberId: "Phone number ID",
        deployRuntimeMessagingFieldAppSecret: "App secret",
        deployRuntimeMessagingFieldVerifyToken: "Verify token",
        deployRuntimeMessagingFieldApiBaseUrl: "API base URL",
        deployRuntimeMessagingFieldApiVersion: "API version",
        deployRuntimeMessagingFieldIntents: "Intents",
        deployRuntimeMessagingFieldVerificationToken: "Verification token",
        deployRuntimeMessagingFieldBaseUrl: "Base URL",
        deployRuntimeMessagingFieldNumber: "Number",
        deployRuntimeMessagingFieldWebhookSecret: "Webhook signing secret",
        deployRuntimeMqttCardDescription:
          "Exposes an MQTT bridge to receive or publish real-time events for IoT, monitoring, field automations, and systems that already speak MQTT.",
        deployRuntimeExternalInceptionCardDescription:
          "Connects the agent to an external Inception instance for expert operations, runtime inspection, and controlled administration actions.",
        deployRuntimeShellCardDescription:
          "Expose shell capabilities for local flows and expert tools.",
        deployRuntimeInternalSaved: "Internal configuration saved.",
        deployRuntimeInternalSaveError:
          "Failed to save internal configuration.",
        deployRuntimeS3DialogDescription:
          "Fill in the S3 connection used as storage for this agent.",
        deployRuntimeS3Endpoint: "Endpoint",
        deployRuntimeS3Region: "Region",
        deployRuntimeS3Bucket: "Bucket",
        deployRuntimeS3AccessKey: "Access key",
        deployRuntimeS3SecretKey: "Secret key",
        deployRuntimeS3Cdn: "Public CDN URL",
        deployRuntimeS3UseSsl: "Use SSL",
        deployRuntimeS3Required: "S3 endpoint and access key are required.",
        deployRuntimeS3Created: "S3 configuration created.",
        deployRuntimeS3CreateError: "Failed to create S3 configuration.",
        deployRuntimeS3Updated: "S3 configuration updated.",
        deployRuntimeS3UpdateError: "Failed to update S3 configuration.",
        deployRuntimeS3Deleted: "S3 configuration deleted.",
        deployRuntimeS3DeleteError: "Failed to delete S3 configuration.",
        deployRuntimeMultimodalSaved: "Multimodal configuration saved.",
        deployRuntimeMultimodalSaveError:
          "Failed to save multimodal configuration.",
        deployRuntimeMultimodalDeleted: "Multimodal configuration deleted.",
        deployRuntimeMultimodalDeleteError:
          "Failed to delete multimodal configuration.",
        deployRuntimeMultimodalDefaultsSaved:
          "AgentMaurice multimodal enabled.",
        deployRuntimeMultimodalDefaultsError:
          "Failed to enable AgentMaurice multimodal.",
        deployRuntimeConfigureMultimodal: "Configure multimodal",
        deployRuntimeMultimodalDialogDescription:
          "Enable AgentMaurice managed mode or configure a personal key.",
        deployRuntimeMultimodalManagedMode: "AgentMaurice managed",
        deployRuntimeMultimodalByokMode: "Personal key",
        deployRuntimeMultimodalManagedTitle: "AgentMaurice multimodal",
        deployRuntimeMultimodalManagedDescription:
          "Enables vision, document, audio, and video capabilities without a personal key. Usage is billed in AgentMaurice credits.",
        deployRuntimeMultimodalManagedCapabilities:
          "Vision, documents, audio transcription, and video",
        deployRuntimeMultimodalManagedActivate: "Enable multimodal",
        deployRuntimeMultimodalManagedActivating: "Enabling…",
        deployRuntimeMultimodalHostedBadge: "AgentMaurice managed",
        deployRuntimeMultimodalByokBadge: "Personal key",
        deployRuntimeMultimodalBaseUrlInvalid:
          "Base URL must be a valid http(s) URL.",
        deployRuntimeMultimodalExistingConfigs: "Existing configurations",
        deployRuntimeMultimodalAddConfig: "Add configuration",
        deployRuntimeMultimodalEditConfig: "Edit configuration",
        deployRuntimeMultimodalFormDescription:
          "Define a capability, provider, and model for this profile.",
        deployRuntimeMultimodalCapability: "Capability",
        deployRuntimeMultimodalProfile: "Profile",
        deployRuntimeMultimodalProvider: "Provider",
        deployRuntimeMultimodalModel: "Model",
        deployRuntimeMultimodalSelectModel: "Select a model",
        deployRuntimeMultimodalNoCompatibleModels:
          "No compatible models found for this provider.",
        deployRuntimeMultimodalBaseUrl: "Base URL",
        deployRuntimeMultimodalOrgProvider: "Organization LLM provider",
        deployRuntimeMultimodalSelectOrgProvider: "Select a provider",
        deployRuntimeMultimodalNoOrgProviders:
          "No compatible organization provider with a credential. Declare one in Build → LLM.",
        deployRuntimeMultimodalOrgProviderRequired:
          "An organization LLM provider is required for multimodal BYOK.",
        deployRuntimeMultimodalModelRequired: "A multimodal model is required.",
        deployRuntimeMultimodalNoConfigs:
          "No multimodal configuration has been saved yet.",
        deployRuntimeMultimodalDeleteConfig: "Delete multimodal configuration",
        deployRuntimeMultimodalDeleteDescription:
          "Configuration {{capability}} / {{profile}} will be deleted.",
        deployRuntimeVariablesPanelDescription:
          "Manage the variables and secrets injected automatically during recipe execution.",
        deployRuntimeVariablesCount: "Variables",
        deployRuntimeVariableSecretCount: "Secrets",
        deployRuntimeVariableScopedCount: "Scoped",
        deployRuntimeVariableSharedCount: "Shared",
        deployRuntimeVariablesList: "Agent variables",
        deployRuntimeVariablesListDescription:
          "Add the API keys, credentials, and constants required by this agent here.",
        deployRuntimeAddVariable: "Add variable",
        deployRuntimeNoVariables: "No variables configured.",
        deployRuntimeNoVariablesDescription:
          "Variables let you store secrets and constants that are injected automatically into recipes.",
        deployRuntimeCreateVariable: "Create variable",
        deployRuntimeEditVariable: "Edit variable",
        deployRuntimeDeleteVariable: "Delete variable",
        deployRuntimeDeleteVariableDescription:
          "Variable {{name}} will be removed from the agent immediately.",
        deployRuntimeVariableDialogDescription:
          "Define the name, value, and scope of this variable for the agent.",
        deployRuntimeVariableName: "Name",
        deployRuntimeVariableValue: "Value",
        deployRuntimeVariableValueOptional:
          "Leave empty to keep the existing value",
        deployRuntimeVariableSecret: "Mask the value as a secret",
        deployRuntimeVariableDescriptionLabel: "Description",
        deployRuntimeVariableRecipeScope: "Recipe scope",
        deployRuntimeVariableRecipeScopeDescription:
          "Leave empty to share the variable with every recipe, or select only the recipes that need it.",
        deployRuntimeVariableAvailableRecipes: "Available recipes",
        deployRuntimeVariableRecipeScopeAll: "All recipes",
        deployRuntimeVariableRecipeScopeEmpty:
          "No deployed recipes yet. The variable will stay shared at agent level.",
        deployRuntimeVariableNameRequired: "Variable name is required.",
        deployRuntimeVariableValueRequired: "Variable value is required.",
        deployRuntimeVariableCreated: "Variable created.",
        deployRuntimeVariableCreateError: "Failed to create variable.",
        deployRuntimeVariableUpdated: "Variable updated.",
        deployRuntimeVariableUpdateError: "Failed to update variable.",
        deployRuntimeVariableDeleted: "Variable deleted.",
        deployRuntimeVariableDeleteError: "Failed to delete variable.",
        deployRuntimeVariableAllRecipes: "All recipes",
        deployRuntimeVariableAllRecipesDescription:
          "Available to every recipe in this agent.",
        deployRuntimeVariableScopedRecipes: "Scoped",
        deployRuntimeVariableShow: "Show",
        deployRuntimeVariableHide: "Hide",
        deployRuntimeVariableSecretBadge: "Secret",
        deployRuntimeVariableDescription:
          "Explain briefly what this variable is used for.",
        deployRuntimeVariablesUsageTitle: "Best practices",
        deployRuntimeVariablesUsage1:
          "Keep sensitive values such as API keys and passwords as secrets.",
        deployRuntimeVariablesUsage2:
          "Use recipe scope to limit variables to specific workflows.",
        deployRuntimeVariablesUsage3:
          "Prefer explicit and stable names to keep maintenance simple.",
        deployRuntimeVariablesInjectedDescription:
          "These variables will be injected automatically into agent executions.",
        openTasks: "Open tasks",
        timeline: "Timeline",
        artifacts: "Artifacts",
        sourceGraph: "Source graph",
        degraded: "Degraded",
        loadingContext: "Loading context…",
        loadingRecipePreview: "Loading recipe preview…",
      },
    },
  },
  es: {
    translation: {
      language: {
        label: "Idioma",
        fr: "Francés",
        en: "Inglés",
        es: "Español",
      },
      theme: {
        label: "Tema",
        system: "Sistema",
        light: "Claro",
        dark: "Oscuro",
      },
      common: {
        loading: "Cargando…",
        miniappStepDone: "terminada",
        miniappStepCurrent: "en curso",
        miniappStepTodo: "pendiente",
        miniappNoData: "Sin datos",
        miniappOther: "Otros",
        miniappToneSuccess: "Favorable",
        miniappToneWarning: "A vigilar",
        miniappToneError: "Desfavorable",
        miniappDevWarnings: "Avisos de renderizado (modo desarrollo)",
        close: "Cerrar",
        cancel: "Cancelar",
        create: "Crear",
        save: "Guardar",
        edit: "Editar",
        delete: "Eliminar",
        remove: "Quitar",
        refresh: "Actualizar",
        noDescription: "No se proporcionó descripción.",
        unknown: "Desconocido",
        valid: "Válida",
        invalid: "Inválida",
        preview: "Vista previa",
        hide: "Ocultar",
        open: "Abrir",
        download: "Descargar",
        context: "Contexto",
        connecting: "Conectando…",
        active: "activo",
        error: "Error",
        copy: "Copiar",
        run: "Ejecución",
        studio: "Studio",
        build: "Configuración",
        builder: "Builder",
        admin: "Admin",
      },
      integrations: {
        description: "Añade conectores útiles al Agente actual, configura sus accesos y expone sus tools al runtime AgentMaurice.",
        usageTitle: "Créditos de integraciones",
        usageValue: "{{consumed}} / {{budget}} créditos este mes",
        addedTitle: "Conectores añadidos",
        addedDescription: "Solo aparecen aquí los conectores añadidos al Agente actual.",
        addConnector: "Añadir conector",
        emptyTitle: "No hay conectores añadidos",
        emptyDescription: "Busca un conector en el catálogo para añadirlo al Agente actual.",
        connectSuccess: "Conector conectado.",
        connectError: "No se pudo conectar.",
        addSuccess: "Conector añadido.",
        addError: "No se pudo añadir.",
        removeSuccess: "Conector retirado.",
        removeError: "No se pudo retirar.",
        disconnectSuccess: "Conector desconectado.",
        disconnectError: "No se pudo desconectar.",
        settingsSuccess: "Configuración guardada.",
        settingsError: "No se pudo configurar.",
        testSuccess: "Estado del conector: {{status}}.",
        testError: "No se pudo probar.",
        catalogError: "No se pudieron cargar los conectores.",
        catalogHTTPError: "Console {{status}} en {{path}}: {{message}}",
        authMode: "Modo",
        configurationRequiredHelp: "Configura el conector antes de crear una conexión de usuario.",
        manualSupportHelp: "Este conector requiere configuración asistida por soporte.",
        editSettings: "Editar",
        configure: "Configurar",
        reconnect: "Reconectar",
        connect: "Conectar",
        test: "Probar",
        tools: "Tools",
        disconnect: "Desconectar",
        remove: "Retirar",
        maintainedPack: "Pack mantenido",
        actionsAvailable: "Acciones disponibles",
        noActionsEnabled: "Ninguna acción activada",
        directoryTitle: "Añadir conector",
        directoryDescription: "El catálogo es global, pero añadir un conector lo habilita solo para el Agente actual.",
        searchPlaceholder: "Buscar Gmail, Slack, CRM…",
        allCategories: "Todas las categorías",
        allAuthModes: "Todos los modos",
        directoryError: "No se pudo cargar el catálogo.",
        noDirectoryResults: "Ningún conector coincide con esta búsqueda.",
        toolPack: "Pack tools",
        add: "Añadir",
        loadMoreConnectors: "Mostrar más",
        toolsTitle: "Tools del conector",
        toolsDescription: "Tools proyectados en el Agente actual para {{connector}}.",
        toolsError: "No se pudieron cargar los tools del conector.",
        noActionsHelp: "No se proyecta ningún tool hasta que el conector esté configurado y conectado en este Agente.",
        managedAction: "Acción disponible",
        customTool: "Tool custom",
        editSettingsTitle: "Editar configuración",
        configureTitle: "Configurar conector",
        configureDescription: "Los valores secretos nunca se vuelven a mostrar.",
        connectionCredentialsHelp: "Las credenciales se introducen al conectar la cuenta de usuario.",
        setupGuide: "Guía de configuración",
        callbackUrl: "URL de callback",
        disabled: "Desactivado",
        manualSupport: "Soporte requerido",
        configurationRequired: "Configuración requerida",
        connected: "Conectado",
        revoked: "Revocado",
        notConnected: "No conectado",
        consoleRequiredTitle: "Conecta AgentMaurice Console",
        consoleRequiredDescription:
          "Las integraciones se autentican en la Console con tu sesión Hanko. Sin ambos criterios, el catálogo y los créditos no están disponibles.",
        consoleRequiredHankoOk: "Sesión Hanko",
        consoleRequiredHankoMissing: "Falta la sesión Hanko",
        consoleRequiredConsoleMissing: "Falta la sesión Console",
        consoleRequiredHankoTitle: "1. Conéctate con Hanko",
        consoleRequiredHankoBody:
          "Abre AgentMaurice OS con autenticación Hanko (no el modo local). Usa el mismo correo que en la Console. Las cuentas se crean en la Console.",
        consoleRequiredConsoleTitle: "2. Abre una sesión de AgentMaurice Console",
        consoleRequiredConsoleBody:
          "Entra en AgentMaurice Console con esa cuenta y crea o únete a una organización. El JWT Hanko del OS debe ser aceptado por esta Console.",
        consoleRequiredCreditsTitle: "3. Obtén créditos",
        consoleRequiredCreditsBody:
          "Los conectores hosted debitan el wallet de la organización. En la Console, abre Facturación y compra un pack de créditos AgentMaurice.",
        consoleRequiredOpenConsole: "Abrir AgentMaurice Console",
        consoleRequiredOpenBilling: "Comprar créditos",
      },
      desktopUpdate: {
        availableTitle: "Nueva versión disponible",
        availableDescription: "JusteMaurice {{version}} se puede instalar.",
        genericVersion: "más reciente",
        installAction: "Actualizar",
        installing: "Instalando actualización…",
        installError: "No se pudo instalar la actualización.",
      },
      auth: {
        checking: "Comprobando autenticación…",
        required: "La autenticación es necesaria antes de cargar organizaciones, agentes y espacios.",
        localModeEnabled: "El modo de desarrollo local está activado. La autenticación la gestiona `chatserver`.",
        localAccount: "Cuenta local",
        localSignIn: "Inicio local",
        signIn: "Iniciar sesión",
        createAccount: "Crear cuenta",
        loadingApp: "Cargando Agent OS…",
        createAccountOnConsoleHint: "La creación de cuenta se hace en console.agentmaurice.app.",
        signInError: "Error de inicio de sesión",
        noAccountYet: "¿Aún no tienes cuenta?",
      },
      enrollment: {
        title: "Completa tu perfil AgentMaurice",
        subtitle: "Completa tu perfil y crea tu primera organización antes de entrar en AgentMaurice OS.",
        subtitleProfileOnly: "Completa tu perfil de Console antes de entrar en AgentMaurice OS.",
        roleHint: "Tu primer rol en esta organización será `orga-admin`.",
        roleHintProfileOnly: "Este perfil se guarda en Console y se sincroniza aquí automáticamente.",
        email: "Correo",
        username: "Nombre de usuario",
        usernamePlaceholder: "mikaelmorvan",
        firstName: "Nombre",
        firstNamePlaceholder: "Tu nombre",
        lastName: "Apellido",
        lastNamePlaceholder: "Tu apellido",
        language: "Idioma preferido",
        personalOrganization: "Es una organización personal",
        personalOrganizationHint: "Deja el nombre vacío si quieres usar tu identidad como nombre de la organización.",
        organizationName: "Nombre de la organización",
        organizationNamePlaceholder: "AgentMaurice",
        organizationNamePersonalPlaceholder: "Opcional para una organización personal",
        submit: "Guardar perfil",
        error: "No se pudo guardar el perfil.",
        validation: {
          username: "El nombre de usuario es obligatorio.",
          firstName: "El nombre es obligatorio.",
          lastName: "El apellido es obligatorio.",
          language: "El idioma preferido es obligatorio.",
          organizationName: "El nombre de la organización es obligatorio.",
        },
      },
      welcome: {
        badge: "Configuración exprés",
        title: "Prepara AgentMaurice OS para un primer uso útil.",
        subtitle: "Recuperamos el contexto de organización, creamos el Agente por defecto si hace falta y bloqueamos el acceso LLM hasta que esté listo.",
        organizationTitle: "Organización",
        organizationReady: "Organización disponible",
        organizationPending: "Esperando el bootstrap local",
        deploymentTitle: "Agente",
        deploymentReady: "Agente por defecto listo",
        deploymentPending: "Agente aún por crear",
        providerTitle: "LLM",
        providerChoicePending: "Falta elegir el modo LLM",
        providerHosted: "Modelos hosted de AgentMaurice",
        providerHostedPending: "Modelos AgentMaurice por inicializar",
        providerReady: "Provider configurado",
        providerPending: "Todavía no hay provider activo",
        nextStepTitle: "Siguiente paso",
        nextStepModeChoice: "Primero elige cómo quieres usar los LLM: modelos de AgentMaurice o tus propias claves API.",
        nextStepContext: "Todavía estamos terminando el contexto local. Vuelve a lanzar el bootstrap para recuperar la organización de consola y crear el workspace por defecto.",
        nextStepDeployment: "La organización ya está lista, pero aún falta el Agente de usuario por defecto. Actualiza el contexto para crearlo.",
        nextStepProvider: "El contexto ya está listo. Configura ahora tus claves API para desbloquear chat y Build.",
        nextStepHostedPending: "El contexto ya está listo. Inicializa el perfil LLM AgentMaurice para crear el provider, el modelo y la selección del Agente.",
        nextStepHosted: "El contexto ya está listo. Los modelos de AgentMaurice están disponibles en esta instancia sin claves adicionales.",
        nextStepReady: "Todo está listo en esta máquina. Ya puedes entrar en el chat o pasar a Build sin configuración adicional.",
        stepConsoleTitle: "Contexto",
        stepConsoleDescription: "AgentMaurice OS primero recupera el contexto de tu organización y prepara el workspace activo.",
        stepProviderTitle: "Provider",
        stepProviderDescription: "Elige el modo LLM que mejor te encaja y, en modo de claves propias, prueba la configuración antes de guardarla.",
        stepLaunchTitle: "Inicio",
        stepLaunchDescription: "Cuando el modo está listo, el chat y Build quedan listos para usarse en esta máquina.",
        modeTitle: "Elegir acceso LLM",
        modeDescription: "Debes elegir entre los modelos de AgentMaurice y tus propias claves API antes de usar la instancia.",
        modeLabel: "Modo LLM",
        modeHostedTitle: "Modelos de AgentMaurice",
        modeHostedDescription: "Usa los modelos proporcionados por AgentMaurice. No hace falta ninguna clave personal en esta máquina.",
        modeByokTitle: "Mis propias claves",
        modeByokDescription: "Usa tus propios providers. Mientras las claves no estén configuradas, chat y Build seguirán bloqueados.",
        modeChoiceRequiredTitle: "Elección obligatoria",
        modeChoiceRequiredDescription: "Mientras no elijas un modo LLM, la instancia se mantiene en configuración y los flujos principales siguen bloqueados.",
        modeLockedTitle: "Configuración LLM ya definida",
        modeLockedHostedDescription: "Esta organización usa los modelos de AgentMaurice. Los demás usuarios de esta VM no tienen que repetir el onboarding LLM.",
        modeLockedByokDescription: "Esta organización ya usa un provider BYOK. Los demás usuarios de esta VM no tienen que volver a introducir claves.",
        hostedTitle: "Usar los modelos de AgentMaurice",
        hostedDescription: "Esta instancia puede usar directamente los modelos de AgentMaurice. No necesitas introducir ninguna clave API.",
        hostedPanelTitle: "LLM AgentMaurice activo",
        hostedPanelDescription: "El Agente usa un perfil LLM AgentMaurice de la organización. No hace falta ningún secreto de usuario en AgentMaurice OS.",
        hostedPanelPendingTitle: "Inicializar el perfil AgentMaurice",
        hostedPanelPendingDescription: "AgentMaurice OS creará o reutilizará el provider AgentMaurice de la organización, añadirá un modelo por defecto, creará un perfil y lo seleccionará para este Agente.",
        hostedNoKeyRequired: "No se requiere clave del usuario",
        hostedPendingNoKey: "No se requiere clave del usuario",
        hostedActivateButton: "Inicializar AgentMaurice",
        hostedActivating: "Inicializando…",
        hostedActivateSuccess: "Perfil LLM AgentMaurice inicializado.",
        hostedActivateError: "No se pudo inicializar el perfil LLM AgentMaurice.",
        byokPanelTitle: "Provider BYOK activo",
        byokPanelDescription: "La organización ya tiene una configuración LLM. Para cambiarla, usa Build > LLM con los permisos necesarios.",
        formTitle: "Conectar tu LLM",
        formDescription: "Una sola configuración basta. Los secretos se guardan en el backend local y el provider se conecta al Agente por defecto.",
        readyBadge: "Listo",
        setupBadge: "Setup requerido",
        providerNameLabel: "Nombre visible",
        modelLabel: "Modelo",
        apiKeyLabel: "Clave API",
        apiKeyOptionalLabel: "Clave API (opcional)",
        apiKeyPlaceholder: "sk-...",
        urlRequiredLabel: "URL / endpoint",
        urlOptionalLabel: "URL / endpoint (opcional)",
        urlPlaceholder: "https://...",
        advancedTitle: "Parámetros avanzados",
        hideAdvanced: "Ocultar",
        showAdvanced: "Mostrar",
        systemPromptLabel: "System prompt",
        systemPromptPlaceholder: "Opcional. Déjalo vacío para usar el prompt por defecto.",
        maxCompletionTokensLabel: "Max completion tokens",
        diagnosticOk: "Conexión validada",
        diagnosticError: "La prueba falló",
        testing: "Probando…",
        testButton: "Probar",
        saving: "Guardando…",
        primaryButton: "Probar y empezar",
        refreshing: "Actualizando…",
        refreshButton: "Actualizar contexto",
        continueChat: "Continuar al chat",
        openBuild: "Abrir Studio",
        readyHint: "El workspace ya está listo. Puedes entrar en el chat o abrir Build para empezar a construir.",
        readyHintHosted: "El workspace ya está listo y los modelos de AgentMaurice están disponibles. Puedes ir directamente al chat o a Build.",
        pendingHint: "Elige primero un modo LLM y luego asegúrate de que la organización y el Agente estén listos antes de continuar.",
        pendingHintByok: "Mientras tus claves API no estén probadas y guardadas, chat y Build seguirán bloqueados.",
        pendingHintHosted: "Inicializa el perfil AgentMaurice para desbloquear chat y Build sin introducir una clave API.",
        testSuccess: "Conexión con el provider validada.",
        testError: "No se pudo validar la conexión con el provider.",
        saveSuccess: "Configuración guardada.",
        saveError: "No se pudo guardar la configuración.",
        contextRefreshed: "Contexto local actualizado.",
        contextRefreshError: "No se pudo actualizar el contexto local.",
        statusError: "No se pudo cargar el estado del setup.",
        agentDiscoveryTitle: "Conectar un agente de código",
        agentDiscoveryDescription: "Elige un prompt sin instalación o un comando MauriceCLI para el rail Git-native Agent Spec V2. Ambos caminos mantienen External Inception guiado, temporal y auditable.",
        agentDiscoveryBadge: "External Inception",
        codeAgentPromptMode: "Conexión MCP sin instalación (`amb_`)",
        codeAgentCLIMode: "Conexión MauriceCLI (`amc_`)",
        codeAgentPromptModeHint: "Copia un prompt de conexión MCP. Su URL `amb_` nunca debe pasarse a `maurice agent connect`.",
        codeAgentCLIModeHint: "Copia el comando `maurice agent connect`. Configura el cliente e inicia el rail Agent Spec V2 en el proyecto Git local.",
        agentDiscoveryReadyHint: "El prompt no contiene la clave final. El agente debe llamar a la URL bootstrap para recibir el contrato `agentmaurice.agent_connection/v2`.",
        agentDiscoveryUnavailableHint: "No tienes permisos suficientes para generar este prompt.",
        agentDiscoveryHumanApprovalHint: "El agente de código prepara el plan, pero no puede aprobarlo. La aprobación del hash exacto sigue siendo una acción humana separada en AgentMaurice OS.",
        agentDiscoveryGenerate: "Generar prompt",
        agentDiscoveryGenerating: "Generando…",
        agentDiscoveryCopy: "Copiar prompt",
        agentDiscoveryGenerated: "Prompt de agente generado.",
        agentDiscoveryGenerateError: "No se pudo generar el prompt de agente.",
        agentDiscoveryInvalidBootstrap: "El servidor no devolvió una conexión MCP `amb_` válida.",
        agentDiscoveryCopied: "Prompt de agente copiado.",
        agentDiscoveryCopyError: "No se pudo copiar el prompt de agente.",
        agentDiscoveryPrompt: "Vas a conectar este agente de código a una instancia AgentMaurice.\n\nIMPORTANTE — solo conexión MCP (`amb_`): no pases nunca esta URL a `maurice agent connect`. Ese comando requiere un bootstrap MauriceCLI `amc_` generado por AgentMaurice OS.\n\n1. Llama a esta URL bootstrap una sola vez:\n{{url}}\n\n2. Comprueba que el JSON devuelto tiene `$schema: agentmaurice.agent_connection/v2`, `schema_version: 2`, `bootstrap_kind: external_inception_mcp` e `intended_consumer: mcp_client_setup`. Usa únicamente `organization`, `agent`, `agent_scopes`, `credential`, `mcp`, `commands`, `tools`, `policies`, `warnings`, `next_command` y `client_setup`.\n\n3. Configura MCP con `client_setup`. Empieza con `inception_agent_scopes_list` y luego llama a `inception_agent_doctor` sin argumentos: la respuesta es compacta por defecto; usa `full:true` solo para un diagnóstico experto solicitado expresamente. Después llama a `inception_mcp_capabilities`. Nunca infieras un Agente por su nombre humano: usa `agent_alias` o `agent_id` de `agent_scopes`.\n\n4. Para cualquier cambio, usa exclusivamente este rail: `inception_agent_spec_init` si es necesario → `inception_agent_spec_pull` → edición de los archivos Git-native → `inception_agent_spec_check` → `inception_agent_spec_plan`. Presenta el plan inmutable y su `plan_hash` y detente.\n\n5. La aprobación debe registrarla una persona autenticada en AgentMaurice OS o en una sesión humana separada. Como agente o servicio, no llames a `inception_agent_spec_approve` ni intentes autoaprobarte. Tras confirmar que la aprobación humana está registrada, llama a `inception_agent_spec_apply` con el plan aprobado y luego a `inception_agent_spec_verify`.\n\n6. Nunca solicites, muestres ni escribas secretos en bruto; usa solo referencias de secretos.",
        cliBootstrapReadyHint: "El comando configura el cliente y el proyecto local; los cambios siguen después init/pull/check/plan, aprobación humana, apply y verify.",
        cliBootstrapUnavailableHint: "No tienes permisos suficientes para generar este comando.",
        cliBootstrapEnvLabel: "Entorno",
        cliBootstrapKindLabel: "Tipo",
        cliBootstrapClientLabel: "Cliente agente",
        cliBootstrapAliasLabel: "Alias del Agente",
        cliBootstrapDirLabel: "Directorio",
        cliBootstrapJoinExistingLabel: "Reconectarme a un proyecto existente",
        cliBootstrapJoinExistingDescription: "Añade `--join-existing` para renovar el acceso local sin reescribir ni exportar los archivos Agent Spec del proyecto.",
        bootstrapScopesTitle: "Agentes vinculados",
        bootstrapScopesDescription: "Añade solo los agentes que este agente o esta CLI debe poder seleccionar explícitamente.",
        bootstrapScopesNone: "No hay otro Agente disponible en este contexto.",
        bootstrapScopeAlias: "Alias",
        bootstrapScopeRole: "Rol",
        bootstrapScopeRuntimeDependency: "Dependencia runtime",
        bootstrapScopeManaged: "Gestionado",
        cliBootstrapGenerate: "Generar comando",
        cliBootstrapGenerating: "Generando…",
        cliBootstrapCopy: "Copiar comando",
        cliBootstrapGenerated: "Comando MauriceCLI generado.",
        cliBootstrapGenerateError: "No se pudo generar el comando MauriceCLI.",
        cliBootstrapInvalidCommand: "El servidor no devolvió un comando V2 `maurice agent connect` válido.",
        cliBootstrapCopied: "Comando MauriceCLI copiado.",
        cliBootstrapCopyError: "No se pudo copiar el comando MauriceCLI.",
        cliBootstrapKind: {
          development: "Desarrollo",
          preproduction: "Preproducción",
          production: "Producción",
          sandbox: "Sandbox",
          integration_test: "Test de integración",
        },
        cliBootstrapClient: {
          "claude-code": "Claude Code",
          codex: "Codex",
          cursor: "Cursor",
          windsurf: "Windsurf",
          generic: "Generic MCP",
        },
      },
      operateSetup: {
        missingOrganizationTitle: "Se requiere una organización",
        missingOrganizationDescription: "Esta vista necesita una organización activa antes de poder cargar el contenido operativo.",
        missingDeploymentTitle: "Se requiere un Agente",
        missingDeploymentDescription: "Selecciona o crea primero un Agente activo antes de abrir las pantallas de operación.",
        missingSpaceTitle: "Se requiere un espacio",
        missingSpaceDescription: "El Agente está listo, pero todavía no hay un espacio activo en esta sesión. Vuelve a la bienvenida para terminar la puesta en marcha.",
        noSpaceTitle: "No hay un espacio listo para este Agente",
        noSpaceDescription: "Esta instancia todavía no tiene un espacio utilizable para el Agente actual. Termina la bienvenida antes de abrir el chat.",
        loadingSpacesTitle: "Cargando espacios…",
        loadingSpacesDescription: "Comprobando los espacios disponibles para el Agente actual antes de abrir el chat.",
        openWelcome: "Abrir bienvenida",
        createSpace: "Crear un espacio",
        creatingSpace: "Creando el espacio…",
        createSpaceError: "No se pudo crear un espacio para este Agente.",
        escalateChiefOfStaff: "Continuar en Studio con el Jefe de gabinete",
        escalateChiefOfStaffHint:
          "Este Agente aún no tiene la capacidad pedida. El Jefe de gabinete la prepara en Studio.",
        openCatalog: "Abrir catálogo",
        openHistory: "Abrir historial",
        completeSetupToStart: "Termina la bienvenida para desbloquear el chat y las pantallas operativas",
      },
      shell: {
        toggleContextPanel: "Alternar panel de contexto",
        toggleRightPanel: "Alternar panel derecho (Ctrl/Cmd+Shift+\\)",
        openNavigation: "Abrir la navegación",
        closeNavigation: "Cerrar la navegación",
        resizeNavigationPanel: "Redimensionar panel de navegación",
        resizeContextPanel: "Redimensionar panel de contexto",
        executionDetailTitle: "Detalle de ejecución",
        executionDetailDescription: "Contexto de la ejecución seleccionada.",
        emptyContextDescription: "El shell mantiene esta zona lista para inspección, detalles de ejecución y vistas previas contextuales.",
      },
      sidebar: {
        recipes: "Recetas",
        data: "Datos",
        deployments: "Agentes",
        chiefOfStaff: "Jefe de gabinete",
        applications: "Aplicaciones",
        agentStudio: "Studio",
        travail: "Trabajo",
        travailInbox: "Por tratar",
        travailActivity: "Actividad",
        noApplications: "Ninguna aplicación",
        applicationReview: "Revisión",
        organization: "Organización",
        orgAccessMap: "Derechos",
        orgGates: "Puertas de máquina",
        orgMembers: "Miembros y directorio",
        orgVault: "Bóveda y eventos",
        orgUsage: "Uso y facturación",
        orgImportExport: "Importar / exportar",
        agentModels: "Modelos",
        models: "Modelos",
        mcp: "MCP",
        skills: "Skills",
        agentConfig: "Ajustes",
        tools: "Herramientas",
        channels: "Canales",
        importExport: "Import / Export",
        mailCatcher: "Mail Catcher",
        spaces: "Espacios",
        chat: "Chat",
        catalog: "Catálogo",
        history: "Historial",
        spacesSessions: "Espacios y sesiones",
        newSession: "Nueva sesión",
        sessionActions: "Acciones de sesión",
        renameSession: "Renombrar",
        renameSessionTitle: "Renombrar sesión",
        renameSessionDescription: "Cambia el nombre mostrado en la lista de sesiones.",
        renameSessionNameRequired: "El nombre de sesión es obligatorio.",
        renameSessionSuccess: "Sesión renombrada.",
        renameSessionError: "No se pudo renombrar la sesión.",
        deleteSession: "Eliminar",
        deleteSessionTitle: "Eliminar sesión",
        deleteSessionDescription: "La sesión {{name}} se eliminará definitivamente.",
        deleteSessionSuccess: "Sesión eliminada.",
        deleteSessionError: "No se pudo eliminar la sesión.",
        sessionName: "Nombre de la sesión",
        unnamedSession: "Sesión",
        noSessionYet: "Aún no hay sesiones.",
        localProfile: "Perfil local",
        userProfile: "Perfil de usuario",
        account: "Cuenta",
        access: "Acceso",
        osVersion: "AgentMaurice OS",
        appearance: "Apariencia",
        profileSecurity: "Seguridad",
        localAuthentication: "Autenticación local",
        hankoAuthentication: "Autenticación segura",
        hankoProfileDescription: "Gestiona la identidad, los métodos de inicio de sesión y el contexto AgentMaurice de esta sesión.",
        hankoProfileLoadError: "No se pudo cargar la seguridad de la cuenta.",
        localSignOutHint: "Cerrar sesión te devuelve al selector de cuentas locales.",
        hankoSignOutHint: "Cerrar sesión termina la sesión local en este dispositivo.",
        confirmSignOutTitle: "Confirmar cierre de sesión",
        confirmSignOutDescription: "Vas a cerrar la sesión actual en este dispositivo.",
        confirmSwitchUserDescription: "Vas a salir de este perfil local y volver al selector de cuentas.",
        switchUser: "Cambiar usuario",
        signOut: "Cerrar sesión",
        consoleBinding: "Vinculación de consola",
        consoleBindingDescription: "Vincule esta instalación a una instancia de consola sin cambiar el backend local ni la base SQLite.",
        consoleBound: "Vinculado",
        consoleUnbound: "Sin vincular",
        consoleUrl: "Consola",
        consoleInstance: "Instancia",
        consoleOrganization: "Organización",
        consoleUser: "Usuario de consola",
        consoleLastSync: "Última actualización {{value}}",
        consolePair: "Vincular",
        consoleReconnect: "Vincular de nuevo",
        consoleDetach: "Desvincular",
        consoleDetachConfirm: "¿Desvincular esta instalación de la consola y recargar la aplicación?",
        consoleDetached: "Vinculación de consola eliminada. Recargando…",
        consolePairingIntro: "Introduzca la URL de la consola y luego inicie la vinculación por device flow.",
        consolePairingStart: "Iniciar vinculación",
        consolePairingCancel: "Cancelar",
        consolePairingUrlPlaceholder: "https://console.agentmaurice.app",
        consolePairingPending: "Abra esta URL en el navegador e introduzca el siguiente código.",
        consoleVerificationUrl: "URL de verificación",
        consoleUserCode: "Código",
        consoleCheckingStatus: "Esperando aprobación…",
        consolePairingExpires: "Caduca en {{count}} s",
        consolePairingExpired: "El código de vinculación caducó. Inicie el emparejamiento de nuevo.",
        consolePaired: "Instalación vinculada a {{instance}}. Recargando…",
        consolePairingFailed: "La vinculación de consola ha fallado.",
        consoleReloadHint: "El contexto de organización se recargará automáticamente tras vincular o desvincular.",
      },
      contextSwitcher: {
        selectOrganization: "Seleccionar organización",
        selectDeployment: "Seleccionar Agente",
        organization: "Organización",
        orgId: "ID organización",
        notSelected: "No seleccionado",
        loadingContext: "Cargando contexto…",
        createApplicationTitle: "Crear una Application",
        createApplicationDescription: "Una Application agrupa Agents y publica una superficie de acceso externa.",
        createApplicationKeyLabel: "Clave Application",
        createApplicationKeyPlaceholder: "salon-client",
        createApplicationNameLabel: "Nombre visible",
        createApplicationNamePlaceholder: "Portal cliente",
        createApplicationConfirm: "Crear Application",
        createApplicationSubmitting: "Creando…",
        createApplicationSuccess: "Application {{name}} creada.",
        createApplicationFailed: "No se pudo crear la Application.",
        createApplicationKeyRequired: "La clave Application es obligatoria.",
        createApplicationAgentsLabel: "Agents miembros",
        createApplicationAgentsHint: "Selecciona los Agents a incluir en esta Application.",
        createApplicationNoAgents: "No hay Agents disponibles en esta organización.",
        createApplicationMembersPartial: "Application creada, pero algunos Agents no se pudieron añadir.",
        createDeploymentTitle: "Crear Agente",
        createDeploymentSubmitting: "Creando…",
        createDeploymentNoOrganization: "Selecciona primero una organización.",
      },
      chat: {
        headerTitle: "Chat con Maurice",
        presenceLabel: "Presentes en la sesión",
        presenceYou: "tú",
        invite: {
          button: "Invitar",
          title: "Invitar a la conversación",
          hint: "Solo se proponen las personas que tienen acceso a la Application. La persona invitada accede solo a esta conversación, no a las demás conversaciones del espacio.",
          loading: "Cargando personas…",
          empty: "Todas las personas que tienen acceso a la Application ya tienen acceso a esta conversación.",
          listLabel: "Personas para invitar",
          pending: "Invitando",
          retry: "Reintentar",
          success: "{{name}} tiene acceso a esta conversación: aparece en su Run.",
          alreadyMember: "{{name}} ya tiene acceso a esta conversación.",
          participantsTitle: "Personas invitadas",
          participantsEmpty: "Todavía no hay nadie invitado a esta conversación.",
          remove: "Quitar",
          removeLabel: "Quitar a {{name}} de la conversación",
          removing: "Quitando",
          removed: "{{name}} ya no tiene acceso a esta conversación.",
          errors: {
            run_invitee_not_application_person: "Esta persona no tiene acceso a la Application.",
            run_session_not_found: "Conversación no encontrada, o no participas en ella.",
            run_session_not_invitable: "Esta conversación no se puede compartir desde esta Application.",
            run_participant_removal_forbidden: "Solo el autor de la invitación y el propietario del espacio pueden quitar a esta persona.",
            application_access_denied: "No tienes acceso a esta Application.",
            unknown: "No se pudo cargar ni enviar la invitación. Inténtalo de nuevo.",
          },
        },
        recipeLabel: "Workflow: {{name}}",
        recipeBadge: "Contexto",
        chooseRecipe: "Elegir un Workflow",
        skillsButton: "Skills",
        debugMessages: "Debug",
        showTechnicalMessages: "Mostrar llamadas a herramientas y resultados sin procesar",
        hideTechnicalMessages: "Ocultar llamadas a herramientas y resultados sin procesar",
        skillsSessionLabel: "Skills de sesión",
        skillsPanelTitle: "Skills de sesión",
        skillsPanelDescription: "Selecciona skills del Agente para enriquecer la sesión actual.",
        skillsLoading: "Cargando skills…",
        skillsLoadingError: "No se pudieron cargar las skills del Agente.",
        noSelectedSkills: "No hay skills seleccionadas para esta sesión.",
        noDeploymentSkills: "No hay skills instaladas en este Agente.",
        useSkill: "Usar",
        skillSelected: "Seleccionada",
        clearSkills: "Vaciar skills",
        skillsCleared: "Selección de skills vaciada.",
        skillNotFound: "Skill no encontrada: {{skill}}",
        skillAdded: "{{skill}} añadida a la sesión.",
        skillRemoved: "{{skill}} retirada de la sesión.",
        noSkillPreview: "No hay vista previa disponible para esta skill.",
        execution: "Ejecución",
        connectionErrorTitle: "Error de conexión",
        connectionErrorDescription:
          "La conexión al chat falló. Vuelve a intentarlo; si persiste, contacta a tu administrador.",
        serverErrorTitle: "Error del servicio",
        serverErrorDescription:
          "El servicio encontró un error. Tu mensaje no se perdió; vuelve a intentarlo en un momento.",
        serviceTimeoutTitle: "El servicio está tardando demasiado en responder",
        serviceTimeoutDescription:
          "Problema temporal del servicio, ajeno al Workflow. Vuelve a intentarlo en un momento.",
        errorRetryAction: "Reintentar",
        errorTechnicalDetailsToggle: "Detalles técnicos",
        sessionPausedTitle: "Sesión en pausa",
        sessionPausedDescription: "La sesión se pausó tras un período de inactividad.",
        resumeConversation: "Reanudar la conversación",
        sessionReplacedOtherApplication:
          "Esta conversación pertenece a otra Application: se abrió una nueva conversación aquí. Su historial permanece en su Application.",
        sessionReplacedUnavailable:
          "La conversación solicitada no está disponible en esta Application: se abrió una nueva conversación.",
        sessionReplacedDismiss: "Ocultar este mensaje",
        accessRemovedTitle: "Se ha retirado tu acceso a esta conversación",
        accessRemovedDescription:
          "Ya no puedes leer ni escribir en esta conversación. Para volver, pide a una persona que gestione la Application que te invite de nuevo.",
        accessRemovedPlaceholder: "Acceso retirado",
        applicationNotOpenPlaceholder: "Application no abierta para ti",
        messageFeed: "Flujo de mensajes del chat",
        loadingHistory: "Cargando historial…",
        loadingOlderMessages: "Cargando mensajes anteriores…",
        startConversation: "Iniciar una conversación",
        readyForMessage: "Cuando quieras",
        askAboutRecipe: "Pregunta a Maurice cualquier cosa sobre este Workflow",
        askAboutWorkspace: "Pregunta a Maurice cualquier cosa sobre este espacio",
        latest: "Últimos",
        createSessionToStart: "Crea o selecciona una sesión para empezar.",
        askMaurice: "Pregúntale a Maurice…",
        noExecutionContext: "Todavía no hay contexto de ejecución disponible",
        noActiveSessionToClear: "No hay sesión activa para limpiar",
        sessionHistoryCleared: "Historial de sesión borrado",
        failedToClearSession: "No se pudo borrar la sesión",
        clearSessionTitle: "Borrar sesión",
        clearSessionDescription: "Esto eliminará todo el historial de la sesión de chat actual.",
        clearHistory: "Borrar historial",
        helpMessage: "Comandos disponibles:\n\n- `/status` abrir el contexto de ejecución\n- `/workflow` abrir el selector de Workflows\n- `/tools` pedir a Maurice las herramientas disponibles en este contexto\n- `/skills` abrir el panel de skills\n- `/use-skill <id>` seleccionar una skill para la sesión\n- `/clear-skills` vaciar la selección de skills\n- `/help` mostrar esta ayuda\n- `/clear` borrar el historial de la sesión actual",
        recipeContextHint:
          "Los siguientes mensajes quedan enmarcados por este Workflow.",
        llmActivityThinking: "Maurice está pensando…",
        llmActivityTool: "Maurice está usando una herramienta…",
        llmActivitySkill: "Maurice está aplicando una skill…",
        llmActivityProject: "Maurice está trabajando en el proyecto…",
      },
      chatInput: {
        openStatusContext: "Abrir contexto de estado",
        openStatusContextDescription: "Pedir el estado actual de una ejecución o Agente",
        launchRecipe: "Lanzar un Workflow",
        launchRecipeDescription: "Abrir el selector de Workflows o apuntar a un comando de Workflow",
        showHelp: "Mostrar ayuda",
        showHelpDescription: "Mostrar los slash commands disponibles",
        showTools: "Mostrar herramientas",
        showToolsDescription: "Pedir a Maurice las herramientas disponibles en este contexto",
        openSkills: "Abrir skills",
        openSkillsDescription: "Mostrar las skills del Agente y la selección actual de la sesión",
        useSkill: "Usar una skill",
        useSkillDescription: "Seleccionar una skill para enriquecer los próximos mensajes",
        clearSkills: "Vaciar skills",
        clearSkillsDescription: "Quitar todas las skills seleccionadas de la sesión actual",
        clearSession: "Borrar sesión",
        clearSessionDescription: "Eliminar el historial de la sesión actual",
        changeRecipe: "Cambiar",
        messageLabel: "Tu mensaje",
        quickActions: "Acciones rápidas",
        shortcutHint: "Usa slash commands o el selector de Workflows para encuadrar la sesión rápidamente.",
        stop: "Detener",
      },
      files: {
        attach: "Adjuntar un archivo",
        attached: "{{filename}} añadido al mensaje",
        uploadFailed: "Error al subir el archivo",
        uploadProgress: "Subida {{progress}}%",
        attachedFile: "Archivo adjunto",
      },
      recipePicker: {
        title: "Seleccionar un blueprint",
        description: "Inicia la conversación con un contexto de Workflow específico, o mantén el chat genérico.",
        searchPlaceholder: "Buscar Workflows…",
        loading: "Cargando Workflows…",
        noMatch: "Ningún Workflow coincide con esta búsqueda.",
        noDescription: "No se proporcionó descripción.",
      },
      recipeForm: {
        fallbackTitle: "Formulario de Workflow",
        fallbackDescription: "El Workflow en curso necesita información adicional para continuar.",
        selectOption: "Seleccionar…",
        submit: "Enviar formulario",
        submitting: "Enviando…",
        fieldRequired: "{{field}} es obligatorio.",
        restoreError: "No se puede volver a abrir el formulario de este Workflow.",
      },
      chatMessage: {
        resourcePreview: "Vista previa del recurso",
        previewTruncated: "Vista previa truncada.",
        result: "Resultado",
        logs: "Logs",
        userMessage: "Mensaje del usuario",
        peerMessage: "Mensaje de {{name}}",
        assistantMessage: "Mensaje del asistente",
        technicalMessage: "Mensaje técnico",
      },
      executionPanel: {
        title: "Estado de ejecución",
        completedCount: "{{done}}/{{total}} completadas",
        running: "En curso…",
        progress: "Progreso",
        overallProgress: "Progreso global",
        stepProgress: "Progreso de {{step}}",
        empty: "Ningún paso activo por el momento",
        summary: "Los pasos de ejecución aparecerán aquí en cuanto arranque un Workflow o una tarea de sesión.",
      },
      executionResult: {
        title: "Resultado",
        refresh: "Actualizar resultado",
        copy: "Copiar resultado",
        loading: "Cargando resultado…",
        empty: "No hay resultado disponible.",
        expired:
          "El Workflow terminó, pero el resultado detallado ha caducado y ya no está disponible.",
      },
      executionLogs: {
        title: "Logs",
        refresh: "Actualizar logs",
        copy: "Copiar logs",
        loading: "Cargando logs…",
        empty: "No hay logs disponibles para esta ejecución.",
        expired:
          "El Workflow terminó, pero los logs detallados han caducado y ya no están disponibles.",
      },
      historyDetail: {
        rerun: "Relanzar en el chat",
        timeline: "Cronología",
        created: "Creado",
        started: "Iniciado",
        completed: "Completado",
        duration: "Duración",
        blueprint: "Blueprint",
        loadingBlueprint: "Cargando vista previa del Workflow…",
        noBlueprintPreview: "No hay vista previa del blueprint disponible para esta ejecución.",
        noDescription: "No se proporcionó descripción.",
        noRecipe: "No hay ningún Workflow asociado a esta ejecución.",
        error: "Error",
        notAvailable: "No disponible",
        pending: "Pendiente",
        running: "En curso",
        completedStatus: "Completado",
        failed: "Fallido",
        cancelled: "Cancelado",
        waitingForForm: "Respuesta pendiente",
        unknownStatus: "Desconocido",
        respondToForm: "Responder al formulario",
        resultPartial: "Resultado parcial: el detalle completo ya no está disponible (archivado o expirado).",
        usageTitle: "Resumen de uso",
        usageSourceTrace: "Estimado",
        usageSourceMetering: "Metering",
        usageDuration: "Duración",
        usageTokens: "Tokens",
        usageEstimatedCost: "Coste estimado",
        usageActions: "Acciones",
        usageFailures: "fallos",
        usageLLMCalls: "Llamadas LLM",
        usageMonetaryUnavailable: "Coste monetario final no disponible",
        usageNoData: "No hay resumen de uso disponible.",
        usageModelBreakdown: "Modelos",
      },
      catalog: {
        title: "Catálogo de acciones",
        description: "Elige un Workflow para iniciar una conversación con Maurice",
        searchPlaceholder: "Buscar Workflows...",
        all: "Todas",
        resultsTitle: "Todos los Workflows",
        resultsDescription: "{{count}} Workflow(s) visibles en este Agente.",
        resultsFilteredBy: "Filtrado por {{category}}",
        resultsAllVisible: "Vista completa",
        launchableTitle: "Listas para lanzar",
        launchableDescription: "Estos Workflows ya se pueden usar y pueden abrir una nueva sesión inmediatamente.",
        launchableCount: "{{count}} listas",
        buildRequiredTitle: "Para terminar en Studio",
        buildRequiredDescription: "Estos Workflows ya existen, pero todavía necesitan una pasada por Agent Spec antes de lanzarse.",
        buildRequiredCount: "{{count}} por terminar",
        loading: "Cargando Workflows…",
        error: "Error",
        noRecipes: "No hay Workflows disponibles",
        noRecipesHint: "Crea y aplica un Workflow con Agent Spec para empezar",
        noSearchMatch: "Ningún Workflow coincide con tu búsqueda",
        clearFilters: "Limpiar filtros",
        metricsAvailable: "Workflows",
        metricsAvailableHint: "Disponibles en este Agente",
        metricsVisible: "Visibles",
        metricsVisibleHint: "Coinciden con los filtros actuales",
        surfaceHint: "Explore los Workflows desde una superficie pensada para seguir siendo legible incluso antes del lanzamiento.",
      },
      travail: {
        inboxTitle: "Por tratar",
        inboxDescription:
          "Planes e hilos que esperan una decisión humana. No es otra mensajería.",
        inboxEmpty: "Nada que tratar para este Agente.",
        activityTitle: "Actividad",
        activityDescription:
          "Jobs Agent duraderos, ejecuciones Workflow y closeouts Studio reunidos en un mismo lugar.",
        activityEmpty: "Ninguna actividad reciente para este Agente.",
        openThread: "Abrir el hilo",
        openExecution: "Abrir la ejecución",
        summary: "Resumen",
        trajectory: "Trayectoria",
        evidence: "Pruebas",
        blockedThread: "Hilo bloqueado",
        preparedPlan: "Plan a revisar",
        context: "Contexto",
        closeout: "Closeout Studio",
      },
      history: {
        title: "Historial de ejecuciones",
        description: "Consulta ejecuciones pasadas y sus resultados",
        searchPlaceholder: "Buscar por Workflow o ID de ejecución...",
        all: "Todas",
        metricsTotal: "Total",
        metricsTotalHint: "Ejecuciones cargadas",
        metricsSuccess: "Correctas",
        metricsSuccessHint: "Terminadas sin bloqueo",
        metricsAttention: "Por corregir",
        metricsAttentionHint: "Requieren intervención",
        metricsRerunnable: "Relanzables",
        metricsRerunnableHint: "Pueden volver al chat",
        surfaceHint: "Revisa runs recientes y abre sus detalles sin depender de un panel contextual ya relleno.",
        loading: "Cargando historial...",
        error: "Error",
        noExecutions: "No se encontraron ejecuciones",
        noExecutionsHint: "Inicia una conversación para ver el historial",
        loadMore: "Cargar más",
        pending: "Pendiente",
        running: "En curso",
        completed: "Completado",
        failed: "Fallido",
        cancelled: "Cancelado",
        waitingForForm: "Respuesta pendiente",
        unknownStatus: "Desconocido",
        openDetails: "Abrir detalles",
        respondToForm: "Responder",
        rerun: "Relanzar en el chat",
        executionLabel: "Ejecución",
        startedLabel: "Inicio",
        durationLabel: "Duración",
        usageLabel: "Uso",
        signalLabel: "Señal",
        readinessReview: "Lista para revisión",
        readinessFix: "Por corregir",
        readinessRerunnable: "Relanzable",
        readinessRunning: "Seguimiento activo",
        readinessQueued: "En cola",
        readinessWaitingForm: "Respuesta pendiente",
        readinessUnknown: "Estado desconocido",
        nextStepLabel: "Siguiente paso",
        nextStepRerun: "Abre los detalles y relanza rápido si quieres comparar o empezar de nuevo.",
        nextStepFix: "Inspecciona el error, corrige el Workflow y relánzalo desde el chat.",
        nextStepReview: "Este run fue cancelado: revisa el contexto antes de relanzarlo.",
        nextStepWatch: "Sigue el progreso en detalle o espera a que termine el run.",
        nextStepQueue: "Espera al arranque completo antes de relanzar o intervenir.",
        nextStepRespond: "Responde al formulario para que la ejecución continúe.",
        nextStepUnknown: "Estado no reconocido por la interfaz: revisa el detalle antes de actuar.",
        groupAttentionTitle: "Por corregir",
        groupAttentionDescription: "Estos runs fallaron o se bloquearon y necesitan acción antes de relanzarlos.",
        groupActiveTitle: "En curso",
        groupActiveDescription: "Estos runs siguen avanzando en el runtime y sobre todo requieren seguimiento.",
        groupWaitingTitle: "Respuesta pendiente",
        groupWaitingDescription: "Estos runs esperan una respuesta humana a un formulario antes de continuar.",
        groupQueuedTitle: "En espera",
        groupQueuedDescription: "Estos runs ya existen, pero todavía no han arrancado del todo.",
        groupUnknownTitle: "Estado desconocido",
        groupUnknownDescription: "Estos runs tienen un estado que la interfaz todavía no reconoce.",
        groupSuccessTitle: "Correctas",
        groupSuccessDescription: "Estos runs terminaron, se pueden revisar y a menudo están listos para relanzar.",
        pendingSummary: "Esta ejecución todavía espera un arranque completo.",
        runningSummary: "Esta ejecución sigue avanzando en el runtime.",
        completedSummary: "Este run terminó y está listo para revisión.",
        failedSummary: "Este run falló y necesita una revisión específica.",
        cancelledSummary: "Este run fue cancelado antes de terminar.",
        waitingForFormSummary: "Esta ejecución espera una respuesta a un formulario.",
        unknownSummary: "Estado de ejecución no reconocido por la interfaz.",
      },
      recipeCard: {
        active: "Activa",
        draft: "Borrador",
        noDescription: "No se proporcionó descripción",
        launchNow: "Lanzar ahora",
        openInBuild: "Abrir en Studio",
        inspectBlueprint: "Inspeccionar blueprint",
        launchHint: "Abre directamente una nueva sesión de ejecución.",
        buildHint: "Usa Agent Spec para terminar o aplicar este Workflow.",
        workflow: "Workflow",
        miniapp: "MiniApp",
        moreTags: "+{{count}}",
      },
      filePreview: {
        image: "Imagen",
        document: "Documento",
        file: "Archivo",
        noPreviewUrl: "No hay URL de vista previa disponible para este archivo.",
        loadingPreview: "Cargando vista previa…",
        noInlinePreview: "No hay vista previa integrada disponible para este archivo.",
      },
      commandPalette: {
        title: "Paleta de comandos",
        description: "Busca comandos de la aplicación o pide a Calisto que actúe sobre el Agente actual.",
        placeholder: "Buscar comandos o preguntar a Calisto…",
        noCommands: "No se encontró ningún comando.",
        newThread: "Nuevo hilo",
        newThreadDescription: "Abrir el diálogo de creación de un hilo Studio",
        continueInStudio: "Continuar en Studio",
        continueInStudioDescription: "Retomar desde la revista Application",
        travailInbox: "Por tratar",
        travailInboxDescription: "Abrir la cola de Trabajo",
      },
      build: {
        questionNode: "Pregunta",
        questionMore: "+ {{count}} más — ver configuración",
        questionCriteria: "Criterios",
        questionConfidence: "Confianza mínima",
        networkAllowListBadge: "Seguridad de red",
        networkAllowListTitle: "Acceso de red saliente",
        networkAllowListDescription: "Autoriza explícitamente los endpoints que puede llamar el código Deno de este Agente. Los cambios se aplican a las ejecuciones siguientes.",
        networkAllowListAddTitle: "Autorizar una URL",
        networkAllowListAddDescription: "El host, el protocolo y el puerto efectivo se extraen automáticamente. La ruta y el token nunca se guardan en esta lista.",
        networkAllowListURLLabel: "URL que autorizar",
        networkAllowListURLPlaceholder: "https://devmachine.example.com/callback",
        networkAllowListEntryDescriptionLabel: "Descripción",
        networkAllowListDescriptionPlaceholder: "Callback DevMachine",
        networkAllowListAllow: "Autorizar",
        networkAllowListEntriesTitle: "Endpoints autorizados",
        networkAllowListEntriesDescription: "Estos permisos pertenecen al Agente seleccionado y se inyectan en su sandbox Deno.",
        networkAllowListEmpty: "No hay ningún endpoint externo autorizado.",
        networkAllowListSubdomains: "Subdominios HTTP",
        networkAllowListDelete: "Eliminar autorización",
        networkAllowListSaveSuccess: "Endpoint de red autorizado",
        networkAllowListSaveError: "No se pudo autorizar este endpoint",
        networkAllowListDeleteSuccess: "Autorización de red eliminada",
        networkAllowListDeleteError: "No se pudo eliminar la autorización",
        accessPrimaryCta: "Abrir una vista Configuración disponible",
        accessBackToRun: "Volver a Run",
        accessRecipesTitle: "Acceso Studio limitado",
        accessRecipesDescription: "Esta zona Studio requiere permisos de edición sobre las recetas. Tu rol actual no puede abrir las pantallas de authoring.",
        accessDeployTitle: "Se requiere acceso a Deploy",
        accessDeployDescription: "La página Deploy requiere permisos explícitos del Agente. Abre otra vista Configuración disponible o vuelve a Run.",
        accessExternalControlTitle: "Claves del Agente restringidas",
        accessExternalControlDescription: "Esta zona Configuración requiere permisos explícitos del Agente.",
        source: "Fuente",
        conditionalExpression: "Expresión condicional",
        maxTokens: "Máx. tokens",
        inputLabel: "Entrada",
        outputLabel: "Salida",
        deleteNode: "Eliminar nodo",
        noConditionSet: "Ninguna condición definida",
        trueLabel: "Verdadero",
        falseLabel: "Falso",
        noPromptConfigured: "Ningún prompt configurado",
        noToolsConfigured: "No hay herramientas configuradas",
        moreTools: "+ {{count}} más",
        toolsCount: "{{count}} herramientas",
        recordsCount: "{{count}} registros",
        dataPlaneTitle: "Plano de datos",
        dataCoverageLabel: "Cobertura",
        dataAvailableLabel: "Disponibles",
        dataNeedsSetupLabel: "Por conectar",
        dataStatusReady: "Listo",
        dataStatusLoadError: "Error de carga",
        dataStatusUnknown: "Desconocido",
        dataInventoryStorageLoadError: "Fallo al cargar la configuración de almacenamiento.",
        dataInventoryStorageUnknown: "Backend de almacenamiento aún no determinado.",
        dataInventoryStorageManaged: "Almacenamiento gestionado por la plataforma (AgentMaurice CDN).",
        deployTabSkills: "Skills",
        deployTabInternal: "Interno",
        deployTabVariables: "Variables",
        deployRuntimeLoading: "Cargando configuración runtime…",
        deployRuntimeSkillsPanelDescription: "Gestiona las skills realmente instaladas en el Agente y el catálogo disponible.",
        deployRuntimeSkillsCatalogTitle: "Catálogo de skills",
        deployRuntimeSkillsCatalogDescription: "Instala skills desde el catálogo real expuesto por chatserver.",
        deployRuntimeSkillsSearchPlaceholder: "Buscar skills por nombre, repositorio o tag",
        deployRuntimeSkillsNoCatalog: "No hay skills disponibles",
        deployRuntimeSkillsNoCatalogDescription: "Añade skills al catálogo antes de instalarlas en este Agente.",
        deployRuntimeSkillsInstall: "Instalar",
        deployRuntimeSkillsUninstall: "Desinstalar",
        deployRuntimeSkillsInstalled: "Instaladas runtime",
        deployRuntimeSkillsFilesCount: "{{count}} archivo(s)",
        deployRuntimeSkillsToolsCount: "{{count}} herramienta(s) MCP",
        deployRuntimeSkillsInstallations: "Instalaciones",
        deployRuntimeSkillsInstallationsTitle: "Instalaciones del catálogo",
        deployRuntimeSkillsInstallationsDescription: "Estas líneas vienen de SkillInstallation e indican los paquetes instalados para este Agente.",
        deployRuntimeSkillsNoInstallations: "No hay instalación del catálogo.",
        deployRuntimeSkillsNoInstallationsDescription: "Las instalaciones aparecerán aquí después de añadir una skill desde el catálogo real.",
        deployRuntimeSkillsCatalogCount: "Catálogo",
        deployRuntimeSkillsInstalledTitle: "Estado real del runtime",
        deployRuntimeSkillsInstalledDescription: "Esta lista viene de chatserver y refleja las skills efectivamente disponibles en el Agente.",
        deployRuntimeSkillsNoInstalled: "No hay skill instalada en el runtime.",
        deployRuntimeSkillsNoInstalledDescription: "Instala una skill desde el catálogo real o importa un SKILL.md en este Agente.",
        deployRuntimeSkillsVerified: "Verificada",
        deployRuntimeSkillsInactive: "Inactiva",
        deployRuntimeSkillsNotInstalled: "No instalada",
        deployRuntimeSkillsInstallSuccess: "Skill {{skillName}} instalada en el Agente.",
        deployRuntimeSkillsInstallError: "No se pudo instalar la skill {{skillName}}.",
        deployRuntimeSkillsUninstallSuccess: "Skill {{skillName}} desinstalada del Agente.",
        deployRuntimeSkillsUninstallError: "No se pudo desinstalar la skill {{skillName}}.",
        deployRuntimeSkillsUninstallConfirm: "¿Desinstalar la skill {{skillName}} de este Agente?",
        deployRuntimeSkillsGitHubImportTitle: "Instalar desde GitHub",
        deployRuntimeSkillsGitHubImportDescription: "Pega una URL de repositorio o carpeta GitHub que contenga SKILL.md. Los archivos Markdown de esa carpeta se importan en este Agente.",
        deployRuntimeSkillsGitHubUrlPlaceholder: "https://github.com/owner/repo/tree/main/skills/mi-skill",
        deployRuntimeSkillsGitHubBranchPlaceholder: "Rama (opcional)",
        deployRuntimeSkillsGitHubPathPlaceholder: "Carpeta (opcional)",
        deployRuntimeSkillsGitHubIdPlaceholder: "ID skill (opcional)",
        deployRuntimeSkillsGitHubOverwrite: "Reemplazar si la skill ya existe",
        deployRuntimeSkillsGitHubImport: "Importar",
        deployRuntimeSkillsGitHubImporting: "Importando…",
        deployRuntimeSkillsGitHubUrlRequired: "Introduce una URL GitHub que contenga SKILL.md.",
        deployRuntimeSkillsGitHubImportSuccess: "Skill {{skillName}} importada desde GitHub.",
        deployRuntimeSkillsGitHubImportError: "No se pudo importar esta skill desde GitHub.",
        deployRuntimeSkillsFootnoteTitle: "Cuándo usar skills",
        deployRuntimeSkillsFootnoteDescription: "Usa skills para exponer workflows de build especializados sin sobrecargar las recetas estándar del Agente.",
        agentControlTitle: "Control agent-native",
        agentControlDescription: "Supervisa los accesos de agentes de código, las aprobaciones humanas de Agent Spec y las claves temporales asociadas.",
        agentAccessKindAgent: "Agente de código",
        agentAccessKindCli: "MauriceCLI",
        agentAccessTitle: "Accesos de agentes de código",
        agentAccessDescription: "Enlaces bootstrap emitidos para agentes de código y MauriceCLI. Revocar un enlace también revoca su clave temporal.",
        agentAccessNoActiveLinks: "No hay ningún enlace bootstrap activo.",
        agentAccessRevokedLinks: "Enlaces revocados",
        agentControlSeeAlso: "Vistas relacionadas",
        agentControlOpenAgentSpec: "Plan y aprobación → Agent Spec",
        agentControlOpenObserve: "Apply y verificación → Agent Spec",
        agentDiscoveryBootstrapRevoked: "Acceso del agente revocado",
        agentDiscoveryBootstrapRevokeError: "No se pudo revocar este acceso",
        cliBootstrapRevoked: "Acceso MauriceCLI revocado",
        cliBootstrapRevokeError: "No se pudo revocar este acceso MauriceCLI",
        deployRuntimeApiKeyExpiresAt: "Caduca",
        deployRuntimeInternalDescription: "Prepara los servicios internos del Agente: almacenamiento de artefactos, búsqueda documental, memoria de negocio, multimodal, mensajería y control experto.",
        deployRuntimeUnsavedChanges: "Cambios sin guardar",
        deployRuntimeSavedState: "Guardado",
        deployRuntimeResetDraft: "Descartar cambios",
        deployRuntimeSaving: "Guardando…",
        deployRuntimeStorage: "Storage",
        deployRuntimeCompanyMemory: "Company memory",
        deployRuntimeEnabled: "Activado",
        deployRuntimeDisabled: "Desactivado",
        deployRuntimeStorageCardDescription: "Selecciona dónde el runtime conserva archivos generados, imports, exports y artefactos persistentes. Déjalo desactivado si el Agente no manipula archivos duraderos.",
        deployRuntimeStorageDisabled: "Desactivado",
        deployRuntimeStorageLocalS3: "Almacenamiento S3 local",
        deployRuntimeStorageS3Compatible: "S3 compatible",
        deployRuntimeStorageAgentMauriceCdn: "AgentMaurice CDN",
        deployRuntimeStorageUnavailable: "no disponible",
        deployRuntimeStorageUnavailableMessage: "Este proveedor no está disponible en este runtime. Selecciona almacenamiento local/S3 compatible para guardar.",
        deployRuntimeConfigureS3: "Configurar S3",
        deployRuntimeDocstoreCardDescription: "Añade una capa documental interna para subir, indexar y recuperar archivos en workflows sobre contratos, manuales o bases de conocimiento.",
        deployRuntimeCompanyMemoryCardDescription: "Expone memoria de negocio estructurada a recetas y herramientas para conservar hechos, decisiones y contexto de organización entre sesiones.",
        deployRuntimeBrain: "Brain",
        deployRuntimeBrainCardDescription: "Activa el MCP Brain local para consultar una base DuckDB dedicada cuando un Agente debe razonar sobre datos locales sin servicio externo.",
        deployRuntimeMemory: "Memory",
        deployRuntimeMemoryCardDescription: "Activa el MCP Memory local para guardar notas, estado y recuerdos operativos propios de esta máquina o Agente.",
        deployRuntimeCompanyMemoryReadyDocker: "Company Memory está activo mediante el sidecar Docker de este Agente.",
        deployRuntimeMultimodalCardDescription: "Permite que recetas y chat usen perfiles especializados para analizar imágenes, leer PDF, extraer OCR, transcribir audio o generar medios.",
        deployRuntimeMessagingCardDescription: "Abre el Agente a canales externos como Slack, Telegram, WhatsApp, Discord, Google Chat o Signal, con cuentas ligadas a claves API.",
        accessPageTitle: "Acceso de la Application",
        accessPageDescription:
          "Quién puede abrir esta Application, sus claves de máquina y los endpoints que su runtime puede llamar.",
        accessTabPeople: "Personas",
        accessTabKeys: "Claves",
        accessTabNetwork: "Red",
        accessPeopleHint:
          "Solo estas personas ven la Application en Run. No es un rol de negocio.",
        accessPeopleEmpty: "Nadie tiene acceso a esta Application todavía.",
        accessPeoplePick: "Añadir una persona",
        accessPeopleAdd: "Añadir",
        accessAudienceTitle: "Quién entra en la Application",
        accessAudienceListed: "Personas de la lista",
        accessAudienceListedHint:
          "Solo las personas de la lista siguiente entran en la Application.",
        accessAudienceOrganization: "Todos los miembros de la organización",
        accessAudienceOrganizationHint:
          "Cada miembro de la organización entra, incluidos los que se unan más tarde, además de las personas de la lista.",
        accessAudienceOrganizationNote:
          "Todos los miembros de la organización entran en esta Application: quitar a alguien de la lista no le quita el acceso mientras sea miembro de la organización.",
        accessAudienceConfirmOrganizationTitle: "¿Abrir la Application a todos los miembros?",
        accessAudienceConfirmOrganizationDescription:
          "Cada miembro de la organización, incluidos los que se unan más tarde, podrá entrar en «{{name}}». La lista de personas se conserva, pero quitar a alguien de ella ya no le quitará el acceso mientras sea miembro.",
        accessAudienceConfirmListedTitle: "¿Reservar la Application a las personas de la lista?",
        accessAudienceConfirmListedDescription:
          "Solo las personas de la lista podrán entrar en «{{name}}». Los miembros de la organización que no están en la lista pierden el acceso; nadie se quita de la lista.",
        accessAudienceConfirm: "Confirmar",
        accessAudienceCancel: "Cancelar",
        accessAudienceSaved: "Audiencia de la Application actualizada.",
        accessPeopleHintOrganization:
          "Personas nombradas explícitamente. Conservan el acceso si la Application vuelve a las personas de la lista.",
        applicationAccessDeniedTitle: "Esta Application no te está abierta",
        applicationAccessDeniedDescription:
          "No eres miembro de esta Application. Elige otra en el árbol, o pide acceso a un administrador.",
        accessNetworkNeedsEntrypoint:
          "Elige un Agent de entrada chat en la Revista para configurar la red.",
        selectApplicationFirst: "Elige una Application en el árbol.",
        toolsPageDescription:
          "Servidores MCP y Skills que este Agent puede llamar. Conectores y secretos tienen su propia hoja.",
        channelsPageTitle: "Canales",
        channelsPageDescription:
          "Cuentas de mensajería externas de esta Application, alojadas por el Agent de entrada chat.",
        channelsNeedEntrypoint:
          "Elige un Agent de entrada chat en la Revista para conectar canales.",
        channelsAdvancedTitle: "Pasarelas y runtime avanzado",
        scheduleSelectWorkflow: "Workflow",
        snapshotTitle: "Import / Export de l’Agente",
        snapshotDescription: "Transfiere la configuración de un Agente entre instancias mediante un snapshot cifrado.",
        snapshotExportTitle: "Exportar snapshot",
        snapshotExportDescription: "Genera un archivo JSON cifrado con la configuración del Agente.",
        snapshotImportTitle: "Importar snapshot",
        snapshotImportDescription: "Importa un snapshot JSON creando o sobrescribiendo un Agente.",
        snapshotPassphrase: "Frase secreta",
        snapshotPassphrasePlaceholder: "Introduce una frase secreta fuerte",
        snapshotIncludeRegistryDefinitions: "Incluir definiciones de registry para autocreación durante el import",
        snapshotExportAction: "Exportar snapshot",
        snapshotExportSuccess: "Snapshot exportado.",
        snapshotExportError: "No se pudo exportar el snapshot.",
        snapshotImportFromFile: "Desde archivo",
        snapshotImportFromJson: "Desde JSON",
        snapshotSelectedFile: "Archivo seleccionado",
        snapshotJson: "Snapshot JSON",
        snapshotJsonPlaceholder: "Pega aquí el JSON exportado.",
        snapshotImportMode: "Modo de import",
        snapshotImportCreate: "Crear un nuevo Agente",
        snapshotImportOverwrite: "Sobrescribir un Agente existente",
        snapshotTargetDeployment: "Agente destino",
        snapshotDryRun: "Dry-run sin aplicar",
        snapshotLaunchAfterImport: "Lanzar después del import",
        snapshotRedeployAfterImport: "Redesplegar después del import",
        snapshotAllowRegistryAutoCreate: "Permitir autocreación de registry",
        snapshotDryRunAction: "Probar import",
        snapshotImportAction: "Importar snapshot",
        snapshotImportResult: "Resultado del import",
        snapshotImportDryRunSuccess: "Dry-run terminado.",
        snapshotImportSuccess: "Snapshot importado.",
        snapshotImportError: "No se pudo importar el snapshot.",
        mailCatcherTitle: "Rutas email",
        mailCatcherDescription: "Asocia direcciones inbound a recetas para activar workflows automáticamente por email.",
        mailCatcherDisabledBadge: "No disponible",
        mailCatcherDisabledTitle: "Email inbound desactivado",
        mailCatcherDisabledDescription: "Mail Catcher depende de EmailConnect y permanecerá desactivado hasta que el servicio de pago, las cuotas, la seguridad webhook y el dispatch hacia las VMs estén listos en producción.",
        spacesTitle: "Espacios colaborativos",
        spacesDescription: "Gestiona los espacios ligados al Agente, sus sesiones y colaboración.",
        spacesCreate: "Crear espacio",
        spacesCount: "Espacios",
        spacesMembersCount: "Miembros",
        spacesSessionsCount: "Sesiones",
        spacesNoSpaces: "No hay espacios",
        spacesNoSpacesDescription: "Crea un espacio para organizar sesiones y colaboración del Agente.",
        spacesMembersLabel: "miembro(s)",
        spacesSessionsLabel: "sesión(es)",
        spacesCreatedAt: "Creado",
        spacesCreateTitle: "Crear espacio",
        spacesCreateDescription: "El espacio se asociará al Agente actual.",
        spacesName: "Nombre",
        spacesDescriptionLabel: "Descripción",
        spacesDeleteTitle: "Eliminar espacio",
        spacesDeleteDescription: "El espacio {{name}} y sus sesiones asociadas se eliminarán.",
        spacesCreateSuccess: "Espacio creado.",
        spacesCreateError: "No se pudo crear el espacio.",
        spacesDeleteSuccess: "Espacio eliminado.",
        spacesDeleteError: "No se pudo eliminar el espacio.",
        deployRuntimeMessagingTitle: "Cuentas de mensajería",
        deployRuntimeMessagingDescription: "Conecta canales externos al Agente y asígnalos a una clave API dedicada.",
        deployRuntimeMessagingAddAccount: "Añadir cuenta",
        deployRuntimeMessagingAccountsCount: "Cuentas",
        deployRuntimeMessagingApiKeysAvailable: "Claves API disponibles",
        deployRuntimeMessagingWebhookChannels: "Canales webhook",
        deployRuntimeMessagingNoAccounts: "No hay cuentas de mensajería",
        deployRuntimeMessagingNoAccountsDescription: "Añade al menos un canal si este Agente debe recibir o emitir mensajes de negocio.",
        deployRuntimeMessagingCopyWebhook: "Copiar webhook",
        deployRuntimeMessagingWebhookCopied: "Webhook copiado.",
        deployRuntimeMessagingWebhookCopyError: "No se pudo copiar el webhook.",
        deployRuntimeMessagingEditAccount: "Editar cuenta",
        deployRuntimeMessagingCreateAccount: "Crear cuenta",
        deployRuntimeMessagingDialogDescription: "Configura el canal, la cuenta y los secretos necesarios para este transporte.",
        deployRuntimeMessagingChannel: "Canal",
        deployRuntimeMessagingSelectChannel: "Elegir un canal",
        deployRuntimeMessagingStatus: "Estado",
        deployRuntimeMessagingStatusActive: "Activa",
        deployRuntimeMessagingStatusDisabled: "Desactivada",
        deployRuntimeMessagingStatusInvalid: "Inválida",
        deployRuntimeMessagingAccountId: "ID de cuenta",
        deployRuntimeMessagingDisplayName: "Nombre visible",
        deployRuntimeMessagingDisplayNamePlaceholder: "Bot principal",
        deployRuntimeMessagingExternalId: "ID externo",
        deployRuntimeMessagingExternalIdPlaceholder: "Opcional",
        deployRuntimeMessagingApiKeyLabel: "Clave API",
        deployRuntimeMessagingApiKeyPlaceholder: "Selecciona una clave API",
        deployRuntimeMessagingApiKeyPlaceholderEdit: "Déjalo vacío para conservar la clave actual",
        deployRuntimeMessagingApiKeyHelperEdit: "Selecciona una nueva clave API solo si quieres reemplazar la ya asociada.",
        deployRuntimeMessagingNoExpiration: "Sin caducidad",
        deployRuntimeMessagingConfigSection: "Configuración del canal",
        deployRuntimeMessagingSecretInfo: "Los secretos existentes nunca se rellenan previamente.",
        deployRuntimeMessagingSecretPlaceholder: "Déjalo vacío para conservar el valor actual",
        deployRuntimeMessagingSecretHelperEdit: "Déjalo vacío para conservar el secreto ya almacenado.",
        deployRuntimeMessagingDeleteAccount: "Eliminar cuenta",
        deployRuntimeMessagingDeleteAccountDescription: "La cuenta {{name}} se eliminará del gateway de mensajería.",
        deployRuntimeMessagingChannelRequired: "El canal es obligatorio.",
        deployRuntimeMessagingAccountIdRequired: "El ID de cuenta es obligatorio.",
        deployRuntimeMessagingFieldRequired: "El campo {{field}} es obligatorio.",
        deployRuntimeMessagingApiKeyRequired: "Se requiere una clave API para crear una cuenta de mensajería.",
        deployRuntimeMessagingCreateSuccess: "Cuenta de mensajería creada.",
        deployRuntimeMessagingCreateError: "No se pudo crear la cuenta de mensajería.",
        deployRuntimeMessagingUpdateSuccess: "Cuenta de mensajería actualizada.",
        deployRuntimeMessagingUpdateError: "No se pudo actualizar la cuenta de mensajería.",
        deployRuntimeMessagingDeleteSuccess: "Cuenta de mensajería eliminada.",
        deployRuntimeMessagingDeleteError: "No se pudo eliminar la cuenta de mensajería.",
        deployRuntimeMessagingConnectionWebhook: "Webhook",
        deployRuntimeMessagingConnectionPolling: "Polling",
        deployRuntimeMessagingConnectionWebsocket: "WebSocket",
        deployRuntimeMessagingConfigKeys: "Claves de configuración",
        deployRuntimeMessagingCapabilities: "Funciones interactivas",
        deployRuntimeMessagingRichUI: "Interfaz enriquecida",
        deployRuntimeMessagingRichUIDescription: "Usa las tarjetas, botones y listas nativas disponibles en este canal.",
        deployRuntimeMessagingWorkflowInteractions: "Interacciones de Workflow",
        deployRuntimeMessagingWorkflowInteractionsDescription: "Permite formularios y aprobaciones de Workflow desde esta cuenta.",
        deployRuntimeMessagingRichUIEnabled: "Interfaz enriquecida activa",
        deployRuntimeMessagingRichUIDisabled: "Interfaz enriquecida inactiva",
        deployRuntimeMessagingWorkflowsEnabled: "Workflows activos",
        deployRuntimeMessagingWorkflowsDisabled: "Workflows inactivos",
        deployRuntimeMessagingManageIdentities: "Vínculos",
        deployRuntimeMessagingGenerateLinkCode: "Generar código",
        deployRuntimeMessagingLinkCode: "Código de vinculación",
        deployRuntimeMessagingCopyLinkCode: "Copiar código de vinculación",
        deployRuntimeMessagingLinkCodeCopied: "Código de vinculación copiado.",
        deployRuntimeMessagingLinkCodeCopyError: "No se pudo copiar el código.",
        deployRuntimeMessagingLinkCodeError: "No se pudo generar el código de vinculación.",
        deployRuntimeMessagingLinkCodeExpiresIn: "Caduca en {{seconds}} s",
        deployRuntimeMessagingLinkCodeExpired: "Caducado",
        deployRuntimeMessagingLinkedIdentities: "Identidades vinculadas",
        deployRuntimeMessagingNoIdentities: "No hay identidades vinculadas a esta cuenta.",
        deployRuntimeMessagingIdentitiesError: "No se pudieron cargar las identidades vinculadas.",
        deployRuntimeMessagingLinkedAt: "Vinculada el {{date}}",
        deployRuntimeMessagingRevoke: "Revocar",
        deployRuntimeMessagingRevokeIdentity: "Revocar esta identidad",
        deployRuntimeMessagingIdentityRevoked: "Vínculo revocado.",
        deployRuntimeMessagingIdentityRevokeError: "No se pudo revocar este vínculo.",
        deployRuntimeMessagingChannelTelegram: "Telegram",
        deployRuntimeMessagingChannelSlack: "Slack",
        deployRuntimeMessagingChannelWhatsapp: "WhatsApp",
        deployRuntimeMessagingChannelDiscord: "Discord",
        deployRuntimeMessagingChannelGooglechat: "Google Chat",
        deployRuntimeMessagingChannelSignal: "Signal",
        deployRuntimeMessagingChannelUnknown: "Canal desconocido",
        deployRuntimeMessagingFieldBotToken: "Bot token",
        deployRuntimeMessagingFieldPollInterval: "Intervalo de polling (s)",
        deployRuntimeMessagingFieldAllowedUpdates: "Allowed updates",
        deployRuntimeMessagingFieldSigningSecret: "Signing secret",
        deployRuntimeMessagingFieldBotUserId: "Bot user ID",
        deployRuntimeMessagingFieldAccessToken: "Access token",
        deployRuntimeMessagingFieldPhoneNumberId: "Phone number ID",
        deployRuntimeMessagingFieldAppSecret: "App secret",
        deployRuntimeMessagingFieldVerifyToken: "Verify token",
        deployRuntimeMessagingFieldApiBaseUrl: "API base URL",
        deployRuntimeMessagingFieldApiVersion: "API version",
        deployRuntimeMessagingFieldIntents: "Intents",
        deployRuntimeMessagingFieldVerificationToken: "Verification token",
        deployRuntimeMessagingFieldBaseUrl: "Base URL",
        deployRuntimeMessagingFieldNumber: "Número",
        deployRuntimeMessagingFieldWebhookSecret: "Secreto de firma del webhook",
        deployRuntimeMqttCardDescription: "Expone un puente MQTT para recibir o publicar eventos en tiempo real, útil para IoT, supervisión, automatizaciones de campo y sistemas que ya usan MQTT.",
        deployRuntimeExternalInceptionCardDescription: "Conecta el Agente a una instancia Inception externa para operaciones expertas, inspección del runtime y acciones de administración controladas.",
        deployRuntimeShellCardDescription: "Expone capacidades shell para flujos locales y herramientas expertas.",
        deployRuntimeInternalSaved: "Configuración interna guardada.",
        deployRuntimeInternalSaveError: "No se pudo guardar la configuración interna.",
        deployRuntimeS3DialogDescription: "Completa la conexión S3 usada como storage de este Agente.",
        deployRuntimeS3Endpoint: "Endpoint",
        deployRuntimeS3Region: "Región",
        deployRuntimeS3Bucket: "Bucket",
        deployRuntimeS3AccessKey: "Access key",
        deployRuntimeS3SecretKey: "Secret key",
        deployRuntimeS3Cdn: "URL CDN pública",
        deployRuntimeS3UseSsl: "Usar SSL",
        deployRuntimeS3Required: "El endpoint S3 y el access key son obligatorios.",
        deployRuntimeS3Created: "Configuración S3 creada.",
        deployRuntimeS3CreateError: "No se pudo crear la configuración S3.",
        deployRuntimeS3Updated: "Configuración S3 actualizada.",
        deployRuntimeS3UpdateError: "No se pudo actualizar la configuración S3.",
        deployRuntimeS3Deleted: "Configuración S3 eliminada.",
        deployRuntimeS3DeleteError: "No se pudo eliminar la configuración S3.",
        deployRuntimeMultimodalSaved: "Configuración multimodal guardada.",
        deployRuntimeMultimodalSaveError: "No se pudo guardar la configuración multimodal.",
        deployRuntimeMultimodalDeleted: "Configuración multimodal eliminada.",
        deployRuntimeMultimodalDeleteError: "No se pudo eliminar la configuración multimodal.",
        deployRuntimeMultimodalDefaultsSaved: "Multimodal AgentMaurice activado.",
        deployRuntimeMultimodalDefaultsError: "No se pudo activar el multimodal AgentMaurice.",
        deployRuntimeConfigureMultimodal: "Configurar multimodal",
        deployRuntimeMultimodalDialogDescription: "Activa el modo AgentMaurice gestionado o configura una clave personal.",
        deployRuntimeMultimodalManagedMode: "AgentMaurice gestionado",
        deployRuntimeMultimodalByokMode: "Clave personal",
        deployRuntimeMultimodalManagedTitle: "Multimodal AgentMaurice",
        deployRuntimeMultimodalManagedDescription: "Activa visión, documentos, audio y vídeo sin clave personal. El consumo se factura en créditos AgentMaurice.",
        deployRuntimeMultimodalManagedCapabilities: "Visión, documentos, transcripción de audio y vídeo",
        deployRuntimeMultimodalManagedActivate: "Activar multimodal",
        deployRuntimeMultimodalManagedActivating: "Activando…",
        deployRuntimeMultimodalHostedBadge: "AgentMaurice gestionado",
        deployRuntimeMultimodalByokBadge: "Clave personal",
        deployRuntimeMultimodalBaseUrlInvalid: "La URL base debe ser una URL http(s) válida.",
        deployRuntimeMultimodalExistingConfigs: "Configuraciones existentes",
        deployRuntimeMultimodalAddConfig: "Añadir configuración",
        deployRuntimeMultimodalEditConfig: "Editar configuración",
        deployRuntimeMultimodalFormDescription: "Define una capacidad, un provider y un modelo para este perfil.",
        deployRuntimeMultimodalCapability: "Capacidad",
        deployRuntimeMultimodalProfile: "Perfil",
        deployRuntimeMultimodalProvider: "Provider",
        deployRuntimeMultimodalModel: "Modelo",
        deployRuntimeMultimodalSelectModel: "Seleccionar un modelo",
        deployRuntimeMultimodalNoCompatibleModels: "No se encontraron modelos compatibles para este provider.",
        deployRuntimeMultimodalBaseUrl: "URL base",
        deployRuntimeMultimodalOrgProvider: "Provider LLM de la organización",
        deployRuntimeMultimodalSelectOrgProvider: "Seleccionar un provider",
        deployRuntimeMultimodalNoOrgProviders: "No hay provider de organización compatible con credencial. Decláralo en Build → LLM.",
        deployRuntimeMultimodalOrgProviderRequired: "Se requiere un provider LLM de la organización para multimodal BYOK.",
        deployRuntimeMultimodalModelRequired: "El modelo multimodal es obligatorio.",
        deployRuntimeMultimodalNoConfigs: "Todavía no hay configuración multimodal guardada.",
        deployRuntimeMultimodalDeleteConfig: "Eliminar configuración multimodal",
        deployRuntimeMultimodalDeleteDescription: "La configuración {{capability}} / {{profile}} se eliminará.",
        deployRuntimeVariablesPanelDescription: "Gestiona las variables y secretos inyectados automáticamente durante la ejecución de recetas.",
        deployRuntimeVariablesCount: "Variables",
        deployRuntimeVariableSecretCount: "Secretos",
        deployRuntimeVariableScopedCount: "Con scope",
        deployRuntimeVariableSharedCount: "Globales",
        deployRuntimeVariablesList: "Variables del Agente",
        deployRuntimeVariablesListDescription: "Añade aquí las claves API, credenciales y constantes necesarias para este Agente.",
        deployRuntimeAddVariable: "Añadir variable",
        deployRuntimeNoVariables: "No hay variables configuradas.",
        deployRuntimeNoVariablesDescription: "Las variables permiten almacenar secretos y constantes que se inyectan automáticamente en las recetas.",
        deployRuntimeCreateVariable: "Crear variable",
        deployRuntimeEditVariable: "Editar variable",
        deployRuntimeDeleteVariable: "Eliminar variable",
        deployRuntimeDeleteVariableDescription: "La variable {{name}} se eliminará inmediatamente del Agente.",
        deployRuntimeVariableDialogDescription: "Define el nombre, el valor y el scope de esta variable para el Agente.",
        deployRuntimeVariableName: "Nombre",
        deployRuntimeVariableValue: "Valor",
        deployRuntimeVariableValueOptional: "Déjalo vacío para conservar el valor existente",
        deployRuntimeVariableSecret: "Ocultar el valor como secreto",
        deployRuntimeVariableDescriptionLabel: "Descripción",
        deployRuntimeVariableRecipeScope: "Scope de recetas",
        deployRuntimeVariableRecipeScopeDescription: "Déjalo vacío para compartir la variable con todas las recetas, o selecciona solo las que la necesiten.",
        deployRuntimeVariableAvailableRecipes: "Recetas disponibles",
        deployRuntimeVariableRecipeScopeAll: "Todas las recetas",
        deployRuntimeVariableRecipeScopeEmpty: "Todavía no hay recetas desplegadas. La variable seguirá compartida a nivel del Agente.",
        deployRuntimeVariableNameRequired: "El nombre de la variable es obligatorio.",
        deployRuntimeVariableValueRequired: "El valor de la variable es obligatorio.",
        deployRuntimeVariableCreated: "Variable creada.",
        deployRuntimeVariableCreateError: "No se pudo crear la variable.",
        deployRuntimeVariableUpdated: "Variable actualizada.",
        deployRuntimeVariableUpdateError: "No se pudo actualizar la variable.",
        deployRuntimeVariableDeleted: "Variable eliminada.",
        deployRuntimeVariableDeleteError: "No se pudo eliminar la variable.",
        deployRuntimeVariableAllRecipes: "Todas las recetas",
        deployRuntimeVariableAllRecipesDescription: "Disponible para todas las recetas de este Agente.",
        deployRuntimeVariableScopedRecipes: "Scope limitado",
        deployRuntimeVariableShow: "Mostrar",
        deployRuntimeVariableHide: "Ocultar",
        deployRuntimeVariableSecretBadge: "Secreto",
        deployRuntimeVariableDescription: "Explica brevemente para qué sirve esta variable.",
        deployRuntimeVariablesUsageTitle: "Buenas prácticas",
        deployRuntimeVariablesUsage1: "Reserva los secretos para valores sensibles como claves API y contraseñas.",
        deployRuntimeVariablesUsage2: "Usa el scope de recetas para limitar variables a workflows concretos.",
        deployRuntimeVariablesUsage3: "Prefiere nombres explícitos y estables para facilitar el mantenimiento.",
        deployRuntimeVariablesInjectedDescription: "Estas variables se inyectarán automáticamente en las ejecuciones del Agente.",
        openTasks: "Tareas abiertas",
        timeline: "Cronología",
        artifacts: "Artefactos",
        sourceGraph: "Grafo de fuentes",
        degraded: "Degradado",
        loadingContext: "Cargando contexto…",
        loadingRecipePreview: "Cargando la vista previa de la receta…",
        llmEnableProvider: "Activar",
        llmDisableProvider: "Desactivar",
        llmProviderEnabled: "Proveedor activado",
        llmProviderDisabled: "Proveedor desactivado",
      },
      compose: {
        emptyApplications: "Aún no hay Application. Créela desde el árbol Studio.",
        selectOrganization: "Seleccione una organización.",
        selectApplicationHint: "Elija una Application en el árbol Studio.",
        sectionSurface: "Superficie",
        sectionRun: "Run",
        loadFailed: "No se pudieron cargar las Applications.",
        members: "Miembros (Agentes)",
        noAgents: "Aún no hay Agentes miembros.",
        selectAgent: "Seleccionar un Agente",
        addAgent: "Añadir",
        removeAgent: "Quitar",
        agentAdded: "Agente añadido a la Application.",
        agentAddFailed: "No se pudo añadir el Agente.",
        agentRemoved: "Agente quitado de la Application.",
        agentRemoveFailed: "No se pudo quitar el Agente.",
        chatEntrypoint: "Entrada de chat (opcional)",
        noChatEntrypoint: "Sin chat",
        runLLM: "Modelo usado por esta Application",
        runLLMHint: "Ref portable slug:model (p. ej. hosted:gpt-4o-mini). Vacío = perfil org.run.",
        mcpGrants: "MCP grants (herramientas Run)",
        mcpGrantsHint: "Una herramienta por línea. Vacío = sin restricción adicional.",
        saveRunConfig: "Guardar Run / grants",
        runConfigSaved: "Configuración Run guardada.",
        runConfigSaveFailed: "No se pudo guardar Run / grants.",
        surfaceWorkflows: "Workflows públicos",
        surfaceWorkflowsHint:
          "Marque los Workflows de los Agentes miembros a exponer. Ninguno = nada publicado.",
        surfaceWorkflowsUnavailable: "Ya no está disponible en el Agente",
        surfaceWorkflowsLoadFailed: "No se pudieron cargar los Workflows de los miembros.",
        saveSurface: "Guardar draft",
        publishSurface: "Publicar (semver minor)",
        surfaceSaved: "Superficie guardada.",
        surfaceSaveFailed: "No se pudo guardar la superficie.",
        surfacePublished: "Superficie publicada.",
        surfacePublishFailed: "No se pudo publicar la superficie.",
        publishedVersion: "Versión publicada: {{version}}",
      },
      runContext: {
        title: "Contexto de sesión",
        description: "Memoria de sesión, artefactos recientes y Workflow vinculado a esta conversación.",
        loadingContext: "Cargando el contexto de sesión…",
        activeRecipe: "Workflow activo",
        activeRecipeDescription: "Vista de solo lectura del Workflow actualmente vinculado a esta sesión.",
        loadingRecipe: "Cargando la vista previa del Workflow…",
        notLinked: "Esta conversación aún no está vinculada a un Workflow concreto.",
        openTasks: "Tareas abiertas",
        timeline: "Cronología",
        artifacts: "Artefactos",
        sourceGraph: "Fuentes",
        noOpenTasks: "No hay tareas abiertas visibles para esta sesión.",
        noTimeline: "No hay eventos recientes disponibles para esta sesión.",
        noArtifacts: "No hay artefactos recientes disponibles para esta sesión.",
        noSources: "No hay fuentes vinculadas disponibles para esta sesión.",
        previewTitle: "Vista previa de artefacto",
        previewDescription: "Vista previa rápida de un artefacto producido durante esta sesión.",
        openFile: "Abrir el archivo",
        noPreview: "No hay vista previa integrada disponible.",
      },
    },
  },
} as const;

export type SupportedLanguage = keyof typeof resources;
